<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading"></loading>
        <div v-if="bool_isDDMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 450px;">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["R"]["CSL"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_isDDMV = false">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div v-if="reportType != 'MemberSummary'">
                                        <div class="table-header">
                                            <strong class="">{{getLanguage['WLRPT']['WLRSH']}}</strong>

                                            <div class="pageBtn">
                                                <CButton class="mb-1 btnReset" @click="resetColumn()" v-if="needResetHeaders">
                                                    <span class="font-weight-bold cil-reload"></span>
                                                    {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                                                </CButton>
                                            </div>
                                        </div>

                                        <draggable v-model="reportHeaders" tag="ul" class="p-0 mb-0 sorttable">
                                            <li v-for="header in reportHeaders" :key="header" scope="col" class="list-group-item p-2" :class="[hideElement(header),['BetCount','BetAmount','TurnoverAmount','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL','LTP','Share'].includes(header)?'':'']">
                                                <template v-if="header == 'NO'">
                                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                    {{getLanguage['GL']['NO']}}
                                                </template>
                                                <template v-else-if="header == 'Brand'">
                                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                    {{getLanguage['GL']['AGT']}}
                                                    <i @click="setSortSummaryTable('AGN')" :class="setSummarySortLogo('AGN')" class="sortlogo"></i>
                                                </template>
                                                <template v-else-if="header == 'Currency'">
                                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                    {{getLanguage['MEM']['CI']}}
                                                    <i @click="setSortSummaryTable('ISOC')" :class="setSummarySortLogo('ISOC')" class="sortlogo"></i>
                                                </template>
                                                <template v-else-if="header == 'UserID'">
                                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                    {{getLanguage['MEM']['U']}}
                                                    <i @click="setSortSummaryTable('U')" :class="setSummarySortLogo('U')" class="sortlogo"></i>
                                                </template>
                                                <template v-else-if="header == 'BetCount'">
                                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                    {{getLanguage['BETRPT']['BC']}}
                                                    <i @click="setSortSummaryTable('BC')" :class="setSummarySortLogo('BC')" class="sortlogo"></i>
                                                </template>
                                                <template v-else-if="header == 'BetAmount'">
                                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                    {{getLanguage['BETRPT']['BA']}}
                                                    <i @click="setSortSummaryTable('BA')" :class="setSummarySortLogo('BA')" class="sortlogo"></i>
                                                </template>
                                                <template v-else-if="header == 'TurnoverAmount'">
                                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                    {{getLanguage['BETRPT']['TA']}}
                                                    <i @click="setSortSummaryTable('TA')" :class="setSummarySortLogo('TA')" class="sortlogo"></i>
                                                </template>
                                                <template v-else-if="header == 'MemberWL'">
                                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                    {{getLanguage['BETRPT']['WL']}}
                                                    <i @click="setSortSummaryTable('WLA')" :class="setSummarySortLogo('WLA')" class="sortlogo"></i>
                                                </template>
                                                <template v-else-if="header == 'AWR'">
                                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                    {{getLanguage['BETRPT']['AWR']}}
                                                    <i @click="setSortTable('AWR')" :class="setSortLogo('AWR')" class="sortlogo"></i>
                                                </template>
                                                <template v-else-if="header == 'ProviderWL'">
                                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                    <font v-if="withWE1POKER()">{{getLanguage['WLRPT_WE1']['PWL_RAKE']}}</font>
                                                    <font v-else>{{getLanguage['WLRPT']['PWL']}}</font>
                                                </template>
                                                <template v-else-if="header == 'CompanyWL'">
                                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                    <font v-if="withWE1POKER()">{{getLanguage['WLRPT_WE1']['WWL_RAKE']}}</font>
                                                    <font v-else>{{getLanguage['WLRPT']['WWL']}}<i @click="setSortSummaryTable('WWL')" :class="setSummarySortLogo('WWL')" class="sortlogo"></i></font>
                                                </template>
                                                <template v-else-if="header == 'SMWL' && getUserInfo.AT == 0">
                                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                    <font v-if="withWE1POKER()">{{getLanguage['WLRPT_WE1']['SAWL_RAKE']}}</font>
                                                    <font v-else>{{getLanguage['WLRPT']['SAWL']}}<i @click="setSortSummaryTable('SAWL')" :class="setSummarySortLogo('SAWL')" class="sortlogo"></i></font>
                                                </template>
                                                <template v-else-if="header == 'MAWL' && getUserInfo.AT <= 1">
                                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                    <font v-if="withWE1POKER()">{{getLanguage['WLRPT_WE1']['MAWL_RAKE']}}</font>
                                                    <font v-else>{{getLanguage['WLRPT']['MAWL']}}<i @click="setSortSummaryTable('MAWL')" :class="setSummarySortLogo('MAWL')" class="sortlogo"></i></font>
                                                </template>
                                                <template v-else-if="header == 'AGWL' && getUserInfo.AT <= 2">
                                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                    <font v-if="withWE1POKER()">{{getLanguage['WLRPT_WE1']['AWL_RAKE']}}</font>
                                                    <font v-else>{{getLanguage['WLRPT']['AWL']}}<i @click="setSortSummaryTable('AWL')" :class="setSummarySortLogo('AWL')" class="sortlogo"></i></font>
                                                </template>
                                                <template v-else-if="header == 'LTP'">
                                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                    <font>{{getLanguage['WLRPT_WE1']['LTP']}}</font>
                                                </template>
                                                <template v-else-if="header == 'Share'">
                                                    <i class="fa fa-times" @click="removeColumn(header)" :style="shareIndicator ? 'margin-top: 9px;' : ''"></i>
                                                    <font>{{getLanguage['WLRPT']['S']}}<br>{{ shareIndicator }}</font>
                                                </template>
                                            </li>
                                        </draggable>
                                    </div>

                                    <div v-if="reportType == 'MemberSummary'">
                                        <div class="table-header">
                                            <div class="">
                                                <strong>{{this.memberName}} {{this.getLanguage['WLRPT']['WLR']}}</strong>
                                                <small>({{this.getLanguage['WLRPT']['LRO']}} : {{this.DataLastUpdatedTS}})</small>
                                            </div>
                                            <div class="pageBtn">
                                                <CButton class="btnReset" @click="resetColumn2()" v-if="needResetHeaders2">
                                                    <span class="font-weight-bold cil-reload"></span> {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                                                </CButton>
                                            </div>
                                        </div>

                                        <draggable v-model="reportHeaders2" tag="ul" class="p-0 mb-0 sorttable">
                                            <li v-for="header in reportHeaders2" :key="header" scope="col" class="list-group-item p-2" :class="hideElement(header)">
                                                <template v-if="header == 'NO'">
                                                    <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                                    {{getLanguage['GL']['NO']}}
                                                </template>
                                                <template v-else-if="header == 'Brand'">
                                                    <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                                    {{getLanguage['GL']['AGT']}}
                                                    <i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i>
                                                </template>
                                                <template v-else-if="header == 'UserID'">
                                                    <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                                    {{getLanguage['MEM']['U']}}
                                                    <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                                </template>
                                                <template v-else-if="header == 'GameProvider'">
                                                    <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                                    {{getLanguage['PM']['GPROV']}}
                                                    <i @click="setSortTable('PN')" :class="setSortLogo('PN')"></i>
                                                </template>
                                                <template v-else-if="header == 'BetID'">
                                                    <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                                    {{getLanguage['BETRPT']['BI']}}
                                                    <i @click="setSortTable('TI')" :class="setSortLogo('TI')" class="sortlogo"></i>
                                                </template>
                                                <template v-else-if="header == 'Game'">
                                                    <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                                    {{getLanguage['BETRPT']['G']}}
                                                    <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                                </template>
                                                <template v-else-if="header == 'BalanceBefore'">
                                                    <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                                    {{getLanguage['BETRPT']['BB']}}
                                                    <i @click="setSortTable('BB')" :class="setSortLogo('BB')" class="sortlogo"></i>
                                                </template>
                                                <template v-else-if="header == 'BetAmount'">
                                                    <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                                    {{getLanguage['BETRPT']['BA']}}
                                                    <i @click="setSortTable('BA')" :class="setSortLogo('BA')" class="sortlogo"></i>
                                                </template>
                                                <template v-else-if="header == 'BetTime'">
                                                    <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                                    <font v-if="withTransferWallet()">
                                                        {{getLanguage['BETRPT']['BT']}}<i @click="setSortTable('GTS')" :class="setSortLogo('GTS')" class="sortlogo"></i>
                                                    </font>
                                                    <font v-else>
                                                        {{getLanguage['BETRPT']['BT']}}<i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                                    </font>
                                                </template>
                                                <template v-else-if="header == 'EndTime'">
                                                    <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                                    {{getLanguage['BETRPT']['ET']}}
                                                    <i @click="setSortTable('RTS')" :class="setSortLogo('RTS')" class="sortlogo"></i>
                                                </template>
                                                <template v-else-if="header == 'Currency'">
                                                    <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                                    {{getLanguage['MEM']['CI']}}
                                                    <i @click="setSortTable('ISOC')" :class="setSortLogo('ISOC')" class="sortlogo"></i>
                                                </template>
                                                <template v-else-if="header == 'Turnover'">
                                                    <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                                    {{getLanguage['MEM']['TO']}}
                                                    <i @click="setSortTable('TA')" :class="setSortLogo('TA')" class="sortlogo"></i>
                                                </template>
                                                <template v-else-if="header == 'MemberWL'">
                                                    <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                                    {{getLanguage['BETRPT']['WL']}}
                                                    <i @click="setSortTable('WLA')" :class="setSortLogo('WLA')" class="sortlogo"></i>
                                                </template>
                                                <template v-else-if="header == 'AWR'">
                                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                    {{getLanguage['BETRPT']['AWR']}}
                                                    <i @click="setSortTable('AWR')" :class="setSortLogo('AWR')" class="sortlogo"></i>
                                                </template>
                                                <template v-else-if="header == 'ProviderWL'">
                                                    <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                                    {{getLanguage['WLRPT']['PWL']}}
                                                </template>
                                                <template v-else-if="header == 'CompanyWL'">
                                                    <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                                    {{getLanguage['WLRPT']['WWL']}}
                                                    <i @click="setSortTable('WWL')" :class="setSortLogo('WWL')" class="sortlogo"></i>
                                                </template>
                                                <template v-else-if="header == 'SMWL' && getUserInfo.AT == 0">
                                                    <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                                    {{getLanguage['WLRPT']['SAWL']}}
                                                    <i @click="setSortTable('SAWL')" :class="setSortLogo('SAWL')" class="sortlogo"></i>
                                                </template>
                                                <template v-else-if="header == 'MAWL' && getUserInfo.AT <= 1">
                                                    <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                                    {{getLanguage['WLRPT']['MAWL']}}
                                                    <i @click="setSortTable('MAWL')" :class="setSortLogo('MAWL')" class="sortlogo"></i>
                                                </template>
                                                <template v-else-if="header == 'AGWL' && getUserInfo.AT <= 2">
                                                    <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                                    {{getLanguage['WLRPT']['AWL']}}
                                                    <i @click="setSortTable('AWL')" :class="setSortLogo('AWL')" class="sortlogo"></i>
                                                </template>
                                                <template v-else-if="header == 'Share'">
                                                    <i class="fa fa-times" @click="removeColumn2(header)" :style="shareIndicator ? 'margin-top: 9px;' : ''"></i>
                                                    <font>{{getLanguage['WLRPT']['S']}}<br>{{ shareIndicator }}</font>
                                                </template>
                                                <template v-else-if="header == 'IP'">
                                                    <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                                    {{getLanguage['GL']['IP']}}
                                                    <i @click="setSortTable('MIP')" :class="setSortLogo('MIP')" class="sortlogo"></i>
                                                </template>
                                            </li>
                                        </draggable>
                                    </div>

                                    <div v-if="reportType != 'summary' && reportType != 'MemberSummary' && reportType != null">
                                        <div class="table-header">
                                            <div class="">
                                                <strong>{{this.getProviderName()}} {{this.getLanguage['WLRPT']['WLR']}} </strong>
                                                <small>({{this.getLanguage['WLRPT']['LRO']}} : {{this.DataLastUpdatedTS}})</small>
                                            </div>
                                            <div class="pageBtn">
                                                <CButton class="btnReset" @click="resetColumn1()" v-if="needResetHeaders1">
                                                    <span class="font-weight-bold cil-reload"></span> {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                                                </CButton>
                                            </div>
                                        </div>

                                        <draggable v-model="reportHeaders1" tag="ul" class="p-0 mb-0 sorttable">
                                            <li v-for="header in reportHeaders1" :key="header" class="list-group-item p-2" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']" scope="col">
                                                <span v-if="header == 'NO'">
                                                    <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                                    {{getLanguage['GL']['NO']}}
                                                </span>
                                                <span v-if="header == 'Brand'">
                                                    <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                                    {{getLanguage['GL']['AGT']}}
                                                    <i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i>
                                                </span>
                                                <span v-if="header == 'UserID'">
                                                    <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                                    {{getLanguage['MEM']['U']}}
                                                    <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                                </span>
                                                <span v-if="header == 'BetID'">
                                                    <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                                    {{getLanguage['BETRPT']['BI']}}
                                                    <i @click="setSortTable('TI')" :class="setSortLogo('TI')" class="sortlogo"></i>
                                                </span>
                                                <span v-if="header == 'ProviderName' && withSportsBook()">
                                                    <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                                    {{getLanguage['BETRPT']['GP']}}
                                                </span>
                                                <span v-if="header == 'Game'">
                                                    <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                                    {{getLanguage['BETRPT']['G']}}
                                                    <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                                </span>
                                                <span v-if="header == 'EventInfo' && withSportsBook()">
                                                    <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                                    {{getLanguage['BETRPT']['EI']}}
                                                </span>
                                                <span v-if="header == 'Result'">
                                                    <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                                    <font v-if="withSportsBook()">
                                                        {{getLanguage['WLRPT']['BD']}}
                                                    </font>
                                                    <font v-else>
                                                        {{getLanguage['WLRPT']['R']}}
                                                    </font>
                                                </span>
                                                <span v-if="header == 'BalanceBefore'">
                                                    <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                                    {{getLanguage['BETRPT']['BB']}}
                                                    <i @click="setSortTable('BB')" :class="setSortLogo('BB')" class="sortlogo"></i>
                                                </span>
                                                <span v-if="header == 'BetAmount'">
                                                    <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                                    {{getLanguage['BETRPT']['BA']}}
                                                    <i @click="setSortTable('BA')" :class="setSortLogo('BA')" class="sortlogo"></i>
                                                </span>
                                                <span v-if="header == 'BetTime'">
                                                    <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                                    <font v-if="withTransferWallet()">
                                                        {{getLanguage['BETRPT']['BT']}}<i @click="setSortTable('GTS')" :class="setSortLogo('GTS')" class="sortlogo"></i>
                                                    </font>
                                                    <font v-else>
                                                        {{getLanguage['BETRPT']['BT']}}<i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                                    </font>
                                                </span>
                                                <span v-if="header == 'EndTime'">
                                                    <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                                    {{getLanguage['BETRPT']['ET']}}
                                                    <i @click="setSortTable('RTS')" :class="setSortLogo('RTS')" class="sortlogo"></i>
                                                </span>
                                                <span v-if="header == 'Currency'">
                                                    <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                                    {{getLanguage['MEM']['CI']}}
                                                    <i @click="setSortTable('ISOC')" :class="setSortLogo('ISOC')" class="sortlogo"></i>
                                                </span>
                                                <span v-if="header == 'CurrencyRate' && onlyWE1POKER() && searchGameProviderId.length >= 1 && !searchGameProviderId.includes('55')">
                                                    <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                                    {{getLanguage['CR']['CR']}}
                                                </span>
                                                <span v-if="header == 'Turnover' && searchGameProviderId.length >= 1 && !searchGameProviderId.includes('55')">
                                                    <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                                    <font v-if="withWE1POKER()">{{getLanguage['WLRPT_WE1']['RAKE']}}</font>
                                                    <font v-else>{{getLanguage['MEM']['TO']}}</font>
                                                    <i @click="setSortTable('TA')" :class="setSortLogo('TA')" class="sortlogo"></i>
                                                </span>
                                                <span v-if="header == 'MemberWL' && searchGameProviderId.length >= 1 && !searchGameProviderId.includes('55')">
                                                    <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                                    {{getLanguage['BETRPT']['WL']}}
                                                    <i @click="setSortTable('WLA')" :class="setSortLogo('WLA')" class="sortlogo"></i>
                                                </span>
                                                <template v-if="header == 'AWR' && searchGameProviderId.length >= 1 && !searchGameProviderId.includes('55')">
                                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                    {{getLanguage['BETRPT']['AWR']}}
                                                    <i @click="setSortTable('AWR')" :class="setSortLogo('AWR')" class="sortlogo"></i>
                                                </template>
                                                <span v-if="header == 'Bonus' && withBonus()">
                                                    <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                                    {{getLanguage['WLRPT']['BN']}}
                                                </span>
                                                <span v-if="header == 'Jackpot' && withJackpot()">
                                                    <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                                    {{getLanguage['WLRPT']['JP']}}
                                                </span>
                                                <span v-if="header == 'ProviderWL' && searchGameProviderId.length >= 1 && !searchGameProviderId.includes('55')">
                                                    <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                                    <font v-if="withWE1POKER()">{{getLanguage['WLRPT_WE1']['PWL_RAKE']}}</font>
                                                    <font v-else>{{getLanguage['WLRPT']['PWL']}}</font>
                                                </span>
                                                <span v-if="header == 'CompanyWL' && searchGameProviderId.length >= 1 && !searchGameProviderId.includes('55')">
                                                    <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                                    <font v-if="withWE1POKER()">{{getLanguage['WLRPT_WE1']['WWL_RAKE']}}</font>
                                                    <font v-else>{{getLanguage['WLRPT']['WWL']}}<i @click="setSortTable('WWL')" :class="setSortLogo('WWL')" class="sortlogo"></i></font>
                                                </span>
                                                <span v-if="header == 'SMWL' && getUserInfo.AT == 0 && searchGameProviderId.length >= 1 && !searchGameProviderId.includes('55')">
                                                    <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                                    <font v-if="withWE1POKER()">{{getLanguage['WLRPT_WE1']['SAWL_RAKE']}}</font>
                                                    <font v-else>{{getLanguage['WLRPT']['SAWL']}}<i @click="setSortTable('SAWL')" :class="setSortLogo('SAWL')" class="sortlogo"></i></font>
                                                </span>
                                                <span v-if="header == 'MAWL' && getUserInfo.AT <= 1 && searchGameProviderId.length >= 1 && !searchGameProviderId.includes('55')">
                                                    <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                                    <font v-if="withWE1POKER()">{{getLanguage['WLRPT_WE1']['MAWL_RAKE']}}</font>
                                                    <font v-else>{{getLanguage['WLRPT']['MAWL']}}<i @click="setSortTable('MAWL')" :class="setSortLogo('MAWL')" class="sortlogo"></i></font>
                                                </span>
                                                <span v-if="header == 'AGWL' && getUserInfo.AT <= 2 && searchGameProviderId.length >= 1 && !searchGameProviderId.includes('55')">
                                                    <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                                    <font v-if="withWE1POKER()">{{getLanguage['WLRPT_WE1']['AWL_RAKE']}}</font>
                                                    <font v-else>{{getLanguage['WLRPT']['AWL']}}<i @click="setSortTable('AWL')" :class="setSortLogo('AWL')" class="sortlogo"></i></font>
                                                </span>
                                                <span v-if="header == 'Share' && searchGameProviderId.length >= 1 && !searchGameProviderId.includes('55')">
                                                    <i class="fa fa-times" @click="removeColumn1(header)" :style="shareIndicator ? 'margin-top: 9px;' : ''"></i>
                                                    <font>
                                                        {{getLanguage['WLRPT']['S']}}<br />
                                                        {{ shareIndicator }}
                                                    </font>
                                                </span>
                                                <span v-if="header == 'IP'">
                                                    <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                                    {{getLanguage['GL']['IP']}}
                                                    <i @click="setSortTable('MIP')" :class="setSortLogo('MIP')" class="sortlogo"></i>
                                                </span>
                                            </li>
                                        </draggable>
                                    </div>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class="pageHeader position-relative">
                        <h2 id="titleHeight">{{checkModuleIndex('WINLV2', 'R', constAccessType.view, '', -1)}} {{this.getLanguage['SMB']['WINL']}}</h2>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class="searchBox">
                            <!-- Brand -->
                            <div class="searchCol" v-if="getUserInfo.AT !== 4 && !hideBrand">
                                <span class="searchLabel">{{this.getLanguage['GL']['AGT']}} :</span>
                                <customtreeselect :multiple="true"
                                                  :load-options="loadAgentOptions"
                                                  valueConsistsOf="LEAF_PRIORITY"
                                                  :options="ddAgentList"
                                                  :defaultExpandLevel="Infinity"
                                                  :auto-load-root-options="convertToBool(searchAgent)"
                                                  :disable-branch-nodes="false"
                                                  @input="selectAgentOptions"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  :limit="1"
                                                  :limitText="count => `+${count}`"
                                                  v-model="searchAgent" />
                            </div>
                            <!-- Sub Brand -->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SAGT"]}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :key="rtSubBrand"
                                            :load-options="loadSubBrandOptions"
                                            :cacheOptions="false"
                                            :defaultOptions="ddDefaultSubBrand"
                                            :noResultsText="this.getLanguage['GL']['NRF']"
                                            :options="dd_subagentgroup"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                            v-model="searchSubAgent"
                                            openDirection="below"
                                            :disabled="disableSubDD"
                                            @input="SubAgentGroupChangefs" />
                            </div>
                            <!-- Game Provider -->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["BETRPT"]["GP"]}} :</span>
                                <treeselect :multiple="true"
                                            :load-options="loadGameProviderOptions"
                                            :defaultExpandLevel="1"
                                            valueConsistsOf="LEAF_PRIORITY"
                                            :options="ddGameProviderList"
                                            :auto-load-root-options="true"
                                            @input="selectGameProvider"
                                            :placeholder="this.utilGetDDLanguage('BETRPT.GP')"
                                            v-model="searchGameProviderId"
                                            :limit="1"
                                            :limitText="count => `+${count}`"
                                            class="gp-dropdown" />
                            </div>
                            <!-- Start Date -->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="searchCreatedTS"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :minDate="minStartDate"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="searchCreatedTS.startDate != ''">
                                            <CInput v-if="searchUserId == null" size="sm"
                                                    :value="searchCreatedTS.startDate | moment('DD MMM YYYY')"
                                                    @change="DateTimeChange('SD',$event)" />
                                            <CInput v-else size="sm"
                                                    :value="searchCreatedTS.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <!-- End Date -->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="searchCreatedTS"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="searchCreatedTS.endDate != ''">
                                            <CInput v-if="searchUserId == null" size="sm"
                                                    :value="searchCreatedTS.endDate | moment('DD MMM YYYY')"
                                                    @change="DateTimeChange('ED',$event)" />
                                            <CInput v-else size="sm"
                                                    :value="searchCreatedTS.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <!-- UserID -->
                            <div class="searchCol">
                                <span class="searchLabel">{{this.getLanguage['MEM']['U']}} :</span>
                                <treeselect :key="dd_memberKey"
                                            :multiple="false"
                                            :async="true"
                                            :load-options="loadMemberOptions"
                                            :options="ddMemberList"
                                            :defaultOptions="ddDefaultMemberList"
                                            :auto-load-root-options="convertToBool(searchUserId > 0 && searchUsername)"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('MEM.U')"
                                            @input="selectMemberOptions"
                                            @deselect="deSelectMemberOptions"
                                            :cacheOptions="false"
                                            v-model="searchUserId" />
                            </div>
                            <div class="searchCol" v-if="searchUserId != null">
                                <span class="searchLabel">{{this.getLanguage['WLRPT']['WLT']}} :</span>
                                <treeselect :multiple="false"
                                            :options="ddWinLossTypeList"
                                            :auto-load-root-options="true"
                                            :disable-branch-nodes="true"
                                            :placeholder="this.utilGetDDLanguage('WLRPT.WLT')"
                                            v-model="searchWinLossType" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MT"]["MT"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_userType"
                                            :placeholder="this.utilGetDDLanguage('MT.MT')"
                                            v-model="searchIsTester" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["CTCI"]}} :</span>
                                <treeselect :multiple="false"
                                            :load-options="loadCurrencyOptions"
                                            :options="ddCurrencyList"
                                            :auto-load-root-options="true"
                                            :disable-branch-nodes="true"
                                            :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                            v-model="searchCurrency"
                                            @input="updateCC()" />
                            </div>

                            <div class='searchCol'>
                                <label class=" searchLabel">{{getLanguage["MT"]["VDP"]}} :</label>
                                <treeselect :multiple="false"
                                            :options="arry_vdp"
                                            placeholder
                                            v-model="searchVDP" />
                            </div>

                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['MEM']['RSN']}} :</span>
                                <CInput size="sm"
                                        :value="searchRegisterSourceName"
                                        @change="v => searchRegisterSourceName = v"></CInput>
                            </div>

                            <!--Filter for AFB1188 SPORTS only-->
                            <!--<div class='searchCol' v-if="searchGameProviderId.includes('4', '139')">-->
                            <div class='searchCol' v-if="searchGameProviderId != null && searchGameProviderId.length > 0">
                                <span class='searchLabel'>{{this.getLanguage['BETRPT']['BI']}} :</span>
                                <CInput v-model="searchBetId" size="sm" />
                            </div>
                            <div class='searchCol' v-if="searchGameProviderId.includes('4') || searchGameProviderId.includes('139') || searchGameProviderId.includes('86')">
                                <span class='searchLabel'>{{this.getLanguage['WLRPT']['CASHOUTTICKETS']}}:</span>
                                <treeselect :multiple="false"
                                            :options="arry_cash_out"
                                            placeholder
                                            v-model="searchCashOut" />
                            </div>

                            <!--Filter with UserID  --  Need to Modify this Part-->
                            <div class='searchCol' v-if="searchUserId && shouldShowFreeSpin">
                                <span class='searchLabel'>{{this.getLanguage['BETRPT']['FSB']}} :</span>
                                <treeselect :multiple="false"
                                            :options="arry_free_spin"
                                            placeholder
                                            v-model="searchFreeSpin" />
                            </div>
                        </div>
                        <div class="searchBtnCol">
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" class='searchBtn' ref="search" size="sm" block color="success" @click="newSearch()">
                                <span class='searchIcon cil-search'></span>
                                <span>{{this.getLanguage['BTN']['SR']}}</span>
                            </CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>
            <!-- <div class='table-wrapper' v-if="reportType == 'summary'"> -->
            <!-- Report Summary By Provider -->
            <!--<div class='table-wrapper'  v-if="reportType == 'summary'">-->
            <div class="table-wrapper mb-2" v-if="searchGameProviderId.length >= 1 && (searchGameProviderId.includes('55') || searchGameProviderId.includes('100') || searchGameProviderId.includes('106') || searchGameProviderId.includes('117') || searchGameProviderId.includes('118')|| searchGameProviderId.includes('131')|| searchGameProviderId.includes('132') || searchGameProviderId.includes('105') || searchGameProviderId.includes('124') || searchGameProviderId.includes('125') || searchGameProviderId.includes('115') || searchGameProviderId.includes('127') || searchGameProviderId.includes('128') || searchGameProviderId.includes('159'))">
                <div class="table-header d-flex text-danger font-weight-bold p-0" v-if="searchGameProviderId.includes('55')">{{this.getLanguage["BETRPT"]["PKVD"]}}</div>
                <div class="table-header d-flex text-danger font-weight-bold p-0" v-if="searchGameProviderId.includes('100') || searchGameProviderId.includes('106') || searchGameProviderId.includes('117') || searchGameProviderId.includes('118')|| searchGameProviderId.includes('131')|| searchGameProviderId.includes('132')">{{this.getLanguage["BETRPT"]["MGD"]}}</div>
                <div class="table-header d-flex text-danger font-weight-bold p-0" v-if="searchGameProviderId.includes('105') || searchGameProviderId.includes('124') || searchGameProviderId.includes('125')">{{this.getLanguage["BETRPT"]["P888D"]}}</div>
                <div class="table-header d-flex text-danger font-weight-bold p-0" v-if="searchGameProviderId.includes('115') || searchGameProviderId.includes('127') || searchGameProviderId.includes('128')">{{this.getLanguage["BETRPT"]["K918D"]}}</div>
                <div class="table-header d-flex text-danger font-weight-bold p-0" v-if="searchGameProviderId.includes('159')">{{this.getLanguage["BETRPT"]["W9D"]}}</div>
            </div>

            <div class='table-wrapper with_page' v-if="reportType != 'MemberSummary'">
                <header class="table-header">
                    <strong>{{getLanguage['WLRPT']['WLRSH']}}</strong>
                    <div class="pageBtn">
                        <CButton class="btnReset" @click="bool_isDDMV = true"><span class="fa-solid fa-up-down"></span>{{this.getLanguage['R']['CS']}}</CButton>
                        <CButton class="btnReset" @click="resetColumn()" v-if="needResetHeaders">
                            <span class="font-weight-bold cil-reload"></span>
                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                        </CButton>
                        <CButton v-if="checkModuleAccess2(constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                            <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                            {{this.getLanguage["BTN"]["DL"]}}
                        </CButton>
                        <button @click="ctrPage(+int_Page - 1)" v-if="arr_summary_reportList.length != 1">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" v-if="arr_summary_reportList.length != 1" />
                        <span class="tableItemCount" v-if="arr_summary_reportList.length != 1">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)" v-if="arr_summary_reportList.length != 1">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="my-1">
                    <template v-if="backURL">
                        <span>
                            <router-link :to="{ path: backURL, query: { back: 1 }}">
                                {{this.getLanguage['SMB'][backURL.replace('/R/','')]}}
                            </router-link>
                            <i class="fas fa-caret-right mx-2"></i>
                        </span>
                        <span><span style="cursor: default; pointer-events: none">{{ this.getLanguage["WLRPT"]["WLRSH"] }}</span></span>
                    </template>
                    <template v-else-if="reportType != 'summary' && reportType != 'MemberSummary' && reportType != null">
                        <span>
                            <a href="javascript:void(0)" @click="searchUserId = null;setReportType();getReportList()">
                                {{getLanguage['WLRPT']['WLRSH']}}
                            </a>
                            <i class="fas fa-caret-right mx-2"></i>
                            <a href="javascript:void(0)" @click="searchGameProviderId = [];selectGameProvider();setReportType();getReportList()">
                                {{this.memberName}} {{this.getLanguage['WLRPT']['WLR']}}
                            </a>
                            <i class="fas fa-caret-right mx-2"></i>
                            <span style="cursor: default; pointer-events: none">{{renderProviderName(reportType)}} </span>
                        </span>
                    </template>
                </div>


                <div class="custom-table-wrapper" id="tHead1">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr v-if="searchCurrency!=null && totalReport!=null && arr_summary_reportList.length > 0 && reportType == 'summary'">
                                <th colspan="100%" style="z-index:1 !important">{{this.getLanguage['WLRPT']['T']}} ({{this.getLanguage['LST']['PAGE']}} {{int_Page}})</th>
                            </tr>
                            <tr class="reportTotal2" v-if="totalReport!=null && searchCurrency!=null && arr_summary_reportList.length > 0 && reportType == 'summary'">
                                <td v-for="header in reportHeaders" :key="header" :class="[hideElement(header),['BetCount','BetAmount','TurnoverAmount','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL','LTP'].includes(header)?'tableCtnRight':'']">
                                    <template v-if="header == 'NO'">
                                    </template>
                                    <template v-else-if="header == 'Brand'">
                                    </template>
                                    <template v-else-if="header == 'UserID'">
                                    </template>
                                    <template v-else-if="header == 'Currency'">
                                        {{ totalReport.ISOC }}
                                    </template>
                                    <template v-else-if="header == 'BetCount'">
                                        {{ formatNumber(totalReport.BC, 0) }}
                                    </template>
                                    <template v-else-if="header == 'BetAmount'">
                                        <font v-if="withWE1POKER()">{{ formatNumber(totalReport.BA, 4,totalReport.ISOC, false) }}</font>
                                        <font v-else>{{ formatNumber(totalReport.BA, 2, totalReport.ISOC, false) }}</font>
                                    </template>
                                    <template v-else-if="header == 'TurnoverAmount'">
                                        <font v-if="withWE1POKER()">{{ formatNumber(totalReport.TA, 4,totalReport.ISOC, false) }}</font>
                                        <font v-else>{{ formatNumber(totalReport.TA, 2, totalReport.ISOC, false) }}</font>
                                    </template>
                                    <template v-else-if="header == 'MemberWL'">
                                        <span :class="CheckWinLoss(totalReport.WLA,2,totalReport.WLA)">
                                            <font v-if="withWE1POKER()">{{ formatNumber(totalReport.WLA, 4,totalReport.ISOC, false) }}</font>
                                            <font v-else>{{ formatNumber(totalReport.WLA, 2, totalReport.ISOC, false) }}</font>
                                        </span>
                                    </template>
                                    <template v-else-if="header == 'AWR'">
                                        <span v-if="totalReport.TA > 0" :class="MarginCal(totalReport.WLA,totalReport.TA,totalReport.ISOC) < 0? 'negative-number': 'positive-number'">{{ formatNumber(MarginCal(totalReport.WLA,totalReport.TA,totalReport.ISOC), 2, "") }}%</span>
                                        <span class="" v-else>-</span>
                                    </template>
                                    <template v-else-if="header == 'ProviderWL'">
                                        <span :class="CheckWinLoss(totalReport.WLA,2,totalReport.PWL)">
                                            <span v-if="searchGameProviderId.length >= 1 && searchGameProviderId == 55">0.00</span>
                                            <span v-else>
                                                <font v-if="withWE1POKER()">{{ formatNumber(totalReport.PWL, 4,totalReport.ISOC, false) }}</font>
                                                <font v-else>{{ formatNumber(totalReport.PWL, 2, totalReport.ISOC, false) }}</font>
                                            </span>
                                        </span>
                                    </template>
                                    <template v-else-if="header == 'CompanyWL'">
                                        <span :class="CheckWinLoss(totalReport.WLA,2,totalReport.WWL)">
                                            <span v-if="searchGameProviderId.length >= 1 && searchGameProviderId == 55">0.00</span>
                                            <span v-else>
                                                <font v-if="withWE1POKER()">{{ formatNumber(totalReport.WWL, 4,totalReport.ISOC, false) }}</font>
                                                <font v-else>{{ formatNumber(totalReport.WWL, 2, totalReport.ISOC, false) }}</font>
                                            </span>
                                        </span>
                                    </template>
                                    <template v-else-if="header == 'SMWL' && getUserInfo.AT == 0">
                                        <span :class="CheckWinLoss(totalReport.WLA,2,totalReport.SAWL)">
                                            <span v-if="searchGameProviderId.length >= 1 && searchGameProviderId == 55">0.00</span>
                                            <span v-else>
                                                <font v-if="withWE1POKER()">{{ formatNumber(totalReport.SAWL, 4,totalReport.ISOC, false) }}</font>
                                                <font v-else>{{ formatNumber(totalReport.SAWL, 2, totalReport.ISOC, false) }}</font>
                                            </span>
                                        </span>
                                    </template>
                                    <template v-else-if="header == 'MAWL' && getUserInfo.AT <= 1">
                                        <span :class="CheckWinLoss(totalReport.WLA,2,totalReport.MAWL)">
                                            <span v-if="searchGameProviderId.length >= 1 && searchGameProviderId == 55 ">0.00</span>
                                            <span v-else>
                                                <font v-if="withWE1POKER()">{{ formatNumber(totalReport.MAWL, 4,totalReport.ISOC, false) }}</font>
                                                <font v-else>{{ formatNumber(totalReport.MAWL, 2, totalReport.ISOC, false) }}</font>
                                            </span>
                                        </span>
                                    </template>
                                    <template v-else-if="header == 'AGWL' && getUserInfo.AT <= 2">
                                        <span :class="CheckWinLoss(totalReport.WLA,2,totalReport.AWL)">
                                            <span v-if="searchGameProviderId.length >= 1 && searchGameProviderId == 55">0.00</span>
                                            <span v-else>
                                                <font v-if="withWE1POKER()">{{ formatNumber(totalReport.AWL, 4,totalReport.ISOC, false) }}</font>
                                                <font v-else>{{ formatNumber(totalReport.AWL, 2, totalReport.ISOC, false) }}</font>
                                            </span>
                                        </span>
                                    </template>
                                    <template v-else-if="header == 'LTP' && (searchGameProviderId == 43 || searchGameProviderId == 113)">
                                        <font v-if="withWE1POKER()" :class="getWe1LastTotalPayment(totalReport.LTP, true)">{{ getWe1LastTotalPayment(totalReport.LTP) }}</font>
                                    </template>
                                    <template v-else-if="header == 'Share'">
                                    </template>
                                </td>
                            </tr>
                            <tr v-if="searchCurrency!=null && allTotalReport!=null && arr_summary_reportList.length > 0 && reportType == 'summary'">
                                <th colspan="100%" style="z-index:1 !important">{{getLanguage['WLRPT']['AT']}} ({{this.getLanguage['LST']['APAGE']}})</th>
                            </tr>
                            <tr class="reportTotal2" v-if="allTotalReport!=null && searchCurrency!=null && arr_summary_reportList.length > 0 && reportType == 'summary'">
                                <td v-for="header in reportHeaders" :key="header" :class="[hideElement(header),['BetCount','BetAmount','TurnoverAmount','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                    <template v-if="header == 'NO'">
                                    </template>
                                    <template v-else-if="header == 'Brand'">
                                    </template>
                                    <template v-else-if="header == 'UserID'">
                                    </template>
                                    <template v-else-if="header == 'Currency'">
                                        {{ allTotalReport.ISOC }}
                                    </template>
                                    <template v-else-if="header == 'BetCount'">
                                        {{ formatNumber(allTotalReport.BC, 0) }}
                                    </template>
                                    <template v-else-if="header == 'BetAmount'">
                                        <font v-if="withWE1POKER()">{{ formatNumber(allTotalReport.BA, 4,allTotalReport.ISOC, false) }}</font>
                                        <font v-else>{{ formatNumber(allTotalReport.BA, 2, allTotalReport.ISOC, false) }}</font>
                                    </template>
                                    <template v-else-if="header == 'TurnoverAmount'">
                                        <font v-if="withWE1POKER()">{{ formatNumber(allTotalReport.TA, 4, allTotalReport.ISOC, false) }}</font>
                                        <font v-else>{{ formatNumber(allTotalReport.TA, 2, allTotalReport.ISOC, false) }}</font>
                                    </template>
                                    <template v-else-if="header == 'MemberWL'">
                                        <span :class="CheckWinLoss(allTotalReport.WLA,2,allTotalReport.WLA)">
                                            <font v-if="withWE1POKER()">{{ formatNumber(allTotalReport.WLA, 4,allTotalReport.ISOC, false) }}</font>
                                            <font v-else>{{ formatNumber(allTotalReport.WLA, 2, allTotalReport.ISOC, false) }}</font>
                                        </span>
                                    </template>
                                    <template v-else-if="header == 'AWR'">
                                        <span v-if="allTotalReport.TA > 0" :class="MarginCal(allTotalReport.WLA,allTotalReport.TA,allTotalReport.ISOC) < 0? 'negative-number': 'positive-number'">{{ formatNumber(MarginCal(allTotalReport.WLA,allTotalReport.TA,allTotalReport.ISOC), 2, "") }}%</span>
                                        <span class="" v-else>-</span>
                                    </template>
                                    <template v-else-if="header == 'ProviderWL'">
                                        <span :class="CheckWinLoss(allTotalReport.WLA,2,allTotalReport.PWL)">
                                            <span v-if="searchGameProviderId.length >= 1 && searchGameProviderId == 55">0.00</span>
                                            <span v-else>
                                                <font v-if="withWE1POKER()">{{ formatNumber(allTotalReport.PWL, 4,allTotalReport.ISOC, false) }}</font>
                                                <font v-else>{{ formatNumber(allTotalReport.PWL, 2, allTotalReport.ISOC, false) }}</font>
                                            </span>
                                        </span>
                                    </template>
                                    <template v-else-if="header == 'CompanyWL'">
                                        <span :class="CheckWinLoss(allTotalReport.WLA,2,allTotalReport.WWL)">
                                            <span v-if="searchGameProviderId.length >= 1 && searchGameProviderId == 55">0.00</span>
                                            <span v-else>
                                                <font v-if="withWE1POKER()">{{ formatNumber(allTotalReport.WWL, 4,allTotalReport.ISOC, false) }}</font>
                                                <font v-else>{{ formatNumber(allTotalReport.WWL, 2, allTotalReport.ISOC, false) }}</font>
                                            </span>
                                        </span>
                                    </template>
                                    <template v-else-if="header == 'SMWL' && getUserInfo.AT == 0">
                                        <span :class="CheckWinLoss(allTotalReport.WLA,2,allTotalReport.SAWL)">
                                            <span v-if="searchGameProviderId.length >= 1 && searchGameProviderId == 55">0.00</span>
                                            <span v-else>
                                                <font v-if="withWE1POKER()">{{ formatNumber(allTotalReport.SAWL, 4,allTotalReport.ISOC, false) }}</font>
                                                <font v-else>{{ formatNumber(allTotalReport.SAWL, 2, allTotalReport.ISOC, false) }}</font>
                                            </span>
                                        </span>
                                    </template>
                                    <template v-else-if="header == 'MAWL' && getUserInfo.AT <= 1">
                                        <span :class="CheckWinLoss(allTotalReport.WLA,2,allTotalReport.MAWL)">
                                            <span v-if="searchGameProviderId.length >= 1 && searchGameProviderId == 55">0.00</span>
                                            <span v-else>
                                                <font v-if="withWE1POKER()">{{ formatNumber(allTotalReport.MAWL, 4, allTotalReport.ISOC, false) }}</font>
                                                <font v-else>{{ formatNumber(allTotalReport.MAWL, 2, allTotalReport.ISOC, false) }}</font>
                                            </span>
                                        </span>
                                    </template>
                                    <template v-else-if="header == 'AGWL' && getUserInfo.AT <= 2">
                                        <span :class="CheckWinLoss(allTotalReport.WLA,2,allTotalReport.AWL)">
                                            <span v-if="searchGameProviderId.length >= 1 && searchGameProviderId == 55">0.00</span>
                                            <span v-else>
                                                <font v-if="withWE1POKER()">{{ formatNumber(allTotalReport.AWL, 4, allTotalReport.ISOC, false) }}</font>
                                                <font v-else>{{ formatNumber(allTotalReport.AWL, 2, allTotalReport.ISOC, false) }}</font>
                                            </span>
                                        </span>
                                    </template>
                                    <template v-if="header == 'Share'">
                                    </template>
                                </td>
                            </tr>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col" :class="[hideElement(header),['BetCount','BetAmount','TurnoverAmount','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL','LTP','Share'].includes(header)?'tableCtnRight':'']">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['NO']}}
                                    </template>
                                    <template v-else-if="header == 'Brand'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['AGT']}}
                                        <i @click="setSortSummaryTable('AGN')" :class="setSummarySortLogo('AGN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'Currency'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['CI']}}
                                        <i @click="setSortSummaryTable('ISOC')" :class="setSummarySortLogo('ISOC')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'UserID'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['U']}}
                                        <i @click="setSortSummaryTable('U')" :class="setSummarySortLogo('U')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BetCount'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['BC']}}
                                        <i @click="setSortSummaryTable('BC')" :class="setSummarySortLogo('BC')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BetAmount'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['BA']}}
                                        <i @click="setSortSummaryTable('BA')" :class="setSummarySortLogo('BA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TurnoverAmount'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['TA']}}
                                        <i @click="setSortSummaryTable('TA')" :class="setSummarySortLogo('TA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MemberWL'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['WL']}}
                                        <i @click="setSortSummaryTable('WLA')" :class="setSummarySortLogo('WLA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'AWR'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['AWR']}}
                                        <i @click="setSortSummaryTable('AWR')" :class="setSummarySortLogo('AWR')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'ProviderWL'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        <font v-if="withWE1POKER()">{{getLanguage['WLRPT_WE1']['PWL_RAKE']}}</font>
                                        <font v-else>{{getLanguage['WLRPT']['PWL']}}</font>
                                    </template>
                                    <template v-else-if="header == 'CompanyWL'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        <font v-if="withWE1POKER()">{{getLanguage['WLRPT_WE1']['WWL_RAKE']}}</font>
                                        <font v-else>{{getLanguage['WLRPT']['WWL']}}<i @click="setSortSummaryTable('WWL')" :class="setSummarySortLogo('WWL')" class="sortlogo"></i></font>
                                    </template>
                                    <template v-else-if="header == 'SMWL' && getUserInfo.AT == 0">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        <font v-if="withWE1POKER()">{{getLanguage['WLRPT_WE1']['SAWL_RAKE']}}</font>
                                        <font v-else>{{getLanguage['WLRPT']['SAWL']}}<i @click="setSortSummaryTable('SAWL')" :class="setSummarySortLogo('SAWL')" class="sortlogo"></i></font>
                                    </template>
                                    <template v-else-if="header == 'MAWL' && getUserInfo.AT <= 1">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        <font v-if="withWE1POKER()">{{getLanguage['WLRPT_WE1']['MAWL_RAKE']}}</font>
                                        <font v-else>{{getLanguage['WLRPT']['MAWL']}}<i @click="setSortSummaryTable('MAWL')" :class="setSummarySortLogo('MAWL')" class="sortlogo"></i></font>
                                    </template>
                                    <template v-else-if="header == 'AGWL' && getUserInfo.AT <= 2">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        <font v-if="withWE1POKER()">{{getLanguage['WLRPT_WE1']['AWL_RAKE']}}</font>
                                        <font v-else>{{getLanguage['WLRPT']['AWL']}}<i @click="setSortSummaryTable('AWL')" :class="setSummarySortLogo('AWL')" class="sortlogo"></i></font>
                                    </template>
                                    <template v-else-if="header == 'LTP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        <font>{{getLanguage['WLRPT_WE1']['LTP']}}</font>
                                    </template>
                                    <template v-else-if="header == 'Share'">
                                        <i class="fa fa-times" @click="removeColumn(header)" :style="shareIndicator ? 'margin-top: 9px;' : ''"></i>
                                        <font>{{getLanguage['WLRPT']['S']}}<br>{{ shareIndicator }}</font>
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody1">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr v-if="searchCurrency!=null && totalReport!=null && arr_summary_reportList.length > 0 && reportType == 'summary'">
                                <th colspan="100%" style="z-index:1 !important">{{this.getLanguage['WLRPT']['T']}} ({{this.getLanguage['LST']['PAGE']}} {{int_Page}})</th>
                            </tr>
                            <tr class="reportTotal2" v-if="totalReport!=null && searchCurrency!=null && arr_summary_reportList.length > 0 && reportType == 'summary'">
                                <td v-for="header in reportHeaders" :key="header" :class="[hideElement(header),['BetCount','BetAmount','TurnoverAmount','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL','LTP'].includes(header)?'tableCtnRight':'']">
                                    <template v-if="header == 'NO'">
                                    </template>
                                    <template v-else-if="header == 'Brand'">
                                    </template>
                                    <template v-else-if="header == 'UserID'">
                                    </template>
                                    <template v-else-if="header == 'Currency'">
                                        {{ totalReport.ISOC }}
                                    </template>
                                    <template v-else-if="header == 'BetCount'">
                                        {{ formatNumber(totalReport.BC, 0) }}
                                    </template>
                                    <template v-else-if="header == 'BetAmount'">
                                        <font v-if="withWE1POKER()">{{ formatNumber(totalReport.BA, 4,totalReport.ISOC, false) }}</font>
                                        <font v-else>{{ formatNumber(totalReport.BA, 2, totalReport.ISOC, false) }}</font>
                                    </template>
                                    <template v-else-if="header == 'TurnoverAmount'">
                                        <font v-if="withWE1POKER()">{{ formatNumber(totalReport.TA, 4,totalReport.ISOC, false) }}</font>
                                        <font v-else>{{ formatNumber(totalReport.TA, 2, totalReport.ISOC, false) }}</font>
                                    </template>
                                    <template v-else-if="header == 'MemberWL'">
                                        <span :class="CheckWinLoss(totalReport.WLA,2,totalReport.WLA)">
                                            <font v-if="withWE1POKER()">{{ formatNumber(totalReport.WLA, 4,totalReport.ISOC, false) }}</font>
                                            <font v-else>{{ formatNumber(totalReport.WLA, 2, totalReport.ISOC, false) }}</font>
                                        </span>
                                    </template>
                                    <template v-else-if="header == 'AWR'">
                                        <span v-if="totalReport.TA > 0" :class="MarginCal(totalReport.WLA,totalReport.TA,totalReport.ISOC) < 0? 'negative-number': 'positive-number'">{{ formatNumber(MarginCal(totalReport.WLA,totalReport.TA,totalReport.ISOC), 2, "") }}%</span>
                                        <span class="" v-else>-</span>
                                    </template>
                                    <template v-else-if="header == 'ProviderWL'">
                                        <span :class="CheckWinLoss(totalReport.WLA,2,totalReport.PWL)">
                                            <span v-if="searchGameProviderId.length >= 1 && searchGameProviderId == 55">0.00</span>
                                            <span v-else>
                                                <font v-if="withWE1POKER()">{{ formatNumber(totalReport.PWL, 4,totalReport.ISOC), false }}</font>
                                                <font v-else>{{ formatNumber(totalReport.PWL, 2, totalReport.ISOC, false) }}</font>
                                            </span>
                                        </span>
                                    </template>
                                    <template v-else-if="header == 'CompanyWL'">
                                        <span :class="CheckWinLoss(totalReport.WLA,2,totalReport.WWL)">
                                            <span v-if="searchGameProviderId.length >= 1 && searchGameProviderId == 55">0.00</span>
                                            <span v-else>
                                                <font v-if="withWE1POKER()">{{ formatNumber(totalReport.WWL, 4,totalReport.ISOC, false) }}</font>
                                                <font v-else>{{ formatNumber(totalReport.WWL, 2, totalReport.ISOC, false) }}</font>
                                            </span>
                                        </span>
                                    </template>
                                    <template v-else-if="header == 'SMWL' && getUserInfo.AT == 0">
                                        <span :class="CheckWinLoss(totalReport.WLA,2,totalReport.SAWL)">
                                            <span v-if="searchGameProviderId.length >= 1 && searchGameProviderId == 55">0.00</span>
                                            <span v-else>
                                                <font v-if="withWE1POKER()">{{ formatNumber(totalReport.SAWL, 4,totalReport.ISOC, false) }}</font>
                                                <font v-else>{{ formatNumber(totalReport.SAWL, 2, totalReport.ISOC, false) }}</font>
                                            </span>
                                        </span>
                                    </template>
                                    <template v-else-if="header == 'MAWL' && getUserInfo.AT <= 1">
                                        <span :class="CheckWinLoss(totalReport.WLA,2,totalReport.MAWL)">
                                            <span v-if="searchGameProviderId.length >= 1 && searchGameProviderId == 55 ">0.00</span>
                                            <span v-else>
                                                <font v-if="withWE1POKER()">{{ formatNumber(totalReport.MAWL, 4,totalReport.ISOC, false) }}</font>
                                                <font v-else>{{ formatNumber(totalReport.MAWL, 2, totalReport.ISOC, false) }}</font>
                                            </span>
                                        </span>
                                    </template>
                                    <template v-else-if="header == 'AGWL' && getUserInfo.AT <= 2">
                                        <span :class="CheckWinLoss(totalReport.WLA,2,totalReport.AWL)">
                                            <span v-if="searchGameProviderId.length >= 1 && searchGameProviderId == 55">0.00</span>
                                            <span v-else>
                                                <font v-if="withWE1POKER()">{{ formatNumber(totalReport.AWL, 4,totalReport.ISOC, false) }}</font>
                                                <font v-else>{{ formatNumber(totalReport.AWL, 2, totalReport.ISOC, false) }}</font>
                                            </span>
                                        </span>
                                    </template>
                                    <template v-else-if="header == 'LTP' && (searchGameProviderId == 43 || searchGameProviderId == 113)">
                                        <font v-if="withWE1POKER()" :class="getWe1LastTotalPayment(totalReport.LTP, true)">{{ getWe1LastTotalPayment(totalReport.LTP) }}</font>
                                    </template>
                                    <template v-else-if="header == 'Share'">
                                    </template>
                                </td>
                            </tr>
                            <tr v-if="searchCurrency!=null && allTotalReport!=null && arr_summary_reportList.length > 0 && reportType == 'summary'">
                                <th colspan="100%" style="z-index:1 !important">{{getLanguage['WLRPT']['AT']}} ({{this.getLanguage['LST']['APAGE']}})</th>
                            </tr>
                            <tr class="reportTotal2" v-if="allTotalReport!=null && searchCurrency!=null && arr_summary_reportList.length > 0 && reportType == 'summary'">
                                <td v-for="header in reportHeaders" :key="header" :class="[hideElement(header),['BetCount','BetAmount','TurnoverAmount','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                    <template v-if="header == 'NO'">
                                    </template>
                                    <template v-else-if="header == 'Brand'">
                                    </template>
                                    <template v-else-if="header == 'UserID'">
                                    </template>
                                    <template v-else-if="header == 'Currency'">
                                        {{ allTotalReport.ISOC }}
                                    </template>
                                    <template v-else-if="header == 'BetCount'">
                                        {{ formatNumber(allTotalReport.BC, 0) }}
                                    </template>
                                    <template v-else-if="header == 'BetAmount'">
                                        <font v-if="withWE1POKER()">{{ formatNumber(allTotalReport.BA, 4,allTotalReport.ISOC, false) }}</font>
                                        <font v-else>{{ formatNumber(allTotalReport.BA, 2, allTotalReport.ISOC, false) }}</font>
                                    </template>
                                    <template v-else-if="header == 'TurnoverAmount'">
                                        <font v-if="withWE1POKER()">{{ formatNumber(allTotalReport.TA, 4, allTotalReport.ISOC, false) }}</font>
                                        <font v-else>{{ formatNumber(allTotalReport.TA, 2, allTotalReport.ISOC, false) }}</font>
                                    </template>
                                    <template v-else-if="header == 'MemberWL'">
                                        <span :class="CheckWinLoss(allTotalReport.WLA,2,allTotalReport.WLA)">
                                            <font v-if="withWE1POKER()">{{ formatNumber(allTotalReport.WLA, 4,allTotalReport.ISOC, false) }}</font>
                                            <font v-else>{{ formatNumber(allTotalReport.WLA, 2, allTotalReport.ISOC, false) }}</font>
                                        </span>
                                    </template>
                                    <template v-else-if="header == 'AWR'">
                                        <span v-if="allTotalReport.TA > 0" :class="MarginCal(allTotalReport.WLA,allTotalReport.TA,allTotalReport.ISOC) < 0? 'negative-number': 'positive-number'">{{ formatNumber(MarginCal(allTotalReport.WLA,allTotalReport.TA,allTotalReport.ISOC), 2, "") }}%</span>
                                        <span class="" v-else>-</span>
                                    </template>
                                    <template v-else-if="header == 'ProviderWL'">
                                        <span :class="CheckWinLoss(allTotalReport.WLA,2,allTotalReport.PWL)">
                                            <span v-if="searchGameProviderId.length >= 1 && searchGameProviderId == 55">0.00</span>
                                            <span v-else>
                                                <font v-if="withWE1POKER()">{{ formatNumber(allTotalReport.PWL, 4,allTotalReport.ISOC, false) }}</font>
                                                <font v-else>{{ formatNumber(allTotalReport.PWL, 2, allTotalReport.ISOC, false) }}</font>
                                            </span>
                                        </span>
                                    </template>
                                    <template v-else-if="header == 'CompanyWL'">
                                        <span :class="CheckWinLoss(allTotalReport.WLA,2,allTotalReport.WWL)">
                                            <span v-if="searchGameProviderId.length >= 1 && searchGameProviderId == 55">0.00</span>
                                            <span v-else>
                                                <font v-if="withWE1POKER()">{{ formatNumber(allTotalReport.WWL, 4,allTotalReport.ISOC, false) }}</font>
                                                <font v-else>{{ formatNumber(allTotalReport.WWL, 2, allTotalReport.ISOC, false) }}</font>
                                            </span>
                                        </span>
                                    </template>
                                    <template v-else-if="header == 'SMWL' && getUserInfo.AT == 0">
                                        <span :class="CheckWinLoss(allTotalReport.WLA,2,allTotalReport.SAWL)">
                                            <span v-if="searchGameProviderId.length >= 1 && searchGameProviderId == 55">0.00</span>
                                            <span v-else>
                                                <font v-if="withWE1POKER()">{{ formatNumber(allTotalReport.SAWL, 4,allTotalReport.ISOC, false) }}</font>
                                                <font v-else>{{ formatNumber(allTotalReport.SAWL, 2, allTotalReport.ISOC, false) }}</font>
                                            </span>
                                        </span>
                                    </template>
                                    <template v-else-if="header == 'MAWL' && getUserInfo.AT <= 1">
                                        <span :class="CheckWinLoss(allTotalReport.WLA,2,allTotalReport.MAWL)">
                                            <span v-if="searchGameProviderId.length >= 1 && searchGameProviderId == 55">0.00</span>
                                            <span v-else>
                                                <font v-if="withWE1POKER()">{{ formatNumber(allTotalReport.MAWL, 4, allTotalReport.ISOC, false) }}</font>
                                                <font v-else>{{ formatNumber(allTotalReport.MAWL, 2, allTotalReport.ISOC, false) }}</font>
                                            </span>
                                        </span>
                                    </template>
                                    <template v-else-if="header == 'AGWL' && getUserInfo.AT <= 2">
                                        <span :class="CheckWinLoss(allTotalReport.WLA,2,allTotalReport.AWL)">
                                            <span v-if="searchGameProviderId.length >= 1 && searchGameProviderId == 55">0.00</span>
                                            <span v-else>
                                                <font v-if="withWE1POKER()">{{ formatNumber(allTotalReport.AWL, 4, allTotalReport.ISOC, false) }}</font>
                                                <font v-else>{{ formatNumber(allTotalReport.AWL, 2, allTotalReport.ISOC, false) }}</font>
                                            </span>
                                        </span>
                                    </template>
                                    <template v-if="header == 'Share'">
                                    </template>
                                </td>
                            </tr>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col" :class="[hideElement(header),['BetCount','BetAmount','TurnoverAmount','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL','LTP','Share'].includes(header)?'tableCtnRight':'']">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['NO']}}
                                    </template>
                                    <template v-else-if="header == 'Brand'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['AGT']}}
                                        <i @click="setSortSummaryTable('AGN')" :class="setSummarySortLogo('AGN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'Currency'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['CI']}}
                                        <i @click="setSortSummaryTable('ISOC')" :class="setSummarySortLogo('ISOC')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'UserID'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['U']}}
                                        <i @click="setSortSummaryTable('U')" :class="setSummarySortLogo('U')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BetCount'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['BC']}}
                                        <i @click="setSortSummaryTable('BC')" :class="setSummarySortLogo('BC')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BetAmount'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['BA']}}
                                        <i @click="setSortSummaryTable('BA')" :class="setSummarySortLogo('BA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TurnoverAmount'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['TA']}}
                                        <i @click="setSortSummaryTable('TA')" :class="setSummarySortLogo('TA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MemberWL'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['WL']}}
                                        <i @click="setSortSummaryTable('WLA')" :class="setSummarySortLogo('WLA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'AWR'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['AWR']}}
                                        <i @click="setSortSummaryTable('AWR')" :class="setSummarySortLogo('AWR')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'ProviderWL'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        <font v-if="withWE1POKER()">{{getLanguage['WLRPT_WE1']['PWL_RAKE']}}</font>
                                        <font v-else>{{getLanguage['WLRPT']['PWL']}}</font>
                                    </template>
                                    <template v-else-if="header == 'CompanyWL'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        <font v-if="withWE1POKER()">{{getLanguage['WLRPT_WE1']['WWL_RAKE']}}</font>
                                        <font v-else>{{getLanguage['WLRPT']['WWL']}}<i @click="setSortSummaryTable('WWL')" :class="setSummarySortLogo('WWL')" class="sortlogo"></i></font>
                                    </template>
                                    <template v-else-if="header == 'SMWL' && getUserInfo.AT == 0">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        <font v-if="withWE1POKER()">{{getLanguage['WLRPT_WE1']['SAWL_RAKE']}}</font>
                                        <font v-else>{{getLanguage['WLRPT']['SAWL']}}<i @click="setSortSummaryTable('SAWL')" :class="setSummarySortLogo('SAWL')" class="sortlogo"></i></font>
                                    </template>
                                    <template v-else-if="header == 'MAWL' && getUserInfo.AT <= 1">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        <font v-if="withWE1POKER()">{{getLanguage['WLRPT_WE1']['MAWL_RAKE']}}</font>
                                        <font v-else>{{getLanguage['WLRPT']['MAWL']}}<i @click="setSortSummaryTable('MAWL')" :class="setSummarySortLogo('MAWL')" class="sortlogo"></i></font>
                                    </template>
                                    <template v-else-if="header == 'AGWL' && getUserInfo.AT <= 2">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        <font v-if="withWE1POKER()">{{getLanguage['WLRPT_WE1']['AWL_RAKE']}}</font>
                                        <font v-else>{{getLanguage['WLRPT']['AWL']}}<i @click="setSortSummaryTable('AWL')" :class="setSummarySortLogo('AWL')" class="sortlogo"></i></font>
                                    </template>
                                    <template v-else-if="header == 'LTP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        <font>{{getLanguage['WLRPT_WE1']['LTP']}}</font>
                                    </template>
                                    <template v-else-if="header == 'Share'">
                                        <i class="fa fa-times" @click="removeColumn(header)" :style="shareIndicator ? 'margin-top: 9px;' : ''"></i>
                                        <font>{{getLanguage['WLRPT']['S']}}<br>{{ shareIndicator }}</font>
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if="arr_summary_reportList.length == 0 && searchGameProviderId.length == 0">{{this.getLanguage['GL']['PSGP']}}</td>
                        <td colspan="100%" v-else-if="arr_summary_reportList.length == 0 && searchGameProviderId.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <!--Win Loss Report Summary-->
                        <tr v-for="(data,index) in arr_summary_reportList" :class="data.PTPS == 0 ?  'reportTotal2': ''">
                            <td v-for="header in reportHeaders" :key="header" :class="[hideElement(header),['BetCount','BetAmount','TurnoverAmount','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL','LTP','Share'].includes(header)?'tableCtnRight':'']">
                                <template v-if="header == 'NO'">
                                    {{ CountItem(index+1) }}
                                </template>
                                <template v-else-if="header == 'Brand'">
                                    <span class="grid-line">{{ data.AGN }}</span>
                                    <span class="saggroupname">{{ data.SAGN }}</span>
                                </template>
                                <template v-else-if="header == 'UserID'">
                                    <span v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" @click="CheckingMember(data.AGI,data.MI)">
                                        <div class="custom_tooltip">
                                            <span :style="getbgtooltip(data)" @click="openMemberWinLossDetail(data)">{{data.U}}</span>
                                            <span class="tooltiptext">{{ getLanguage['WLRPT']['VD'] }}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.TW == 0" @click.stop>
                                            <img src="/src/assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["MNM"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.HTWT" @click.stop>
                                            <img src="/src/assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["PVP"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.RP" @click.stop>
                                            <img src="/src/assets/icons/referral.svg" class="referral-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["RFB"]}}</span>
                                        </div>
                                        <div class="float-right pointer ml-1" style="margin-top: -1px;">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                                                <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                            </svg>
                                        </div>
                                    </span>
                                    <span v-else-if="(isSENS == 1 && data.AGI != curAGI)">
                                        <div class="custom_tooltip">
                                            <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                            <span class="tooltiptext">{{ getLanguage['WLRPT']['VD'] }}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.TW == 0">
                                            <img src="/src/assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["MNM"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.HTWT">
                                            <img src="/src/assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["PVP"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.RP">
                                            <img src="/src/assets/icons/referral.svg" class="referral-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["RFB"]}}</span>
                                        </div>
                                        <div class="float-right pointer ml-1" style="margin-top: -1px;">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                                                <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                            </svg>
                                        </div>
                                    </span>
                                </template>
                                <template v-else-if="header == 'Currency'">
                                    {{ data.ISOC }}
                                </template>
                                <template v-else-if="header == 'BetCount'">
                                    {{ formatNumber(data.BC, 0) }}
                                </template>
                                <template v-else-if="header == 'BetAmount'">
                                    <font v-if="withWE1POKER()">{{ formatNumber(data.BA, 4, data.ISOC, false) }}</font>
                                    <font v-else>{{ formatNumber(data.BA, 2, data.ISOC, false) }}</font>
                                </template>
                                <template v-else-if="header == 'TurnoverAmount'">
                                    <font v-if="withWE1POKER()">{{ formatNumber(data.TA, 4, data.ISOC, false) }}</font>
                                    <font v-else>{{ formatNumber(data.TA, 2, data.ISOC, false) }}</font>
                                </template>
                                <template v-else-if="header == 'MemberWL'">
                                    <span :class="CheckWinLoss(data.WLA,2,data.WLA)">
                                        <font v-if="withWE1POKER()">{{ formatNumber(data.WLA, 4, data.ISOC, false) }}</font>
                                        <font v-else>{{ formatNumber(data.WLA, 2, data.ISOC, false) }}</font>
                                    </span>
                                </template>
                                <template v-else-if="header == 'AWR'">
                                    <span v-if="data.TA > 0" :class="MarginCal(data.WLA, data.TA, data.ISOC) < 0? 'negative-number': 'positive-number'">{{ formatNumber(MarginCal(data.WLA, data.TA, data.ISOC), 2, "") }}%</span>
                                    <span class="" v-else>-</span>
                                </template>
                                <template v-else-if="header == 'ProviderWL'">
                                    <span :class="CheckWinLoss(data.WLA,2,data.PWL)">
                                        <span v-if="searchGameProviderId.length >= 1 && searchGameProviderId == 55">0.00</span>
                                        <span v-else>
                                            <font v-if="withWE1POKER()">{{ formatNumber(data.PWL, 4, data.ISOC, false) }}</font>
                                            <font v-else>{{ formatNumber(data.PWL, 2, data.ISOC, false) }}</font>
                                        </span>
                                    </span>
                                </template>
                                <template v-else-if="header == 'CompanyWL'">
                                    <span :class="CheckWinLoss(data.WLA,2,data.WWL)">
                                        <span v-if="searchGameProviderId.length >= 1 && searchGameProviderId == 55">0.00</span>
                                        <span v-else>
                                            <font v-if="withWE1POKER()">{{ formatNumber(data.WWL, 4, data.ISOC, false) }}</font>
                                            <font v-else>{{ formatNumber(data.WWL, 2, data.ISOC, false) }}</font>
                                        </span>
                                    </span>
                                </template>
                                <template v-else-if="header == 'SMWL' && getUserInfo.AT == 0">
                                    <span :class="CheckWinLoss(data.WLA,2,data.SAWL)">
                                        <span v-if="searchGameProviderId.length >= 1 && searchGameProviderId == 55">0.00</span>
                                        <span v-else>
                                            <font v-if="withWE1POKER()">{{ formatNumber(data.SAWL, 4, data.ISOC, false) }}</font>
                                            <font v-else>{{ formatNumber(data.SAWL, 2, data.ISOC, false) }}</font>
                                        </span>
                                    </span>
                                </template>
                                <template v-else-if="header == 'MAWL' && getUserInfo.AT <= 1">
                                    <span :class="CheckWinLoss(data.WLA,2,data.MAWL)">
                                        <span v-if="searchGameProviderId.length >= 1 && searchGameProviderId == 55">0.00</span>
                                        <span v-else>
                                            <font v-if="withWE1POKER()">{{ formatNumber(data.MAWL, 4, data.ISOC, false) }}</font>
                                            <font v-else>{{ formatNumber(data.MAWL, 2, data.ISOC, false) }}</font>
                                        </span>
                                    </span>
                                </template>
                                <template v-else-if="header == 'AGWL' && getUserInfo.AT <= 2">
                                    <span :class="CheckWinLoss(data.WLA,2,data.AWL)">
                                        <span v-if="searchGameProviderId.length >= 1 && searchGameProviderId == 55">0.00</span>
                                        <span v-else>
                                            <font v-if="withWE1POKER()">{{ formatNumber(data.AWL, 4, data.ISOC, false) }}</font>
                                            <font v-else>{{ formatNumber(data.AWL, 2, data.ISOC, false) }}</font>
                                        </span>
                                    </span>
                                </template>
                                <template v-else-if="header == 'LTP'">
                                    <font :class="getWe1LastTotalPayment(data.LTP, true)">
                                        {{ getWe1LastTotalPayment(data.LTP) }}
                                    </font>
                                </template>
                                <template v-else-if="header == 'Share'">
                                    <span v-if="searchGameProviderId.length >= 1 && searchGameProviderId == 55 ">0.00/0.00/0.00/0.00/0.00</span>
                                    <span v-else>
                                        <span :class="data.PTPS == 0 ?  'balanceflash': ''">{{ formatPT(data) }}</span>
                                    </span>
                                </template>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <footer style=" padding: 0.57rem 0rem;" v-if="int_TP >= 2 && arr_summary_reportList.length != 1">
                    <div class="pageBtn">
                        <div>
                            <CButton v-if="checkModuleAccess2(constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                                <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                                {{this.getLanguage["BTN"]["DL"]}}
                            </CButton>
                        </div>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </footer>
            </div>
            <!-- Player All Provider Report -->
            <div class='table-wrapper' v-if="reportType == 'MemberSummary'">
                <header class="table-header">
                    <div>
                        <strong>{{this.memberName}} {{this.getLanguage['WLRPT']['WLR']}}</strong>
                        <small>({{this.getLanguage['WLRPT']['LRO']}} : {{this.DataLastUpdatedTS}})</small>
                    </div>
                    <div class="pageBtn">
                        <CButton class="btnReset" @click="resetColumn2()" v-if="needResetHeaders2">
                            <span class="font-weight-bold cil-reload"></span> {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                        </CButton>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="my-1">
                    <template v-if="backURL">
                        <span>
                            <router-link :to="{ path: backURL, query: { back: 1 }}">
                                {{this.getLanguage['SMB'][backURL.replace('/R/','')]}}
                            </router-link>
                            <i class="fas fa-caret-right mx-2"></i>
                        </span>
                        <span><span style="cursor: default; pointer-events: none">{{ this.getLanguage["WLRPT"]["WLR"] }}</span></span>
                    </template>
                    <template v-else>
                        <span>
                            <a href="javascript:void(0)" @click="searchUserId = null;setReportType();getReportList()">
                                {{getLanguage['WLRPT']['WLRSH']}}
                            </a>
                            <i class="fas fa-caret-right mx-2"></i>
                        </span>
                        <span><span style="cursor: default; pointer-events: none">{{this.memberName}} {{this.getLanguage['WLRPT']['WLR']}}</span></span>
                    </template>
                </div>

                <div class="custom-table-wrapper" id="tHead2">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <template>
                                <tr v-if="searchCurrency!=null && totalReport1!=null && arr_provider_reportList && arr_provider_reportList.length > 0">
                                    <th colspan="100%" style="z-index:1 !important">{{this.getLanguage['WLRPT']['T']}} ({{this.getLanguage['LST']['PAGE']}} {{int_Page}})</th>
                                </tr>
                            </template>
                            <template>
                                <tr class="reportTotal2" v-if="totalReport1!=null && searchCurrency!=null && arr_provider_reportList && arr_provider_reportList.length > 0">
                                    <td v-for="header in reportHeaders2" :key="header" :class="[hideElement(header),['BalanceBefore','BetAmount','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'NO'">
                                        </template>
                                        <template v-else-if="header == 'Brand'">
                                        </template>
                                        <template v-else-if="header == 'UserID'">
                                        </template>
                                        <template v-else-if="header == 'GameProvider'">
                                        </template>
                                        <template v-else-if="header == 'BetID'">
                                        </template>
                                        <template v-else-if="header == 'Game'">
                                        </template>
                                        <template v-else-if="header == 'BalanceBefore'">
                                            {{ formatNumber(totalReport1.TBB, 2, totalReport1.ISOC, false) }}
                                        </template>
                                        <template v-else-if="header == 'BetAmount'">
                                            {{ formatNumber(totalReport1.BA, 2, totalReport1.ISOC, false) }}
                                        </template>
                                        <template v-else-if="header == 'BetTime'">
                                        </template>
                                        <template v-else-if="header == 'EndTime'">
                                        </template>
                                        <template v-else-if="header == 'Currency'">
                                            {{ totalReport1.ISOC }}
                                        </template>
                                        <template v-else-if="header == 'Turnover'">
                                            {{ formatNumber(displayGameResult(totalReport1.TA, totalReport1.RS), 2, totalReport1.ISOC, false) }}
                                        </template>
                                        <template v-else-if="header == 'MemberWL'">
                                            <span :class="CheckWinLoss(totalReport1.WLA,2,totalReport1.WLA)">{{ formatNumber(displayGameResult(totalReport1.WLA, totalReport1.RS), 2, totalReport1.ISOC, false) }}</span>
                                        </template>
                                        <template v-else-if="header == 'AWR'">
                                            <span v-if="totalReport1.TA > 0" :class="MarginCal(totalReport1.WLA,totalReport1.TA,totalReport1.ISOC) < 0? 'negative-number': 'positive-number'">{{ formatNumber(MarginCal(totalReport1.WLA,totalReport1.TA,totalReport1.ISOC), 2, "") }}%</span>
                                            <span class="" v-else>-</span>
                                        </template>
                                        <template v-else-if="header == 'ProviderWL'">
                                            <span :class="CheckWinLoss(totalReport1.WLA,2,totalReport1.PWL)">
                                                <span v-if="totalReport1.GPI == 55">0.00</span>
                                                <span v-else>{{ formatNumber(displayGameResult(totalReport1.PWL, totalReport1.RS), 2, totalReport1.ISOC, false) }}</span>
                                            </span>
                                        </template>
                                        <template v-else-if="header == 'CompanyWL'">
                                            <span :class="CheckWinLoss(totalReport1.WLA,2,totalReport1.WWL)">
                                                <span v-if="totalReport1.GPI == 55">0.00</span>
                                                <span v-else>{{ formatNumber(displayGameResult(totalReport1.WWL, totalReport1.RS), 2, totalReport1.ISOC, false) }}</span>
                                            </span>
                                        </template>
                                        <template v-else-if="header == 'SMWL' && getUserInfo.AT == 0">
                                            <span :class="CheckWinLoss(totalReport1.WLA,2,totalReport1.SAWL)">
                                                <span v-if="totalReport1.GPI == 55">0.00</span>
                                                <span v-else>{{ formatNumber(displayGameResult(totalReport1.SAWL, totalReport1.RS), 2, totalReport1.ISOC, false) }}</span>
                                            </span>
                                        </template>
                                        <template v-else-if="header == 'MAWL' && getUserInfo.AT <= 1">
                                            <span :class="CheckWinLoss(totalReport1.WLA,2,totalReport1.MAWL)">
                                                <span v-if="totalReport1.GPI == 55">0.00</span>
                                                <span v-else>{{ formatNumber(displayGameResult(totalReport1.MAWL, totalReport1.RS), 2, totalReport1.ISOC, false) }}</span>
                                            </span>
                                        </template>
                                        <template v-else-if="header == 'AGWL' && getUserInfo.AT <= 2">
                                            <span :class="CheckWinLoss(totalReport1.WLA,2,totalReport1.AWL)">
                                                <span v-if="totalReport1.GPI == 55">0.00</span>
                                                <span v-else>{{ formatNumber(displayGameResult(totalReport1.AWL, totalReport1.RS), 2, totalReport1.ISOC, false) }}</span>
                                            </span>
                                        </template>
                                        <template v-else-if="header == 'Share'">
                                        </template>
                                        <template v-else-if="header == 'IP'">
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <template>
                                <tr v-if="searchCurrency!=null && allTotalReport1!=null && arr_provider_reportList && arr_provider_reportList.length > 0">
                                    <th colspan="100%" style="z-index:1 !important">{{this.getLanguage['WLRPT']['AT']}} ({{this.getLanguage['LST']['APAGE']}})</th>
                                </tr>
                            </template>
                            <template>
                                <tr class="reportTotal2" v-if="allTotalReport1!=null && searchCurrency!=null && arr_provider_reportList && arr_provider_reportList.length > 0">
                                    <td v-for="header in reportHeaders2" :key="header" :class="[hideElement(header),['BalanceBefore','BetAmount','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'NO'">
                                        </template>
                                        <template v-else-if="header == 'Brand'">
                                        </template>
                                        <template v-else-if="header == 'UserID'">
                                        </template>
                                        <template v-else-if="header == 'GameProvider'">
                                        </template>
                                        <template v-else-if="header == 'BetID'">
                                        </template>
                                        <template v-else-if="header == 'Game'">
                                        </template>
                                        <template v-else-if="header == 'BalanceBefore'">
                                            {{ formatNumber(allTotalReport1.TBB, 2, allTotalReport1.ISOC, false) }}
                                        </template>
                                        <template v-else-if="header == 'BetAmount'">
                                            {{ formatNumber(allTotalReport1.BA, 2, allTotalReport1.ISOC, false) }}
                                        </template>
                                        <template v-else-if="header == 'BetTime'">
                                        </template>
                                        <template v-else-if="header == 'EndTime'">
                                        </template>
                                        <template v-else-if="header == 'Currency'">
                                            {{ allTotalReport1.ISOC }}
                                        </template>
                                        <template v-else-if="header == 'Turnover'">
                                            {{ formatNumber(displayGameResult(allTotalReport1.TA, allTotalReport1.RS), 2, allTotalReport1.ISOC, false) }}
                                        </template>
                                        <template v-else-if="header == 'MemberWL'">
                                            <span :class="CheckWinLoss(allTotalReport1.WLA,2,allTotalReport1.WLA)">{{ formatNumber(displayGameResult(allTotalReport1.WLA, allTotalReport1.RS), 2, allTotalReport1.ISOC, false) }}</span>
                                        </template>
                                        <template v-else-if="header == 'AWR'">
                                            <span v-if="allTotalReport1.TA > 0" :class="MarginCal(allTotalReport1.WLA,allTotalReport1.TA,allTotalReport1.ISOC) < 0? 'negative-number': 'positive-number'">{{ formatNumber(MarginCal(allTotalReport1.WLA,allTotalReport1.TA,allTotalReport1.ISOC), 2, "") }}%</span>
                                            <span class="" v-else>-</span>
                                        </template>
                                        <template v-else-if="header == 'ProviderWL'">
                                            <span :class="CheckWinLoss(allTotalReport1.WLA,2,allTotalReport1.PWL)">
                                                <span v-if="allTotalReport1.GPI == 55">0.00</span>
                                                <span v-else>{{ formatNumber(displayGameResult(allTotalReport1.PWL, allTotalReport1.RS), 2, allTotalReport1.ISOC, false) }}</span>
                                            </span>
                                        </template>
                                        <template v-else-if="header == 'CompanyWL'">
                                            <span :class="CheckWinLoss(allTotalReport1.WLA,2,allTotalReport1.WWL)">
                                                <span v-if="allTotalReport1.GPI == 55">0.00</span>
                                                <span v-else>{{ formatNumber(displayGameResult(allTotalReport1.WWL, allTotalReport1.RS), 2, allTotalReport1.ISOC, false) }}</span>
                                            </span>
                                        </template>
                                        <template v-else-if="header == 'SMWL' && getUserInfo.AT == 0">
                                            <span :class="CheckWinLoss(allTotalReport1.WLA,2,allTotalReport1.SAWL)">
                                                <span v-if="allTotalReport1.GPI == 55">0.00</span>
                                                <span v-else>{{ formatNumber(displayGameResult(allTotalReport1.SAWL, allTotalReport1.RS), 2, allTotalReport1.ISOC, false) }}</span>
                                            </span>
                                        </template>
                                        <template v-else-if="header == 'MAWL' && getUserInfo.AT <= 1">
                                            <span :class="CheckWinLoss(allTotalReport1.WLA,2,allTotalReport1.MAWL)">
                                                <span v-if="allTotalReport1.GPI == 55">0.00</span>
                                                <span v-else>{{ formatNumber(displayGameResult(allTotalReport1.MAWL, allTotalReport1.RS), 2, allTotalReport1.ISOC, false) }}</span>
                                            </span>
                                        </template>
                                        <template v-else-if="header == 'AGWL' && getUserInfo.AT <= 2">
                                            <span :class="CheckWinLoss(allTotalReport1.WLA,2,allTotalReport1.AWL)">
                                                <span v-if="allTotalReport1.GPI == 55">0.00</span>
                                                <span v-else>{{ formatNumber(displayGameResult(allTotalReport1.AWL, allTotalReport1.RS), 2, allTotalReport1.ISOC, false) }}</span>
                                            </span>
                                        </template>
                                        <template v-else-if="header == 'Share'">
                                        </template>
                                        <template v-else-if="header == 'IP'">
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <draggable v-model="reportHeaders2" tag="tr">
                                <th v-for="header in reportHeaders2" :key="header" scope="col" :class="hideElement(header)">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['GL']['NO']}}
                                    </template>
                                    <template v-else-if="header == 'Brand'">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['GL']['AGT']}}
                                        <i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'UserID'">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['MEM']['U']}}
                                        <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'GameProvider'">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['PM']['GPROV']}}
                                        <i @click="setSortTable('PN')" :class="setSortLogo('PN')"></i>
                                    </template>
                                    <template v-else-if="header == 'BetID'">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['BETRPT']['BI']}}
                                        <i @click="setSortTable('TI')" :class="setSortLogo('TI')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'Game'">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['BETRPT']['G']}}
                                        <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BalanceBefore'">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['BETRPT']['BB']}}
                                        <i @click="setSortTable('BB')" :class="setSortLogo('BB')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BetAmount'">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['BETRPT']['BA']}}
                                        <i @click="setSortTable('BA')" :class="setSortLogo('BA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BetTime'">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        <font v-if="withTransferWallet()">
                                            {{getLanguage['BETRPT']['BT']}}<i @click="setSortTable('GTS')" :class="setSortLogo('GTS')" class="sortlogo"></i>
                                        </font>
                                        <font v-else>
                                            {{getLanguage['BETRPT']['BT']}}<i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                        </font>
                                    </template>
                                    <template v-else-if="header == 'EndTime'">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['BETRPT']['ET']}}
                                        <i @click="setSortTable('RTS')" :class="setSortLogo('RTS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'Currency'">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['MEM']['CI']}}
                                        <i @click="setSortTable('ISOC')" :class="setSortLogo('ISOC')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'Turnover'">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['MEM']['TO']}}
                                        <i @click="setSortTable('TA')" :class="setSortLogo('TA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MemberWL'">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['BETRPT']['WL']}}
                                        <i @click="setSortTable('WLA')" :class="setSortLogo('WLA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'AWR'">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['BETRPT']['AWR']}}
                                        <i @click="setSortTable('AWR')" :class="setSortLogo('AWR')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'ProviderWL'">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['WLRPT']['PWL']}}
                                    </template>
                                    <template v-else-if="header == 'CompanyWL'">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['WLRPT']['WWL']}}
                                        <i @click="setSortTable('WWL')" :class="setSortLogo('WWL')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'SMWL' && getUserInfo.AT == 0">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['WLRPT']['SAWL']}}
                                        <i @click="setSortTable('SAWL')" :class="setSortLogo('SAWL')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MAWL' && getUserInfo.AT <= 1">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['WLRPT']['MAWL']}}
                                        <i @click="setSortTable('MAWL')" :class="setSortLogo('MAWL')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'AGWL' && getUserInfo.AT <= 2">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['WLRPT']['AWL']}}
                                        <i @click="setSortTable('AWL')" :class="setSortLogo('AWL')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'Share'">
                                        <i class="fa fa-times" @click="removeColumn2(header)" :style="shareIndicator ? 'margin-top: 9px;' : ''"></i>
                                        <font>{{getLanguage['WLRPT']['S']}}<br>{{ shareIndicator }}</font>
                                    </template>
                                    <template v-else-if="header == 'IP'">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['GL']['IP']}}
                                        <i @click="setSortTable('MIP')" :class="setSortLogo('MIP')" class="sortlogo"></i>
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody2">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <template>
                                <tr v-if="searchCurrency!=null && totalReport1!=null && arr_provider_reportList && arr_provider_reportList.length > 0">
                                    <th colspan="100%" style="z-index:1 !important">{{this.getLanguage['WLRPT']['T']}} ({{this.getLanguage['LST']['PAGE']}} {{int_Page}})</th>
                                </tr>
                            </template>
                            <template>
                                <tr class="reportTotal2" v-if="totalReport1!=null && searchCurrency!=null && arr_provider_reportList && arr_provider_reportList.length > 0">
                                    <td v-for="header in reportHeaders2" :key="header" :class="[hideElement(header),['BalanceBefore','BetAmount','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'NO'">
                                        </template>
                                        <template v-else-if="header == 'Brand'">
                                        </template>
                                        <template v-else-if="header == 'UserID'">
                                        </template>
                                        <template v-else-if="header == 'GameProvider'">
                                        </template>
                                        <template v-else-if="header == 'BetID'">
                                        </template>
                                        <template v-else-if="header == 'Game'">
                                        </template>
                                        <template v-else-if="header == 'BalanceBefore'">
                                            {{ formatNumber(totalReport1.TBB, 2, totalReport1.ISOC, false) }}
                                        </template>
                                        <template v-else-if="header == 'BetAmount'">
                                            {{ formatNumber(totalReport1.BA, 2, totalReport1.ISOC, false) }}
                                        </template>
                                        <template v-else-if="header == 'BetTime'">
                                        </template>
                                        <template v-else-if="header == 'EndTime'">
                                        </template>
                                        <template v-else-if="header == 'Currency'">
                                            {{ totalReport1.ISOC }}
                                        </template>
                                        <template v-else-if="header == 'Turnover'">
                                            {{ formatNumber(displayGameResult(totalReport1.TA, totalReport1.RS), 2, totalReport1.ISOC, false) }}
                                        </template>
                                        <template v-else-if="header == 'MemberWL'">
                                            <span :class="CheckWinLoss(totalReport1.WLA,2,totalReport1.WLA)">{{ formatNumber(displayGameResult(totalReport1.WLA, totalReport1.RS), 2, totalReport1.ISOC, false) }}</span>
                                        </template>
                                        <template v-else-if="header == 'AWR'">
                                            <span v-if="totalReport1.TA > 0" :class="MarginCal(totalReport1.WLA,totalReport1.TA,totalReport1.ISOC) < 0? 'negative-number': 'positive-number'">{{ formatNumber(MarginCal(totalReport1.WLA,totalReport1.TA,totalReport1.ISOC), 2, "") }}%</span>
                                            <span class="" v-else>-</span>
                                        </template>
                                        <template v-else-if="header == 'ProviderWL'">
                                            <span :class="CheckWinLoss(totalReport1.WLA,2,totalReport1.PWL)">
                                                <span v-if="totalReport1.GPI == 55">0.00</span>
                                                <span v-else>{{ formatNumber(displayGameResult(totalReport1.PWL, totalReport1.RS), 2, totalReport1.ISOC, false) }}</span>
                                            </span>
                                        </template>
                                        <template v-else-if="header == 'CompanyWL'">
                                            <span :class="CheckWinLoss(totalReport1.WLA,2,totalReport1.WWL)">
                                                <span v-if="totalReport1.GPI == 55">0.00</span>
                                                <span v-else>{{ formatNumber(displayGameResult(totalReport1.WWL, totalReport1.RS), 2, totalReport1.ISOC, false) }}</span>
                                            </span>
                                        </template>
                                        <template v-else-if="header == 'SMWL' && getUserInfo.AT == 0">
                                            <span :class="CheckWinLoss(totalReport1.WLA,2,totalReport1.SAWL)">
                                                <span v-if="totalReport1.GPI == 55">0.00</span>
                                                <span v-else>{{ formatNumber(displayGameResult(totalReport1.SAWL, totalReport1.RS), 2, totalReport1.ISOC, false) }}</span>
                                            </span>
                                        </template>
                                        <template v-else-if="header == 'MAWL' && getUserInfo.AT <= 1">
                                            <span :class="CheckWinLoss(totalReport1.WLA,2,totalReport1.MAWL)">
                                                <span v-if="totalReport1.GPI == 55">0.00</span>
                                                <span v-else>{{ formatNumber(displayGameResult(totalReport1.MAWL, totalReport1.RS), 2, totalReport1.ISOC, false) }}</span>
                                            </span>
                                        </template>
                                        <template v-else-if="header == 'AGWL' && getUserInfo.AT <= 2">
                                            <span :class="CheckWinLoss(totalReport1.WLA,2,totalReport1.AWL)">
                                                <span v-if="totalReport1.GPI == 55">0.00</span>
                                                <span v-else>{{ formatNumber(displayGameResult(totalReport1.AWL, totalReport1.RS), 2, totalReport1.ISOC, false) }}</span>
                                            </span>
                                        </template>
                                        <template v-else-if="header == 'Share'">
                                        </template>
                                        <template v-else-if="header == 'IP'">
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <template>
                                <template>
                                    <tr v-if="searchCurrency!=null && allTotalReport1!=null && arr_provider_reportList && arr_provider_reportList.length > 0">
                                        <th colspan="100%" style="z-index:1 !important">{{this.getLanguage['WLRPT']['AT']}} ({{this.getLanguage['LST']['APAGE']}})</th>
                                    </tr>
                                </template>
                                <tr class="reportTotal2" v-if="allTotalReport1!=null && searchCurrency!=null && arr_provider_reportList && arr_provider_reportList.length > 0">
                                    <td v-for="header in reportHeaders2" :key="header" :class="[hideElement(header),['BalanceBefore','BetAmount','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'NO'">
                                        </template>
                                        <template v-else-if="header == 'Brand'">
                                        </template>
                                        <template v-else-if="header == 'UserID'">
                                        </template>
                                        <template v-else-if="header == 'GameProvider'">
                                        </template>
                                        <template v-else-if="header == 'BetID'">
                                        </template>
                                        <template v-else-if="header == 'Game'">
                                        </template>
                                        <template v-else-if="header == 'BalanceBefore'">
                                            {{ formatNumber(allTotalReport1.TBB, 2, allTotalReport1.ISOC, false) }}
                                        </template>
                                        <template v-else-if="header == 'BetAmount'">
                                            {{ formatNumber(allTotalReport1.BA, 2, allTotalReport1.ISOC, false) }}
                                        </template>
                                        <template v-else-if="header == 'BetTime'">
                                        </template>
                                        <template v-else-if="header == 'EndTime'">
                                        </template>
                                        <template v-else-if="header == 'Currency'">
                                            {{ allTotalReport1.ISOC }}
                                        </template>
                                        <template v-else-if="header == 'Turnover'">
                                            {{ formatNumber(displayGameResult(allTotalReport1.TA, allTotalReport1.RS), 2, allTotalReport1.ISOC, false) }}
                                        </template>
                                        <template v-else-if="header == 'MemberWL'">
                                            <span :class="CheckWinLoss(allTotalReport1.WLA,2,allTotalReport1.WLA)">{{ formatNumber(displayGameResult(allTotalReport1.WLA, allTotalReport1.RS), 2, allTotalReport1.ISOC, false) }}</span>
                                        </template>
                                        <template v-else-if="header == 'AWR'">
                                            <span v-if="allTotalReport1.TA > 0" :class="MarginCal(allTotalReport1.WLA,allTotalReport1.TA,allTotalReport1.ISOC) < 0? 'negative-number': 'positive-number'">{{ formatNumber(MarginCal(allTotalReport1.WLA,allTotalReport1.TA,allTotalReport1.ISOC), 2, "") }}%</span>
                                            <span class="" v-else>-</span>
                                        </template>
                                        <template v-else-if="header == 'ProviderWL'">
                                            <span :class="CheckWinLoss(allTotalReport1.WLA,2,allTotalReport1.PWL)">
                                                <span v-if="allTotalReport1.GPI == 55">0.00</span>
                                                <span v-else>{{ formatNumber(displayGameResult(allTotalReport1.PWL, allTotalReport1.RS), 2, allTotalReport1.ISOC, false) }}</span>
                                            </span>
                                        </template>
                                        <template v-else-if="header == 'CompanyWL'">
                                            <span :class="CheckWinLoss(allTotalReport1.WLA,2,allTotalReport1.WWL)">
                                                <span v-if="allTotalReport1.GPI == 55">0.00</span>
                                                <span v-else>{{ formatNumber(displayGameResult(allTotalReport1.WWL, allTotalReport1.RS), 2, allTotalReport1.ISOC, false) }}</span>
                                            </span>
                                        </template>
                                        <template v-else-if="header == 'SMWL' && getUserInfo.AT == 0">
                                            <span :class="CheckWinLoss(allTotalReport1.WLA,2,allTotalReport1.SAWL)">
                                                <span v-if="allTotalReport1.GPI == 55">0.00</span>
                                                <span v-else>{{ formatNumber(displayGameResult(allTotalReport1.SAWL, allTotalReport1.RS), 2, allTotalReport1.ISOC, false) }}</span>
                                            </span>
                                        </template>
                                        <template v-else-if="header == 'MAWL' && getUserInfo.AT <= 1">
                                            <span :class="CheckWinLoss(allTotalReport1.WLA,2,allTotalReport1.MAWL)">
                                                <span v-if="allTotalReport1.GPI == 55">0.00</span>
                                                <span v-else>{{ formatNumber(displayGameResult(allTotalReport1.MAWL, allTotalReport1.RS), 2, allTotalReport1.ISOC, false) }}</span>
                                            </span>
                                        </template>
                                        <template v-else-if="header == 'AGWL' && getUserInfo.AT <= 2">
                                            <span :class="CheckWinLoss(allTotalReport1.WLA,2,allTotalReport1.AWL)">
                                                <span v-if="allTotalReport1.GPI == 55">0.00</span>
                                                <span v-else>{{ formatNumber(displayGameResult(allTotalReport1.AWL, allTotalReport1.RS), 2, allTotalReport1.ISOC, false) }}</span>
                                            </span>
                                        </template>
                                        <template v-else-if="header == 'Share'">
                                        </template>
                                        <template v-else-if="header == 'IP'">
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <draggable v-model="reportHeaders2" tag="tr">
                                <th v-for="header in reportHeaders2" :key="header" scope="col" :class="hideElement(header)">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['GL']['NO']}}
                                    </template>
                                    <template v-else-if="header == 'Brand'">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['GL']['AGT']}}
                                        <i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'UserID'">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['MEM']['U']}}
                                        <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'GameProvider'">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['PM']['GPROV']}}
                                        <i @click="setSortTable('PN')" :class="setSortLogo('PN')"></i>
                                    </template>
                                    <template v-else-if="header == 'BetID'">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['BETRPT']['BI']}}
                                        <i @click="setSortTable('TI')" :class="setSortLogo('TI')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'Game'">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['BETRPT']['G']}}
                                        <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BalanceBefore'">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['BETRPT']['BB']}}
                                        <i @click="setSortTable('BB')" :class="setSortLogo('BB')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BetAmount'">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['BETRPT']['BA']}}
                                        <i @click="setSortTable('BA')" :class="setSortLogo('BA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BetTime'">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        <font v-if="withTransferWallet()">
                                            {{getLanguage['BETRPT']['BT']}}<i @click="setSortTable('GTS')" :class="setSortLogo('GTS')" class="sortlogo"></i>
                                        </font>
                                        <font v-else>
                                            {{getLanguage['BETRPT']['BT']}}<i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                        </font>
                                    </template>
                                    <template v-else-if="header == 'EndTime'">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['BETRPT']['ET']}}
                                        <i @click="setSortTable('RTS')" :class="setSortLogo('RTS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'Currency'">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['MEM']['CI']}}
                                        <i @click="setSortTable('ISOC')" :class="setSortLogo('ISOC')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'Turnover'">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['MEM']['TO']}}
                                        <i @click="setSortTable('TA')" :class="setSortLogo('TA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MemberWL'">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['BETRPT']['WL']}}
                                        <i @click="setSortTable('WLA')" :class="setSortLogo('WLA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'AWR'">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['BETRPT']['AWR']}}
                                        <i @click="setSortTable('AWR')" :class="setSortLogo('AWR')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'ProviderWL'">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['WLRPT']['PWL']}}
                                    </template>
                                    <template v-else-if="header == 'CompanyWL'">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['WLRPT']['WWL']}}
                                        <i @click="setSortTable('WWL')" :class="setSortLogo('WWL')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'SMWL' && getUserInfo.AT == 0">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['WLRPT']['SAWL']}}
                                        <i @click="setSortTable('SAWL')" :class="setSortLogo('SAWL')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MAWL' && getUserInfo.AT <= 1">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['WLRPT']['MAWL']}}
                                        <i @click="setSortTable('MAWL')" :class="setSortLogo('MAWL')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'AGWL' && getUserInfo.AT <= 2">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['WLRPT']['AWL']}}
                                        <i @click="setSortTable('AWL')" :class="setSortLogo('AWL')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'Share'">
                                        <i class="fa fa-times" @click="removeColumn2(header)" :style="shareIndicator ? 'margin-top: 9px;' : ''"></i>
                                        <font>{{getLanguage['WLRPT']['S']}}<br>{{ shareIndicator }}</font>
                                    </template>
                                    <template v-else-if="header == 'IP'">
                                        <i class="fa fa-times" @click="removeColumn2(header)"></i>
                                        {{getLanguage['GL']['IP']}}
                                        <i @click="setSortTable('MIP')" :class="setSortLogo('MIP')" class="sortlogo"></i>
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arr_provider_reportList && arr_provider_reportList.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <!--Provider Win Loss Report-->
                        <template v-for="(data,index) in arr_provider_reportList">
                            <tr :class="data.bool_showDetails? 'bd-selected kema-eft':' kema-eft'">
                                <td v-for="header in reportHeaders2" :key="header" :class="[hideElement(header),['BalanceBefore','BetAmount','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                    <template v-if="header == 'NO'">
                                        {{ CountItem(index+1) }}
                                    </template>
                                    <template v-else-if="header == 'Brand'">
                                        <span class="grid-line">{{ data.AGN }}</span>
                                        <span class="saggroupname">{{ data.SAGN }}</span>
                                    </template>
                                    <template v-else-if="header == 'UserID'">
                                        <span v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" @click="CheckingMember(data.AGI,data.MI)">
                                            <div class="custom_tooltip">
                                                <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                                <span v-if="convertToBool(data.TN)" class="tooltiptext tooltip-right" :style="getbgtooltip(data)">{{data.TN}}</span>
                                            </div>
                                            <div class="custom_tooltip" v-if="data.TW == 0">
                                                <img src="/src/assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                                <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["MNM"]}}</span>
                                            </div>
                                            <div class="custom_tooltip" v-if="data.HTWT">
                                                <img src="/src/assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                                <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["PVP"]}}</span>
                                            </div>
                                            <div class="custom_tooltip" v-if="data.RP">
                                                <img src="/src/assets/icons/referral.svg" class="referral-icon" />
                                                <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["RFB"]}}</span>
                                            </div>
                                            <div class="float-right pointer ml-1" style="margin-top: -1px;">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                                                    <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                                </svg>
                                            </div>
                                        </span>
                                        <span v-else-if="(isSENS == 1 && data.AGI != curAGI)">
                                            <div class="custom_tooltip">
                                                <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                                <span v-if="convertToBool(data.TN)" class="tooltiptext tooltip-right" :style="getbgtooltip(data)">{{data.TN}}</span>
                                            </div>
                                            <div class="custom_tooltip" v-if="data.TW == 0">
                                                <img src="/src/assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                                <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["MNM"]}}</span>
                                            </div>
                                            <div class="custom_tooltip" v-if="data.HTWT">
                                                <img src="/src/assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                                <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["PVP"]}}</span>
                                            </div>
                                            <div class="custom_tooltip" v-if="data.RP">
                                                <img src="/src/assets/icons/referral.svg" class="referral-icon" />
                                                <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["RFB"]}}</span>
                                            </div>
                                            <div class="float-right pointer ml-1" style="margin-top: -1px;">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                                                    <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                                </svg>
                                            </div>
                                        </span>
                                    </template>
                                    <template v-else-if="header == 'GameProvider'">
                                        <a href="#" @click="getProviderReport(data)">{{ getProvName(data.GPN) }}</a>
                                    </template>
                                    <template v-else-if="header == 'BetID'">
                                        {{ data.TI }}
                                    </template>
                                    <template v-else-if="header == 'Game'">
                                        {{ getGN(data.GPN, data.GN) }}
                                    </template>
                                    <template v-else-if="header == 'BalanceBefore'">
                                        {{ formatNumber(data.TBB, 2, data.ISOC, false) }}
                                    </template>
                                    <template v-else-if="header == 'BetAmount'">
                                        {{ formatNumber(data.BA, 2, data.ISOC, false) }}
                                    </template>
                                    <template v-else-if="header == 'BetTime'">
                                        {{ formatDateTime(data.GTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss", true) }}
                                    </template>
                                    <template v-else-if="header == 'EndTime'">
                                        {{ generateEndTime(data.RS, data.GET, data.RTS) }}
                                    </template>
                                    <template v-else-if="header == 'Currency'">
                                        {{ data.ISOC }}
                                    </template>
                                    <template v-else-if="header == 'Turnover'">
                                        {{ formatNumber(displayGameResult(data.TA, data.RS), 2, data.ISOC, false) }}
                                    </template>
                                    <template v-else-if="header == 'MemberWL'">
                                        <span :class="CheckWinLoss(data.WLA,data.RS,data.WLA)">{{ formatNumber(displayGameResult(data.WLA, data.RS), 2, data.ISOC, false) }}</span>
                                    </template>
                                    <template v-else-if="header == 'AWR'">
                                        <span v-if="data.TA > 0" :class="MarginCal(data.WLA,data.TA, data.ISOC) < 0? 'negative-number': 'positive-number'">{{ formatNumber(MarginCal(data.WLA,data.TA, data.ISOC), 2, "") }}%</span>
                                        <span class="" v-else>-</span>
                                    </template>
                                    <template v-else-if="header == 'ProviderWL'">
                                        <span :class="CheckWinLoss(data.WLA,data.RS,data.PWL)">
                                            <span v-if="data.GPI == 55">0.00</span>
                                            <span v-else>{{ formatNumber(displayGameResult(data.PWL, data.RS), 2, data.ISOC, false) }}</span>
                                        </span>
                                    </template>
                                    <template v-else-if="header == 'CompanyWL'">
                                        <span :class="CheckWinLoss(data.WLA,data.RS,data.WWL)">
                                            <span v-if="data.GPI == 55">0.00</span>
                                            <span v-else>{{ formatNumber(displayGameResult(data.WWL, data.RS), 2, data.ISOC, false) }}</span>
                                        </span>
                                    </template>
                                    <template v-else-if="header == 'SMWL' && getUserInfo.AT == 0">
                                        <span :class="CheckWinLoss(data.WLA,data.RS,data.SAWL)">
                                            <span v-if="data.GPI == 55">0.00</span>
                                            <span v-else>{{ formatNumber(displayGameResult(data.SAWL, data.RS), 2, data.ISOC, false) }}</span>
                                        </span>
                                    </template>
                                    <template v-else-if="header == 'MAWL' && getUserInfo.AT <= 1">
                                        <span :class="CheckWinLoss(data.WLA,data.RS,data.MAWL)">
                                            <span v-if="data.GPI == 55">0.00</span>
                                            <span v-else>{{ formatNumber(displayGameResult(data.MAWL, data.RS), 2, data.ISOC, false) }}</span>
                                        </span>
                                    </template>
                                    <template v-else-if="header == 'AGWL' && getUserInfo.AT <= 2">
                                        <span :class="CheckWinLoss(data.WLA,data.RS,data.AWL)">
                                            <span v-if="data.GPI == 55">0.00</span>
                                            <span v-else>{{ formatNumber(displayGameResult(data.AWL, data.RS), 2, data.ISOC, false) }}</span>
                                        </span>
                                    </template>
                                    <template v-else-if="header == 'Share'">
                                        <span v-if="data.D != ''">-</span>
                                        <span v-else-if="data.GPI == 55">0.00/0.00/0.00/0.00/0.00</span>
                                        <span v-else>
                                            <span :class="data.PTPS == 0 ?  'balanceflash': ''">{{ formatPT(data) }}</span>
                                        </span>
                                    </template>
                                    <template v-else-if="header == 'IP'">
                                        {{ data.MIP }}
                                    </template>
                                </td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>

                <footer style=" padding: 0.57rem 0rem;" v-if="int_TP >= 2">
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </footer>
            </div>
            <!-- Player All Provider Report End -->

            <div class='table-wrapper' v-if="reportType != 'summary' && reportType != 'MemberSummary' && reportType != null">
                <header class="table-header">
                    <div>
                        <strong>{{this.getProviderName()}} {{this.getLanguage['WLRPT']['WLR']}} </strong>
                        <small>({{this.getLanguage['WLRPT']['LRO']}} : {{this.DataLastUpdatedTS}})</small>
                        <div v-if="(
                         reportType=='YGGDRASIL' ||
                         reportType=='YGGDRASIL_E_CASINO' ||
                         reportType=='PNG_SLOT' ||
                         reportType=='AUX_SLOT' ||
                         reportType=='GHG_SLOT' ||
                         reportType=='NLC_SLOT' ||
                         reportType=='RELAX_SLOT' ||
                         reportType=='RELAX_E_CASINO' ||
                         reportType=='HACKSAW_SLOT')" class="custom_tooltip">
                            <i class="fa fa-question-circle"></i>
                            <span class="tooltiptext" style="background-color: black;color: white;text-align: left;">
                                <span style="white-space: pre-line;">{{this.getLanguage["GPS"]["YGGIS"]}}</span>
                            </span>
                        </div>
                    </div>
                    <div class="pageBtn">
                        <CButton class="btnReset" @click="resetColumn1()" v-if="needResetHeaders1">
                            <span class="font-weight-bold cil-reload"></span> {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                        </CButton>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <template>
                                <tr v-if="searchCurrency!=null && totalReport1!=null && arr_provider_reportList && arr_provider_reportList.length > 0">
                                    <th colspan="100%" style="z-index:1 !important">{{this.getLanguage['WLRPT']['T']}} ({{this.getLanguage['LST']['PAGE']}} {{int_Page}})</th>
                                </tr>
                            </template>
                            <template>
                                <tr class="reportTotal2" v-if="totalReport1!=null && searchCurrency!=null && arr_provider_reportList && arr_provider_reportList.length > 0">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <span v-if="header == 'NO'">
                                        </span>
                                        <span v-if="header == 'Brand'" class="tableCtnRight" style="display:block">
                                        </span>
                                        <span v-if="header == 'UserID'">
                                        </span>
                                        <span v-if="header == 'BetID'">
                                        </span>
                                        <span v-if="header == 'Game'">
                                        </span>
                                        <span v-if="header == 'Result'"></span>
                                        <span v-if="header == 'BalanceBefore'">
                                            {{ formatNumber(totalReport1.TBB, 2, totalReport1.ISOC, false) }}
                                        </span>
                                        <span v-if="header == 'BetAmount'">
                                            <font v-if="withWE1POKER()">{{ formatNumber(totalReport1.BA, 4, totalReport1.ISOC, false) }}</font>
                                            <font v-else>{{ formatNumber(totalReport1.BA, 2, totalReport1.ISOC, false) }}</font>
                                            <div v-if="(reportType=='AFB1188' || reportType=='GGCORRECTSCORE'||reportType=='MINI_SPORTS') && totalReport1.OBA!=''" v-html="totalReport1.OBA" class="oddsinfo"></div>
                                        </span>
                                        <span v-if="header == 'BetTime'">
                                        </span>
                                        <span v-if="header == 'EndTime'">
                                        </span>
                                        <span v-if="header == 'Currency'">
                                            {{ totalReport1.ISOC }}
                                        </span>
                                        <span v-if="header == 'CurrencyRate' && onlyWE1POKER() && totalReport1.GPI != 55" class="tableCtnRight">
                                        </span>
                                        <span v-if="header == 'Turnover' && totalReport1.GPI != 55" class="tableCtnRight">
                                            <font v-if="withWE1POKER()">{{ formatNumber(displayGameResult(totalReport1.TA, totalReport1.RS), 4,totalReport1.ISOC, false) }}</font>
                                            <font v-else>{{ formatNumber(displayGameResult(totalReport1.TA, totalReport1.RS), 2, totalReport1.ISOC, false) }}</font>
                                        </span>
                                        <span v-if="header == 'MemberWL' && totalReport1.GPI != 55" :class="CheckWinLoss(totalReport1.WLA,2,totalReport1.WLA)">
                                            <font v-if="withWE1POKER()">{{ formatNumber(displayGameResult(totalReport1.WLA, totalReport1.RS), 4,totalReport1.ISOC, false) }}</font>
                                            <font v-else>{{ formatNumber(displayGameResult(totalReport1.WLA, totalReport1.RS), 2, totalReport1.ISOC, false) }}</font>
                                        </span>
                                        <template v-if="header == 'AWR' && totalReport1.GPI != 55">
                                            <span v-if="totalReport1.TA > 0" :class="MarginCal(totalReport1.WLA,totalReport1.TA,totalReport1.ISOC) < 0? 'negative-number': 'positive-number'">{{ formatNumber(MarginCal(totalReport1.WLA,totalReport1.TA,totalReport1.ISOC), 2, "") }}%</span>
                                            <span class="" v-else>-</span>
                                        </template>
                                        <span v-if="header == 'Bonus' && withBonus()" :class="totalReport1.B >= 0? 'positive-number': 'negative-number'">
                                            <font v-if="withWE1POKER()">{{ formatNumber(totalReport1.B, 4, "") }}</font>
                                            <font v-else>{{ formatNumber(totalReport1.B, 2, totalReport1.ISOC, false) }}</font>
                                        </span>
                                        <span v-if="header == 'Jackpot' && withJackpot()" :class="CheckWinLoss(totalReport1.WLA,2,totalReport1.J)">
                                            {{ formatNumber(totalReport1.J, 2, totalReport1.ISOC, false) }}
                                        </span>
                                        <span v-if="header == 'ProviderWL' && totalReport1.GPI != 55" :class="CheckWinLoss(totalReport1.WLA,2,totalReport1.PWL)">
                                            <font v-if="withWE1POKER()">{{ formatNumber(displayGameResult(totalReport1.PWL, totalReport1.RS), 4,totalReport1.ISOC, false) }}</font>
                                            <font v-else>{{ formatNumber(displayGameResult(totalReport1.PWL, totalReport1.RS), 2, totalReport1.ISOC, false) }}</font>
                                        </span>
                                        <span v-if="header == 'CompanyWL' && totalReport1.GPI != 55" :class="CheckWinLoss(totalReport1.WLA,2,totalReport1.WWL)">
                                            <font v-if="withWE1POKER()">{{ formatNumber(displayGameResult(totalReport1.WWL, totalReport1.RS), 4,totalReport1.ISOC, false) }}</font>
                                            <font v-else>{{ formatNumber(displayGameResult(totalReport1.WWL, totalReport1.RS), 2, totalReport1.ISOC, false) }}</font>
                                        </span>
                                        <span v-if="header == 'SMWL' && getUserInfo.AT == 0 && totalReport1.GPI != 55" :class="CheckWinLoss(totalReport1.WLA,2,totalReport1.SAWL)">
                                            <font v-if="withWE1POKER()">{{ formatNumber(displayGameResult(totalReport1.SAWL, totalReport1.RS), 4,totalReport1.ISOC, false) }}</font>
                                            <font v-else>{{ formatNumber(displayGameResult(totalReport1.SAWL, totalReport1.RS), 2, totalReport1.ISOC, false) }}</font>
                                        </span>
                                        <span v-if="header == 'MAWL' && getUserInfo.AT <= 1 && totalReport1.GPI != 55" :class="CheckWinLoss(totalReport1.WLA,2,totalReport1.MAWL)">
                                            <font v-if="withWE1POKER()">{{ formatNumber(displayGameResult(totalReport1.MAWL, totalReport1.RS), 4,totalReport1.ISOC, false) }}</font>
                                            <font v-else>{{ formatNumber(displayGameResult(totalReport1.MAWL, totalReport1.RS), 2, totalReport1.ISOC, false) }}</font>
                                        </span>
                                        <span v-if="header == 'AGWL' && getUserInfo.AT <= 2 && totalReport1.GPI != 55" :class="CheckWinLoss(totalReport1.WLA,2,totalReport1.AWL)">
                                            <font v-if="withWE1POKER()">{{ formatNumber(displayGameResult(totalReport1.AWL, totalReport1.RS), 4,totalReport1.ISOC, false) }}</font>
                                            <font v-else>{{ formatNumber(displayGameResult(totalReport1.AWL, totalReport1.RS), 2, totalReport1.ISOC, false) }}</font>
                                        </span>
                                        <span v-if="header == 'Share' && totalReport1.GPI != 55">
                                        </span>
                                        <span v-if="header == 'IP'">
                                        </span>
                                    </td>
                                </tr>
                            </template>
                            <template>
                                <tr v-if="searchCurrency!=null && allTotalReport1!=null && arr_provider_reportList && arr_provider_reportList.length > 0">
                                    <th colspan="100%" style="z-index:1 !important">{{this.getLanguage['WLRPT']['AT']}} ({{this.getLanguage['LST']['APAGE']}})</th>
                                </tr>
                            </template>
                            <template>
                                <tr class="reportTotal2" v-if="allTotalReport1!=null && searchCurrency!=null && arr_provider_reportList && arr_provider_reportList.length > 0">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <span v-if="header == 'NO'">
                                        </span>
                                        <span v-if="header == 'Brand'" class="tableCtnRight" style="display:block">
                                        </span>
                                        <span v-if="header == 'UserID'">
                                        </span>
                                        <span v-if="header == 'BetID'">
                                        </span>
                                        <span v-if="header == 'Game'">
                                        </span>
                                        <span v-if="header == 'Result'">
                                        </span>
                                        <span v-if="header == 'BalanceBefore'">
                                            {{ formatNumber(allTotalReport1.TBB, 2, allTotalReport1.ISOC, false) }}
                                        </span>
                                        <span v-if="header == 'BetAmount'">
                                            <font v-if="withWE1POKER()">{{ formatNumber(allTotalReport1.BA, 4, allTotalReport1.ISOC, false) }}</font>
                                            <font v-else>{{ formatNumber(allTotalReport1.BA, 2, allTotalReport1.ISOC, false) }}</font>
                                            <div v-if="(reportType=='AFB1188' || reportType=='GGCORRECTSCORE'||reportType=='MINI_SPORTS') && allTotalReport1.OBA!=''" v-html="allTotalReport1.OBA" class="oddsinfo"></div>
                                        </span>
                                        <span v-if="header == 'BetTime'">
                                        </span>
                                        <span v-if="header == 'EndTime'">
                                        </span>
                                        <span v-if="header == 'Currency'">
                                            {{ allTotalReport1.ISOC }}
                                        </span>
                                        <span v-if="header == 'CurrencyRate' && onlyWE1POKER() && allTotalReport1.GPI != 55" class="tableCtnRight">
                                        </span>
                                        <span v-if="header == 'Turnover' && allTotalReport1.GPI != 55" class="tableCtnRight">
                                            <font v-if="withWE1POKER()">{{ formatNumber(displayGameResult(allTotalReport1.TA, allTotalReport1.RS), 4, allTotalReport1.ISOC, false) }}</font>
                                            <font v-else>{{ formatNumber(displayGameResult(allTotalReport1.TA, allTotalReport1.RS), 2, allTotalReport1.ISOC, false) }}</font>
                                        </span>
                                        <span v-if="header == 'MemberWL' && allTotalReport1.GPI != 55" :class="CheckWinLoss(allTotalReport1.WLA,2,allTotalReport1.WLA)">
                                            <font v-if="withWE1POKER()">{{ formatNumber(displayGameResult(allTotalReport1.WLA, allTotalReport1.RS), 4, allTotalReport1.ISOC, false) }}</font>
                                            <font v-else>{{ formatNumber(displayGameResult(allTotalReport1.WLA, allTotalReport1.RS), 2, allTotalReport1.ISOC, false) }}</font>
                                        </span>
                                        <template v-if="header == 'AWR' && allTotalReport1.GPI != 55">
                                            <span v-if="allTotalReport1.TA > 0" :class="MarginCal(allTotalReport1.WLA,allTotalReport1.TA,allTotalReport1.ISOC) < 0? 'negative-number': 'positive-number'">{{ formatNumber(MarginCal(allTotalReport1.WLA,allTotalReport1.TA,allTotalReport1.ISOC), 2, "") }}%</span>
                                            <span class="" v-else>-</span>
                                        </template>
                                        <span v-if="header == 'Bonus' && withBonus()" :class="allTotalReport1.B >= 0? 'positive-number': 'negative-number'">
                                            <font v-if="withWE1POKER()">{{ formatNumber(allTotalReport1.B, 4, allTotalReport1.ISOC, false) }}</font>
                                            <font v-else>{{ formatNumber(allTotalReport1.B, 2, allTotalReport1.ISOC, false) }}</font>
                                        </span>
                                        <span v-if="header == 'Jackpot' && withJackpot()" :class="CheckWinLoss(allTotalReport1.WLA,2,allTotalReport1.J)">
                                            {{ formatNumber(allTotalReport1.J, 2, allTotalReport1.ISOC, false) }}
                                        </span>
                                        <span v-if="header == 'ProviderWL' && allTotalReport1.GPI != 55" :class="CheckWinLoss(allTotalReport1.WLA,2,allTotalReport1.PWL)">
                                            <font v-if="withWE1POKER()">{{ formatNumber(displayGameResult(allTotalReport1.PWL, allTotalReport1.RS), 4, allTotalReport1.ISOC, false) }}</font>
                                            <font v-else>{{ formatNumber(displayGameResult(allTotalReport1.PWL, allTotalReport1.RS), 2, allTotalReport1.ISOC, false) }}</font>
                                        </span>
                                        <span v-if="header == 'CompanyWL' && allTotalReport1.GPI != 55" :class="CheckWinLoss(allTotalReport1.WLA,2,allTotalReport1.WWL)">
                                            <font v-if="withWE1POKER()">{{ formatNumber(displayGameResult(allTotalReport1.WWL, allTotalReport1.RS), 4, allTotalReport1.ISOC, false) }}</font>
                                            <font v-else>{{ formatNumber(displayGameResult(allTotalReport1.WWL, allTotalReport1.RS), 2, allTotalReport1.ISOC, false) }}</font>
                                        </span>
                                        <span v-if="header == 'SMWL' && getUserInfo.AT == 0 && allTotalReport1.GPI != 55" :class="CheckWinLoss(allTotalReport1.WLA,2,allTotalReport1.SAWL)">
                                            <font v-if="withWE1POKER()">{{ formatNumber(displayGameResult(allTotalReport1.SAWL, allTotalReport1.RS), 4, allTotalReport1.ISOC, false) }}</font>
                                            <font v-else>{{ formatNumber(displayGameResult(allTotalReport1.SAWL, allTotalReport1.RS), 2, allTotalReport1.ISOC, false) }}</font>
                                        </span>
                                        <span v-if="header == 'MAWL' && getUserInfo.AT <= 1 && allTotalReport1.GPI != 55" :class="CheckWinLoss(allTotalReport1.WLA,2,allTotalReport1.MAWL)">
                                            <font v-if="withWE1POKER()">{{ formatNumber(displayGameResult(allTotalReport1.MAWL, allTotalReport1.RS), 4, allTotalReport1.ISOC, false) }}</font>
                                            <font v-else>{{ formatNumber(displayGameResult(allTotalReport1.MAWL, allTotalReport1.RS), 2, allTotalReport1.ISOC, false) }}</font>
                                        </span>
                                        <span v-if="header == 'AGWL' && getUserInfo.AT <= 2 && allTotalReport1.GPI != 55" :class="CheckWinLoss(allTotalReport1.WLA,2,allTotalReport1.AWL)">
                                            <font v-if="withWE1POKER()">{{ formatNumber(displayGameResult(allTotalReport1.AWL, allTotalReport1.RS), 4, allTotalReport1.ISOC, false) }}</font>
                                            <font v-else>{{ formatNumber(displayGameResult(allTotalReport1.AWL, allTotalReport1.RS), 2, allTotalReport1.ISOC, false) }}</font>
                                        </span>
                                        <span v-if="header == 'Share' && allTotalReport1.GPI != 55">
                                        </span>
                                        <span v-if="header == 'IP'">
                                        </span>
                                    </td>
                                </tr>
                            </template>
                            <draggable v-model="reportHeaders1" tag="tr">
                                <th v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']" scope="col">
                                    <span v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        {{getLanguage['GL']['NO']}}
                                    </span>
                                    <span v-if="header == 'Brand'">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        {{getLanguage['GL']['AGT']}}
                                        <i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i>
                                    </span>
                                    <span v-if="header == 'UserID'">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        {{getLanguage['MEM']['U']}}
                                        <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                    </span>
                                    <span v-if="header == 'BetID'">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        {{getLanguage['BETRPT']['BI']}}
                                        <i @click="setSortTable('TI')" :class="setSortLogo('TI')" class="sortlogo"></i>
                                    </span>
                                    <span v-if="header == 'ProviderName' && withSportsBook()">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        {{getLanguage['BETRPT']['GP']}}
                                    </span>
                                    <span v-if="header == 'Game'">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        {{getLanguage['BETRPT']['G']}}
                                        <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                    </span>
                                    <span v-if="header == 'EventInfo' && withSportsBook()">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        {{getLanguage['BETRPT']['EI']}}
                                    </span>
                                    <span v-if="header == 'Result'">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        <font v-if="withSportsBook()">
                                            {{getLanguage['WLRPT']['BD']}}
                                        </font>
                                        <font v-else>
                                            {{getLanguage['WLRPT']['R']}}
                                        </font>
                                    </span>
                                    <span v-if="header == 'BalanceBefore'" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        {{getLanguage['BETRPT']['BB']}}
                                        <i @click="setSortTable('BB')" :class="setSortLogo('BB')" class="sortlogo"></i>
                                    </span>
                                    <span v-if="header == 'BetAmount'" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        {{getLanguage['BETRPT']['BA']}}
                                        <i @click="setSortTable('BA')" :class="setSortLogo('BA')" class="sortlogo"></i>
                                    </span>
                                    <span v-if="header == 'BetTime'" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        <font v-if="withTransferWallet()">
                                            {{getLanguage['BETRPT']['BT']}}<i @click="setSortTable('GTS')" :class="setSortLogo('GTS')" class="sortlogo"></i>
                                        </font>
                                        <font v-else>
                                            {{getLanguage['BETRPT']['BT']}}<i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                        </font>
                                    </span>
                                    <span v-if="header == 'EndTime'" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        {{getLanguage['BETRPT']['ET']}}
                                        <i @click="setSortTable('RTS')" :class="setSortLogo('RTS')" class="sortlogo"></i>
                                    </span>
                                    <span v-if="header == 'Currency'" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        {{getLanguage['MEM']['CI']}}
                                        <i @click="setSortTable('ISOC')" :class="setSortLogo('ISOC')" class="sortlogo"></i>
                                    </span>
                                    <span v-if="header == 'CurrencyRate' && onlyWE1POKER() && searchGameProviderId.length >= 1 && !searchGameProviderId.includes('55')" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        {{getLanguage['CR']['CR']}}
                                    </span>
                                    <span v-if="header == 'Turnover' && searchGameProviderId.length >= 1 && !searchGameProviderId.includes('55')" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        <font v-if="withWE1POKER()">{{getLanguage['WLRPT_WE1']['RAKE']}}</font>
                                        <font v-else>{{getLanguage['MEM']['TO']}}</font>
                                        <i @click="setSortTable('TA')" :class="setSortLogo('TA')" class="sortlogo"></i>
                                    </span>
                                    <span v-if="header == 'MemberWL' && searchGameProviderId.length >= 1 && !searchGameProviderId.includes('55')" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        {{getLanguage['BETRPT']['WL']}}
                                        <i @click="setSortTable('WLA')" :class="setSortLogo('WLA')" class="sortlogo"></i>
                                    </span>
                                    <span v-if="header == 'AWR' && searchGameProviderId.length >= 1 && !searchGameProviderId.includes('55')" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        {{getLanguage['BETRPT']['AWR']}}
                                        <i @click="setSortTable('AWR')" :class="setSortLogo('AWR')" class="sortlogo"></i>
                                    </span>
                                    <span v-if="header == 'Bonus' && withBonus()" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        {{getLanguage['WLRPT']['BN']}}
                                    </span>
                                    <span v-if="header == 'Jackpot' && withJackpot()" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        {{getLanguage['WLRPT']['JP']}}
                                    </span>
                                    <span v-if="header == 'ProviderWL' && searchGameProviderId.length >= 1 && !searchGameProviderId.includes('55')" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        <font v-if="withWE1POKER()">{{getLanguage['WLRPT_WE1']['PWL_RAKE']}}</font>
                                        <font v-else>{{getLanguage['WLRPT']['PWL']}}</font>
                                    </span>
                                    <span v-if="header == 'CompanyWL' && searchGameProviderId.length >= 1 && !searchGameProviderId.includes('55')" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        <font v-if="withWE1POKER()">{{getLanguage['WLRPT_WE1']['WWL_RAKE']}}</font>
                                        <font v-else>{{getLanguage['WLRPT']['WWL']}}<i @click="setSortTable('WWL')" :class="setSortLogo('WWL')" class="sortlogo"></i></font>
                                    </span>
                                    <span v-if="header == 'SMWL' && getUserInfo.AT == 0 && searchGameProviderId.length >= 1 && !searchGameProviderId.includes('55')" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        <font v-if="withWE1POKER()">{{getLanguage['WLRPT_WE1']['SAWL_RAKE']}}</font>
                                        <font v-else>{{getLanguage['WLRPT']['SAWL']}}<i @click="setSortTable('SAWL')" :class="setSortLogo('SAWL')" class="sortlogo"></i></font>
                                    </span>
                                    <span v-if="header == 'MAWL' && getUserInfo.AT <= 1 && searchGameProviderId.length >= 1 && !searchGameProviderId.includes('55')" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        <font v-if="withWE1POKER()">{{getLanguage['WLRPT_WE1']['MAWL_RAKE']}}</font>
                                        <font v-else>{{getLanguage['WLRPT']['MAWL']}}<i @click="setSortTable('MAWL')" :class="setSortLogo('MAWL')" class="sortlogo"></i></font>
                                    </span>
                                    <span v-if="header == 'AGWL' && getUserInfo.AT <= 2 && searchGameProviderId.length >= 1 && !searchGameProviderId.includes('55')" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        <font v-if="withWE1POKER()">{{getLanguage['WLRPT_WE1']['AWL_RAKE']}}</font>
                                        <font v-else>{{getLanguage['WLRPT']['AWL']}}<i @click="setSortTable('AWL')" :class="setSortLogo('AWL')" class="sortlogo"></i></font>
                                    </span>
                                    <span v-if="header == 'Share' && searchGameProviderId.length >= 1 && !searchGameProviderId.includes('55')" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn1(header)" :style="shareIndicator ? 'margin-top: 9px;' : ''"></i>
                                        <font>
                                            {{getLanguage['WLRPT']['S']}}<br />
                                            {{ shareIndicator }}
                                        </font>
                                    </span>
                                    <span v-if="header == 'IP'">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        {{getLanguage['GL']['IP']}}
                                        <i @click="setSortTable('MIP')" :class="setSortLogo('MIP')" class="sortlogo"></i>
                                    </span>
                                </th>
                            </draggable>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <template>
                                <tr v-if="searchCurrency!=null && totalReport1!=null && arr_provider_reportList && arr_provider_reportList.length > 0">
                                    <th colspan="100%" style="z-index:1 !important">{{this.getLanguage['WLRPT']['T']}} ({{this.getLanguage['LST']['PAGE']}} {{int_Page}})</th>
                                </tr>
                            </template>
                            <template>
                                <tr class="reportTotal2" v-if="totalReport1!=null && searchCurrency!=null && arr_provider_reportList && arr_provider_reportList.length > 0">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <span v-if="header == 'NO'">
                                        </span>
                                        <span v-if="header == 'Brand'" class="tableCtnRight" style="display:block">
                                        </span>
                                        <span v-if="header == 'UserID'">
                                        </span>
                                        <span v-if="header == 'BetID'">
                                        </span>
                                        <span v-if="header == 'Game'">
                                        </span>
                                        <span v-if="header == 'Result'"></span>
                                        <span v-if="header == 'BalanceBefore'">
                                            {{ formatNumber(totalReport1.TBB, 2, totalReport1.ISOC, false) }}
                                        </span>
                                        <span v-if="header == 'BetAmount'">
                                            <font v-if="withWE1POKER()">{{ formatNumber(totalReport1.BA, 4, totalReport1.ISOC) }}</font>
                                            <font v-else>{{ formatNumber(totalReport1.BA, 2, totalReport1.ISOC) }}</font>
                                            <div v-if="(reportType=='AFB1188' || reportType=='GGCORRECTSCORE'||reportType=='MINI_SPORTS') && totalReport1.OBA!=''" v-html="totalReport1.OBA" class="oddsinfo"></div>
                                        </span>
                                        <span v-if="header == 'BetTime'">
                                        </span>
                                        <span v-if="header == 'EndTime'">
                                        </span>
                                        <span v-if="header == 'Currency'">
                                            {{ totalReport1.ISOC }}
                                        </span>
                                        <span v-if="header == 'CurrencyRate' && onlyWE1POKER() && totalReport1.GPI != 55" class="tableCtnRight">
                                        </span>
                                        <span v-if="header == 'Turnover' && totalReport1.GPI != 55" class="tableCtnRight">
                                            <font v-if="withWE1POKER()">{{ formatNumber(displayGameResult(totalReport1.TA, totalReport1.RS), 4,totalReport1.ISOC) }}</font>
                                            <font v-else>{{ formatNumber(displayGameResult(totalReport1.TA, totalReport1.RS), 2, totalReport1.ISOC) }}</font>
                                        </span>
                                        <span v-if="header == 'MemberWL' && totalReport1.GPI != 55" :class="CheckWinLoss(totalReport1.WLA,2,totalReport1.WLA)">
                                            <font v-if="withWE1POKER()">{{ formatNumber(displayGameResult(totalReport1.WLA, totalReport1.RS), 4,totalReport1.ISOC) }}</font>
                                            <font v-else>{{ formatNumber(displayGameResult(totalReport1.WLA, totalReport1.RS), 2, totalReport1.ISOC) }}</font>
                                        </span>
                                        <template v-if="header == 'AWR' && totalReport1.GPI != 55">
                                            <span v-if="totalReport1.TA > 0" :class="MarginCal(totalReport1.WLA,totalReport1.TA,totalReport1.ISOC) < 0? 'negative-number': 'positive-number'">{{ formatNumber(MarginCal(totalReport1.WLA,totalReport1.TA,totalReport1.ISOC), 2, "") }}%</span>
                                            <span class="" v-else>-</span>
                                        </template>
                                        <span v-if="header == 'Bonus' && withBonus()" :class="totalReport1.B >= 0? 'positive-number': 'negative-number'">
                                            <font v-if="withWE1POKER()">{{ formatNumber(totalReport1.B, 4, "") }}</font>
                                            <font v-else>{{ formatNumber(totalReport1.B, 2, totalReport1.ISOC) }}</font>
                                        </span>
                                        <span v-if="header == 'Jackpot' && withJackpot()" :class="CheckWinLoss(totalReport1.WLA,2,totalReport1.J)">
                                            {{ formatNumber(totalReport1.J, 2, totalReport1.ISOC) }}
                                        </span>
                                        <span v-if="header == 'ProviderWL' && totalReport1.GPI != 55" :class="CheckWinLoss(totalReport1.WLA,2,totalReport1.PWL)">
                                            <font v-if="withWE1POKER()">{{ formatNumber(displayGameResult(totalReport1.PWL, totalReport1.RS), 4,totalReport1.ISOC) }}</font>
                                            <font v-else>{{ formatNumber(displayGameResult(totalReport1.PWL, totalReport1.RS), 2, totalReport1.ISOC) }}</font>
                                        </span>
                                        <span v-if="header == 'CompanyWL' && totalReport1.GPI != 55" :class="CheckWinLoss(totalReport1.WLA,2,totalReport1.WWL)">
                                            <font v-if="withWE1POKER()">{{ formatNumber(displayGameResult(totalReport1.WWL, totalReport1.RS), 4,totalReport1.ISOC) }}</font>
                                            <font v-else>{{ formatNumber(displayGameResult(totalReport1.WWL, totalReport1.RS), 2, totalReport1.ISOC) }}</font>
                                        </span>
                                        <span v-if="header == 'SMWL' && getUserInfo.AT == 0 && totalReport1.GPI != 55" :class="CheckWinLoss(totalReport1.WLA,2,totalReport1.SAWL)">
                                            <font v-if="withWE1POKER()">{{ formatNumber(displayGameResult(totalReport1.SAWL, totalReport1.RS), 4,totalReport1.ISOC) }}</font>
                                            <font v-else>{{ formatNumber(displayGameResult(totalReport1.SAWL, totalReport1.RS), 2, totalReport1.ISOC) }}</font>
                                        </span>
                                        <span v-if="header == 'MAWL' && getUserInfo.AT <= 1 && totalReport1.GPI != 55" :class="CheckWinLoss(totalReport1.WLA,2,totalReport1.MAWL)">
                                            <font v-if="withWE1POKER()">{{ formatNumber(displayGameResult(totalReport1.MAWL, totalReport1.RS), 4,totalReport1.ISOC) }}</font>
                                            <font v-else>{{ formatNumber(displayGameResult(totalReport1.MAWL, totalReport1.RS), 2, totalReport1.ISOC) }}</font>
                                        </span>
                                        <span v-if="header == 'AGWL' && getUserInfo.AT <= 2 && totalReport1.GPI != 55" :class="CheckWinLoss(totalReport1.WLA,2,totalReport1.AWL)">
                                            <font v-if="withWE1POKER()">{{ formatNumber(displayGameResult(totalReport1.AWL, totalReport1.RS), 4,totalReport1.ISOC) }}</font>
                                            <font v-else>{{ formatNumber(displayGameResult(totalReport1.AWL, totalReport1.RS), 2, totalReport1.ISOC) }}</font>
                                        </span>
                                        <span v-if="header == 'Share' && totalReport1.GPI != 55">
                                        </span>
                                        <span v-if="header == 'IP'">
                                        </span>
                                    </td>
                                </tr>
                            </template>
                            <template>
                                <tr v-if="searchCurrency!=null && allTotalReport1!=null && arr_provider_reportList && arr_provider_reportList.length > 0">
                                    <th colspan="100%" style="z-index:1 !important">{{this.getLanguage['WLRPT']['AT']}} ({{this.getLanguage['LST']['APAGE']}})</th>
                                </tr>
                            </template>
                            <template>
                                <tr class="reportTotal2" v-if="allTotalReport1!=null && searchCurrency!=null && arr_provider_reportList && arr_provider_reportList.length > 0">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <span v-if="header == 'NO'">
                                        </span>
                                        <span v-if="header == 'Brand'" class="tableCtnRight" style="display:block">
                                        </span>
                                        <span v-if="header == 'UserID'">
                                        </span>
                                        <span v-if="header == 'BetID'">
                                        </span>
                                        <span v-if="header == 'Game'">
                                        </span>
                                        <span v-if="header == 'Result'">
                                        </span>
                                        <span v-if="header == 'BalanceBefore'">
                                            {{ formatNumber(allTotalReport1.TBB, 2, allTotalReport1.ISOC) }}
                                        </span>
                                        <span v-if="header == 'BetAmount'">
                                            <font v-if="withWE1POKER()">{{ formatNumber(allTotalReport1.BA, 4, allTotalReport1.ISOC) }}</font>
                                            <font v-else>{{ formatNumber(allTotalReport1.BA, 2, allTotalReport1.ISOC) }}</font>
                                            <div v-if="(reportType=='AFB1188' || reportType=='GGCORRECTSCORE'||reportType=='MINI_SPORTS') && allTotalReport1.OBA!=''" v-html="allTotalReport1.OBA" class="oddsinfo"></div>
                                        </span>
                                        <span v-if="header == 'BetTime'">
                                        </span>
                                        <span v-if="header == 'EndTime'">
                                        </span>
                                        <span v-if="header == 'Currency'">
                                            {{ allTotalReport1.ISOC }}
                                        </span>
                                        <span v-if="header == 'CurrencyRate' && onlyWE1POKER() && allTotalReport1.GPI != 55" class="tableCtnRight">
                                        </span>
                                        <span v-if="header == 'Turnover' && allTotalReport1.GPI != 55" class="tableCtnRight">
                                            <font v-if="withWE1POKER()">{{ formatNumber(displayGameResult(allTotalReport1.TA, allTotalReport1.RS), 4, allTotalReport1.ISOC) }}</font>
                                            <font v-else>{{ formatNumber(displayGameResult(allTotalReport1.TA, allTotalReport1.RS), 2, allTotalReport1.ISOC) }}</font>
                                        </span>
                                        <span v-if="header == 'MemberWL' && allTotalReport1.GPI != 55" :class="CheckWinLoss(allTotalReport1.WLA,2,allTotalReport1.WLA)">
                                            <font v-if="withWE1POKER()">{{ formatNumber(displayGameResult(allTotalReport1.WLA, allTotalReport1.RS), 4, allTotalReport1.ISOC) }}</font>
                                            <font v-else>{{ formatNumber(displayGameResult(allTotalReport1.WLA, allTotalReport1.RS), 2, allTotalReport1.ISOC) }}</font>
                                        </span>
                                        <template v-if="header == 'AWR' && allTotalReport1.GPI != 55">
                                            <span v-if="allTotalReport1.TA > 0" :class="MarginCal(allTotalReport1.WLA,allTotalReport1.TA,allTotalReport1.ISOC) < 0? 'negative-number': 'positive-number'">{{ formatNumber(MarginCal(allTotalReport1.WLA,allTotalReport1.TA,allTotalReport1.ISOC), 2, "") }}%</span>
                                            <span class="" v-else>-</span>
                                        </template>
                                        <span v-if="header == 'Bonus' && withBonus()" :class="allTotalReport1.B >= 0? 'positive-number': 'negative-number'">
                                            <font v-if="withWE1POKER()">{{ formatNumber(allTotalReport1.B, 4, allTotalReport1.ISOC) }}</font>
                                            <font v-else>{{ formatNumber(allTotalReport1.B, 2, allTotalReport1.ISOC) }}</font>
                                        </span>
                                        <span v-if="header == 'Jackpot' && withJackpot()" :class="CheckWinLoss(allTotalReport1.WLA,2,allTotalReport1.J)">
                                            {{ formatNumber(allTotalReport1.J, 2, allTotalReport1.ISOC) }}
                                        </span>
                                        <span v-if="header == 'ProviderWL' && allTotalReport1.GPI != 55" :class="CheckWinLoss(allTotalReport1.WLA,2,allTotalReport1.PWL)">
                                            <font v-if="withWE1POKER()">{{ formatNumber(displayGameResult(allTotalReport1.PWL, allTotalReport1.RS), 4, allTotalReport1.ISOC) }}</font>
                                            <font v-else>{{ formatNumber(displayGameResult(allTotalReport1.PWL, allTotalReport1.RS), 2, allTotalReport1.ISOC) }}</font>
                                        </span>
                                        <span v-if="header == 'CompanyWL' && allTotalReport1.GPI != 55" :class="CheckWinLoss(allTotalReport1.WLA,2,allTotalReport1.WWL)">
                                            <font v-if="withWE1POKER()">{{ formatNumber(displayGameResult(allTotalReport1.WWL, allTotalReport1.RS), 4, allTotalReport1.ISOC) }}</font>
                                            <font v-else>{{ formatNumber(displayGameResult(allTotalReport1.WWL, allTotalReport1.RS), 2, allTotalReport1.ISOC) }}</font>
                                        </span>
                                        <span v-if="header == 'SMWL' && getUserInfo.AT == 0 && allTotalReport1.GPI != 55" :class="CheckWinLoss(allTotalReport1.WLA,2,allTotalReport1.SAWL)">
                                            <font v-if="withWE1POKER()">{{ formatNumber(displayGameResult(allTotalReport1.SAWL, allTotalReport1.RS), 4, allTotalReport1.ISOC) }}</font>
                                            <font v-else>{{ formatNumber(displayGameResult(allTotalReport1.SAWL, allTotalReport1.RS), 2, allTotalReport1.ISOC) }}</font>
                                        </span>
                                        <span v-if="header == 'MAWL' && getUserInfo.AT <= 1 && allTotalReport1.GPI != 55" :class="CheckWinLoss(allTotalReport1.WLA,2,allTotalReport1.MAWL)">
                                            <font v-if="withWE1POKER()">{{ formatNumber(displayGameResult(allTotalReport1.MAWL, allTotalReport1.RS), 4, allTotalReport1.ISOC) }}</font>
                                            <font v-else>{{ formatNumber(displayGameResult(allTotalReport1.MAWL, allTotalReport1.RS), 2, allTotalReport1.ISOC) }}</font>
                                        </span>
                                        <span v-if="header == 'AGWL' && getUserInfo.AT <= 2 && allTotalReport1.GPI != 55" :class="CheckWinLoss(allTotalReport1.WLA,2,allTotalReport1.AWL)">
                                            <font v-if="withWE1POKER()">{{ formatNumber(displayGameResult(allTotalReport1.AWL, allTotalReport1.RS), 4, allTotalReport1.ISOC) }}</font>
                                            <font v-else>{{ formatNumber(displayGameResult(allTotalReport1.AWL, allTotalReport1.RS), 2, allTotalReport1.ISOC) }}</font>
                                        </span>
                                        <span v-if="header == 'Share' && allTotalReport1.GPI != 55">
                                        </span>
                                        <span v-if="header == 'IP'">
                                        </span>
                                    </td>
                                </tr>
                            </template>
                            <draggable v-model="reportHeaders1" tag="tr">
                                <th v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']" scope="col">
                                    <span v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        {{getLanguage['GL']['NO']}}
                                    </span>
                                    <span v-if="header == 'Brand'">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        {{getLanguage['GL']['AGT']}}
                                        <i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i>
                                    </span>
                                    <span v-if="header == 'UserID'">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        {{getLanguage['MEM']['U']}}
                                        <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                    </span>
                                    <span v-if="header == 'BetID'">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        {{getLanguage['BETRPT']['BI']}}
                                        <i @click="setSortTable('TI')" :class="setSortLogo('TI')" class="sortlogo"></i>
                                    </span>
                                    <span v-if="header == 'ProviderName' && withSportsBook()" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        {{getLanguage['BETRPT']['GP']}}
                                        <i @click="setSortTable('PN')" :class="setSortLogo('PN')" class="sortlogo"></i>
                                    </span>
                                    <span v-if="header == 'Game'">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        {{getLanguage['BETRPT']['G']}}
                                        <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                    </span>
                                    <span v-if="header == 'EventInfo' && withSportsBook()" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        {{getLanguage['BETRPT']['EI']}}
                                        <i @click="setSortTable('EI')" :class="setSortLogo('EI')" class="sortlogo"></i>
                                    </span>
                                    <span v-if="header == 'Result'">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        <font v-if="withSportsBook()">
                                            {{getLanguage['WLRPT']['BD']}}
                                        </font>
                                        <font v-else>
                                            {{getLanguage['WLRPT']['R']}}
                                        </font>
                                    </span>
                                    <span v-if="header == 'BalanceBefore'" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        {{getLanguage['BETRPT']['BB']}}
                                        <i @click="setSortTable('BB')" :class="setSortLogo('BB')" class="sortlogo"></i>
                                    </span>
                                    <span v-if="header == 'BetAmount'" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        {{getLanguage['BETRPT']['BA']}}
                                        <i @click="setSortTable('BA')" :class="setSortLogo('BA')" class="sortlogo"></i>
                                    </span>
                                    <span v-if="header == 'BetTime'" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        <font v-if="withTransferWallet()">
                                            {{getLanguage['BETRPT']['BT']}}<i @click="setSortTable('GTS')" :class="setSortLogo('GTS')" class="sortlogo"></i>
                                        </font>
                                        <font v-else>
                                            {{getLanguage['BETRPT']['BT']}}<i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                        </font>
                                    </span>
                                    <span v-if="header == 'EndTime'" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        {{getLanguage['BETRPT']['ET']}}
                                        <i @click="setSortTable('RTS')" :class="setSortLogo('RTS')" class="sortlogo"></i>
                                    </span>
                                    <span v-if="header == 'Currency'" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        {{getLanguage['MEM']['CI']}}
                                        <i @click="setSortTable('ISOC')" :class="setSortLogo('ISOC')" class="sortlogo"></i>
                                    </span>
                                    <span v-if="header == 'CurrencyRate' && onlyWE1POKER() && searchGameProviderId.length >= 1 && !searchGameProviderId.includes('55')" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        {{getLanguage['CR']['CR']}}
                                    </span>
                                    <span v-if="header == 'Turnover' && searchGameProviderId.length >= 1 && !searchGameProviderId.includes('55')" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        <font v-if="withWE1POKER()">{{getLanguage['WLRPT_WE1']['RAKE']}}</font>
                                        <font v-else>{{getLanguage['MEM']['TO']}}</font>
                                        <i @click="setSortTable('TA')" :class="setSortLogo('TA')" class="sortlogo"></i>
                                    </span>
                                    <span v-if="header == 'MemberWL' && searchGameProviderId.length >= 1 && !searchGameProviderId.includes('55')" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        {{getLanguage['BETRPT']['WL']}}
                                        <i @click="setSortTable('WLA')" :class="setSortLogo('WLA')" class="sortlogo"></i>
                                    </span>
                                    <span v-if="header == 'AWR' && searchGameProviderId.length >= 1 && !searchGameProviderId.includes('55')" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        {{getLanguage['BETRPT']['AWR']}}
                                        <i @click="setSortTable('AWR')" :class="setSortLogo('AWR')" class="sortlogo"></i>
                                    </span>
                                    <span v-if="header == 'Bonus' && withBonus()" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        {{getLanguage['WLRPT']['BN']}}
                                    </span>
                                    <span v-if="header == 'Jackpot' && withJackpot()" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        {{getLanguage['WLRPT']['JP']}}
                                    </span>
                                    <span v-if="header == 'ProviderWL' && searchGameProviderId.length >= 1 && !searchGameProviderId.includes('55')" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        <font v-if="withWE1POKER()">{{getLanguage['WLRPT_WE1']['PWL_RAKE']}}</font>
                                        <font v-else>{{getLanguage['WLRPT']['PWL']}}</font>
                                    </span>
                                    <span v-if="header == 'CompanyWL' && searchGameProviderId.length >= 1 && !searchGameProviderId.includes('55')" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        <font v-if="withWE1POKER()">{{getLanguage['WLRPT_WE1']['WWL_RAKE']}}</font>
                                        <font v-else>{{getLanguage['WLRPT']['WWL']}}<i @click="setSortTable('WWL')" :class="setSortLogo('WWL')" class="sortlogo"></i></font>
                                    </span>
                                    <span v-if="header == 'SMWL' && getUserInfo.AT == 0 && searchGameProviderId.length >= 1 && !searchGameProviderId.includes('55')" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        <font v-if="withWE1POKER()">{{getLanguage['WLRPT_WE1']['SAWL_RAKE']}}</font>
                                        <font v-else>{{getLanguage['WLRPT']['SAWL']}}<i @click="setSortTable('SAWL')" :class="setSortLogo('SAWL')" class="sortlogo"></i></font>
                                    </span>
                                    <span v-if="header == 'MAWL' && getUserInfo.AT <= 1 && searchGameProviderId.length >= 1 && !searchGameProviderId.includes('55')" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        <font v-if="withWE1POKER()">{{getLanguage['WLRPT_WE1']['MAWL_RAKE']}}</font>
                                        <font v-else>{{getLanguage['WLRPT']['MAWL']}}<i @click="setSortTable('MAWL')" :class="setSortLogo('MAWL')" class="sortlogo"></i></font>
                                    </span>
                                    <span v-if="header == 'AGWL' && getUserInfo.AT <= 2 && searchGameProviderId.length >= 1 && !searchGameProviderId.includes('55')" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        <font v-if="withWE1POKER()">{{getLanguage['WLRPT_WE1']['AWL_RAKE']}}</font>
                                        <font v-else>{{getLanguage['WLRPT']['AWL']}}<i @click="setSortTable('AWL')" :class="setSortLogo('AWL')" class="sortlogo"></i></font>
                                    </span>
                                    <span v-if="header == 'Share' && searchGameProviderId.length >= 1 && !searchGameProviderId.includes('55')" class="tableCtnRight">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        <font>
                                            {{getLanguage['WLRPT']['S']}}<br />
                                            {{ shareIndicator }}
                                        </font>
                                    </span>
                                    <span v-if="header == 'IP'">
                                        <i class="fa fa-times" @click="removeColumn1(header)"></i>
                                        {{getLanguage['GL']['IP']}}
                                        <i @click="setSortTable('MIP')" :class="setSortLogo('MIP')" class="sortlogo"></i>
                                    </span>
                                </th>
                            </draggable>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arr_provider_reportList && arr_provider_reportList.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <!--Provider Win Loss Report-->
                        <template v-for="(data,index) in arr_provider_reportList">
                            <tr @click="clickList(data,index,data.RURL)" :class="data.bool_showDetails? 'bd-selected kema-eft pointer':' kema-eft pointer'">
                                <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                    <span v-if="header == 'NO'">
                                        {{ CountItem(index+1) }}
                                    </span>
                                    <span v-if="header == 'Brand'">
                                        <span class="grid-line">{{ data.AGN }}</span>
                                        <span class="saggroupname">{{ data.SAGGN }}</span>
                                    </span>
                                    <span v-if="header == 'UserID' && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" class='kema-eft' @click="CheckingMember(data.AGI,data.MI)">
                                        <div class="custom_tooltip">
                                            <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                            <span v-if="convertToBool(data.TN)" class="tooltiptext tooltip-right" :style="getbgtooltip(data)">{{data.TN}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="arr_summary_reportList!=null && arr_summary_reportList.length > 0 && arr_summary_reportList[0].TW == 0" @click.stop>
                                            <img src="/src/assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["MNM"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="arr_summary_reportList!=null && arr_summary_reportList.length > 0 && arr_summary_reportList[0].HTWT" @click.stop>
                                            <img src="/src/assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["PVP"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="arr_summary_reportList!=null && arr_summary_reportList.length > 0 && arr_summary_reportList[0].RP" @click.stop>
                                            <img src="/src/assets/icons/referral.svg" class="referral-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["RFB"]}}</span>
                                        </div>
                                        <div class="float-right pointer ml-1" style="margin-top: -1px;">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                                                <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                            </svg>
                                        </div>
                                    </span>
                                    <span v-else-if="header == 'UserID' && (isSENS == 1 && data.AGI != curAGI)" class='kema-eft'>
                                        <div class="custom_tooltip">
                                            <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                            <span v-if="convertToBool(data.TN)" class="tooltiptext tooltip-right" :style="getbgtooltip(data)">{{data.TN}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="arr_summary_reportList!=null && arr_summary_reportList.length > 0 && arr_summary_reportList[0].TW == 0" @click.stop>
                                            <img src="/src/assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["MNM"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="arr_summary_reportList!=null && arr_summary_reportList.length > 0 && arr_summary_reportList[0].HTWT" @click.stop>
                                            <img src="/src/assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["PVP"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="arr_summary_reportList!=null && arr_summary_reportList.length > 0 && arr_summary_reportList[0].RP" @click.stop>
                                            <img src="/src/assets/icons/referral.svg" class="referral-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["RFB"]}}</span>
                                        </div>
                                        <div class="float-right pointer ml-1" style="margin-top: -1px;">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                                                <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                            </svg>
                                        </div>
                                    </span>
                                    <span v-if="header == 'BetID'">
                                        <span v-if="data.PN == 'AFBCASINO'" v-html="data.TI"></span>
                                        <span v-else-if="data.PN == 'SABA_SPORTSBOOK'" v-html="data.TI"></span>
                                        <span v-else-if="data.PN == 'ACE333'" v-html="data.TI"></span>
                                        <span v-else>{{ data.TI }}</span>
                                    </span>

                                    <span v-if="header == 'ProviderName' && withSportsBook()">
                                        <span v-if="data.PN=='AFB1188'">AFB SPORTS</span>
                                        <span v-else-if="data.PN=='GGCORRECTSCORE'">GGCS SPORTS</span>
                                        <span v-else-if="data.PN=='MINI_SPORTS'">MINI SPORTS</span>
                                        <span v-else>{{ data.PN }}</span>
                                    </span>

                                    <!--Game 遊戲-->
                                    <span v-if="header == 'Game'">
                                        <span v-if="data.PN == 'AFB1188'" v-html="data.GN"></span>
                                        <span v-else-if="data.PN=='GGCORRECTSCORE'" v-html="data.GN"></span>
                                        <span v-else-if="data.PN=='MINI_SPORTS'" v-html="data.GN"></span>
                                        <span v-else v-html="getGameName(data.GN, data)"></span>
                                    </span>

                                    <!--Event Info-->
                                    <span v-if="header == 'EventInfo' && withSportsBook()" v-html="getGameName(data.EI, data)">
                                    </span>

                                    <!--Result 結果 Bet Details-->
                                    <span v-if="header == 'Result' && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" @click="gameResultOnClick(data)" v-html="renderGameResult(data.GR, data)">
                                    </span>
                                    <span v-else-if="header == 'Result' && (isSENS == 1 && data.AGI != curAGI)">
                                        {{getLanguage["WLRPT"]["VT"]}}
                                    </span>







                                    <span v-if="header == 'BalanceBefore'">
                                        {{ formatNumber(data.TBB, 2, data.ISOC, false) }}
                                    </span>
                                    <span v-if="header == 'BetAmount'">
                                        <font v-if="withWE1POKER()">{{ formatNumber(data.BA, 4, "") }}</font>
                                        <font v-else>{{ formatNumber(data.BA, 2, data.ISOC, false) }}</font>
                                        <div v-if="(reportType=='AFB1188' || reportType=='GGCORRECTSCORE'|| reportType=='MINI_SPORTS') && data.OBA!=''" v-html="data.OBA" class="oddsinfo"></div>
                                        <div v-else-if="data.BAN!='' || !data.BAN" class="oddsinfo" v-html="data.BAN"></div>
                                    </span>
                                    <span v-if="header == 'BetTime'">
                                        <span v-if="withTransferWallet()">{{ formatDateTime(data.GTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss", true) }}</span>
                                        <span v-else>{{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss", true) }}</span>
                                        <span v-if="data.ASMRT != null || data.ASMRT != ''">
                                            </br>
                                            <span v-html="data.ASMRT"></span>
                                        </span>
                                    </span>
                                    <span v-if="header == 'EndTime'">
                                        {{ generateEndTime(data.RS, data.CTS, data.RTS) }}
                                    </span>
                                    <span v-if="header == 'Currency'">
                                        {{ data.ISOC }}
                                    </span>
                                    <span v-if="header == 'CurrencyRate' && onlyWE1POKER() && data.GPI != 55" class="tableCtnRight">
                                        {{ displayExchangeRate(data.CR) }}
                                    </span>
                                    <span v-if="header == 'Turnover' && data.GPI != 55" class="tableCtnRight">
                                        <font v-if="withWE1POKER()">{{ formatNumber(displayGameResult(data.TA, data.RS), 4, data.ISOC, false ) }}</font>
                                        <font v-else>{{ formatNumber(displayGameResult(data.TA, data.RS), 2, data.ISOC, false) }}</font>
                                    </span>
                                    <span v-if="header == 'MemberWL' && data.GPI != 55" :class="CheckWinLoss(data.WLA,data.RS,data.WLA)">
                                        <font v-if="withWE1POKER()">{{ formatNumber(displayGameResult(data.WLA, data.RS), 4, data.ISOC, false) }}</font>
                                        <font v-else>{{ formatNumber(displayGameResult(data.WLA, data.RS), 2, data.ISOC, false) }}</font>
                                    </span>
                                    <span v-if="header == 'AWR' && data.GPI != 55">
                                        <span v-if="data.TA > 0" :class="MarginCal(data.WLA,data.TA,data.ISOC) < 0? 'negative-number': 'positive-number'">{{ formatNumber(MarginCal(data.WLA,data.TA,data.ISOC), 2, "") }}%</span>
                                        <span class="" v-else>-</span>
                                    </span>
                                    <span v-if="header == 'Bonus' && withBonus()" :class="data.B >= 0? 'positive-number': 'negative-number'">
                                        <font v-if="withWE1POKER()">{{ formatNumber(data.B, 4, "") }}</font>
                                        <font v-else>{{ formatNumber(data.B, 2, data.ISOC, false) }}</font>
                                    </span>
                                    <span v-if="header == 'Jackpot' && withJackpot()" :class="CheckWinLoss(data.WLA,data.RS,data.J)">
                                        {{ formatNumber(data.J, 2, data.ISOC, false) }}
                                    </span>
                                    <span v-if="header == 'ProviderWL' && data.GPI != 55" :class="CheckWinLoss(data.WLA,data.RS,data.PWL)">
                                        <font v-if="withWE1POKER()">{{ formatNumber(displayGameResult(data.PWL, data.RS), 4, "" ) }}</font>
                                        <font v-else>{{ formatNumber(displayGameResult(data.PWL, data.RS), 2, data.ISOC, false) }}</font>
                                    </span>
                                    <span v-if="header == 'CompanyWL' && data.GPI != 55" :class="CheckWinLoss(data.WLA,data.RS,data.WWL)">
                                        <font v-if="withWE1POKER()">{{ formatNumber(displayGameResult(data.WWL, data.RS), 4, "") }}</font>
                                        <font v-else>{{ formatNumber(displayGameResult(data.WWL, data.RS), 2, data.ISOC, false) }}</font>
                                    </span>
                                    <span v-if="header == 'SMWL' && getUserInfo.AT == 0 && data.GPI != 55" :class="CheckWinLoss(data.WLA,data.RS,data.SAWL)">
                                        <font v-if="withWE1POKER()">{{ formatNumber(displayGameResult(data.SAWL, data.RS), 4, "") }}</font>
                                        <font v-else>{{ formatNumber(displayGameResult(data.SAWL, data.RS), 2, data.ISOC, false) }}</font>
                                    </span>
                                    <span v-if="header == 'MAWL' && getUserInfo.AT <= 1 && data.GPI != 55" :class="CheckWinLoss(data.WLA,data.RS,data.MAWL)">
                                        <font v-if="withWE1POKER()">{{ formatNumber(displayGameResult(data.MAWL, data.RS), 4, "") }}</font>
                                        <font v-else>{{ formatNumber(displayGameResult(data.MAWL, data.RS), 2, data.ISOC, false) }}</font>
                                    </span>
                                    <span v-if="header == 'AGWL' && getUserInfo.AT <= 2 && data.GPI != 55" :class="CheckWinLoss(data.WLA,data.RS,data.AWL)">
                                        <font v-if="withWE1POKER()">{{ formatNumber(displayGameResult(data.AWL, data.RS), 4, "") }}</font>
                                        <font v-else>{{ formatNumber(displayGameResult(data.AWL, data.RS), 2, data.ISOC, false) }}</font>
                                    </span>
                                    <template v-else-if="header == 'Share'">
                                        <span v-if="data.D != ''">-</span>
                                        <span v-else-if="data.GPI == 55">0.00/0.00/0.00/0.00/0.00</span>
                                        <span v-else>
                                            <span :class="data.PTPS == 0 ?  'balanceflash': ''">{{ formatPT(data) }}</span>
                                        </span>
                                    </template>
                                    <span v-if="header == 'IP'">
                                        {{ data.MIP }}
                                    </span>
                                </td>
                            </tr>

                            <!-- N2 Details -->
                            <template v-if="reportType=='N2' && data.bool_showDetails">
                                <template v-if="data.DT != 1 && data.DT != 3">
                                    <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg n2-subitem">
                                        <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                            <template v-if="header == 'Game'">
                                                <span v-html="cdata.D"></span>
                                            </template>
                                            <template v-else-if="header == 'Result'">
                                                <span v-html="cdata.BD"></span>
                                            </template>
                                            <template v-else-if="header == 'BetAmount'">
                                                {{ formatNumber(cdata.BA, 2, data.ISOC, false) }}
                                            </template>
                                            <template v-else-if="header == 'CurrencyRate'">
                                                {{ data.ISOC }}
                                            </template>
                                            <template v-else-if="header == 'MemberWL'">
                                                <span :class="cdata.WLA >= 0? 'positive-number': 'negative-number'" class="tableCtnRight d-block">{{ formatNumber(cdata.WLA, 2, data.ISOC, false) }}</span>
                                            </template>
                                        </td>
                                    </tr>
                                </template>
                                <template v-if="data.DT == 1">
                                    <tr class="bd-head-bg n2-subitem">
                                        <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                            <template v-if="header == 'BetID'">
                                                {{getLanguage['BETRPT']['BI']}}
                                            </template>
                                            <template v-else-if="header == 'Game'">
                                                {{getLanguage['WLRPT']['ST']}}
                                            </template>
                                            <template v-else-if="header == 'BetTime'">
                                                {{getLanguage['WLRPT']['HD']}}
                                            </template>
                                            <template v-else-if="header == 'Result'">
                                                {{getLanguage['WLRPT']['CAT']}}
                                            </template>
                                            <template v-else-if="header == 'BalanceBefore'">
                                                {{getLanguage['WLRPT']['CT']}}
                                            </template>
                                            <template v-else-if="header == 'Turnover'">
                                                {{getLanguage['WLRPT']['DH']}}
                                            </template>
                                            <template v-else-if="header == 'BetAmount'">
                                                {{getLanguage['BETRPT']['BA']}}
                                            </template>
                                            <template v-else-if="header == 'Currency'">
                                                {{getLanguage['MEM']['CI']}}
                                            </template>
                                            <template v-else-if="header == 'MemberWL'">
                                                {{getLanguage['BETRPT']['WL']}}
                                            </template>
                                        </td>
                                    </tr>
                                    <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg n2-subitem">
                                        <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                            <template v-if="header == 'BetID'">
                                                {{cdata.BID}}
                                            </template>
                                            <template v-else-if="header == 'Game'">
                                                {{cdata.CBD.S}}
                                            </template>
                                            <template v-else-if="header == 'BetTime'">
                                                {{cdata.CBD.H}}
                                            </template>
                                            <template v-else-if="header == 'Result'">
                                                {{cdata.CBD.C}}
                                            </template>
                                            <template v-else-if="header == 'BalanceBefore'">
                                                <span v-html="cdata.CBD.CT"></span>
                                            </template>
                                            <template v-else-if="header == 'Turnover'">
                                                <span v-if="cindex == 0" :rowspan="data.BTDESCR.length" v-html="cdata.CBD.DH"></span>
                                            </template>
                                            <template v-else-if="header == 'BetAmount'">
                                                <span class="tableCtnRight d-block">{{ formatNumber(cdata.BA, 2, data.ISOC, false) }}</span>
                                            </template>
                                            <template v-else-if="header == 'Currency'">
                                                {{ data.ISOC }}
                                            </template>
                                            <template v-else-if="header == 'MemberWL'">
                                                <span :class="cdata.WLA >= 0? 'positive-number': 'negative-number'" class="tableCtnRight d-block">{{ formatNumber(cdata.WLA, 2, data.ISOC, false) }}</span>
                                            </template>
                                        </td>
                                    </tr>
                                </template>
                                <template v-if="data.DT == 3">
                                    <template v-for="(cdata, cindex) in data.BTDESCR">
                                        <tr v-if="cdata.TYPE == 1" class="bd-bg n2-subitem">
                                            <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                                <template v-if="header == 'Game'">
                                                    {{cdata.CBD.S}}
                                                </template>
                                                <template v-else-if="header == 'Result'">
                                                    <span v-html="cdata.CBD.CD"></span>
                                                </template>
                                            </td>
                                        </tr>
                                        <tr v-if="cdata.TYPE == 0" class="bd-head-bg n2-subitem">
                                            <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                                <template v-if="header == 'Result'">
                                                    {{getLanguage['WLRPT']['CAT']}}
                                                </template>
                                                <template v-else-if="header == 'BetAmount'">
                                                    <span class="tableCtnRight d-block">{{getLanguage['BETRPT']['BA']}}</span>
                                                </template>
                                                <template v-else-if="header == 'MemberWL'">
                                                    <span class="tableCtnRight d-block">{{getLanguage['BETRPT']['WL']}}</span>
                                                </template>
                                            </td>
                                        </tr>
                                        <tr v-if="cdata.TYPE == 2" class="bd-bg n2-subitem">
                                            <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                                <template v-if="header == 'Result'">
                                                    {{ cdata.BD }}
                                                </template>
                                                <template v-else-if="header == 'BetAmount'">
                                                    <span class="tableCtnRight d-block">{{ formatNumber(cdata.BA, 2, data.ISOC, false) }}</span>
                                                </template>
                                                <template v-else-if="header == 'MemberWL'">
                                                    <span :class="cdata.WLA == 0? '': cdata.WLA > 0 ? 'positive-number': 'negative-number'" class="tableCtnRight d-block">{{ formatNumber(cdata.WLA, 2, data.ISOC, false) }}</span>
                                                </template>
                                            </td>
                                        </tr>
                                    </template>
                                </template>
                            </template>
                            <!-- AFB1188 Details -->
                            <template v-if="reportType=='AFB1188' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg afb1188-subitem">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'BetID'">
                                            {{ cdata.BID}}
                                        </template>
                                        <template v-else-if="header == 'Result'">
                                            <span v-html="renderGameResult(cdata.BD, cdata)"></span>
                                        </template>
                                        <template v-else-if="header == 'Game'">
                                            <span v-html="getGameName(cdata.GD)"></span>
                                        </template>
                                        <template v-else-if="header == 'MemberWL'">
                                            <span class="tableCtnRight d-block" v-html="renderAFBWL(cdata.CBD.res)"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- GGCS Details -->
                            <template v-if="(reportType=='GGCORRECTSCORE'||reportType=='MINI_SPORTS') && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg afb1188-subitem">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'BetID'">
                                            {{ cdata.BID}}
                                        </template>
                                        <template v-else-if="header == 'Result'">
                                            <span v-html="renderGameResult(cdata.BD, cdata)"></span>
                                        </template>
                                        <template v-else-if="header == 'Game'">
                                            <span v-html="getGameName(cdata.GD)"></span>
                                        </template>
                                        <template v-else-if="header == 'MemberWL'">
                                            <span class="tableCtnRight d-block" v-html="renderAFBWL(cdata.CBD.res)"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- SBO SPORTS Details -->
                            <template v-if="reportType=='SBO_SPORTSBOOK' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg afb1188-subitem">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'BetID'">
                                            {{ cdata.BID}}
                                        </template>
                                        <template v-else-if="header == 'Game'">
                                            <span v-html="getGameName(cdata.GD)"></span>
                                        </template>
                                        <template v-else-if="header == 'Result'">
                                            <span v-html="renderGameResult(cdata.BD, cdata)"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- SABA SPORTS Details -->
                            <template v-if="reportType=='SABA_SPORTSBOOK' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg afb1188-subitem">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'BetID'">
                                            <span v-html="cdata.BID"></span>
                                        </template>
                                        <template v-else-if="header == 'Result'">
                                            <span v-html="renderGameResult(cdata.BD, cdata)"></span>
                                        </template>
                                        <template v-else-if="header == 'Game'">
                                            <span v-html="getGameName(cdata.GD)"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- TFG_ESPORTS Details -->
                            <template v-if="(reportType=='TFG_ESPORTS' || reportType=='TFG_ESPORTS_SPORTS') && data.bool_showDetails && data.DT == 1">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg tfg-subitem">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'BetID'">
                                            {{ cdata.BID}}
                                        </template>
                                        <template v-else-if="header == 'Result'">
                                            <span v-html="renderGameResult(cdata.BD, cdata)"></span>
                                        </template>
                                        <template v-else-if="header == 'Game'">
                                            <span v-html="getGameName(cdata.GD)"></span>
                                        </template>
                                        <template v-else-if="header == 'MemberWL'">
                                            <span class="tableCtnRight d-block">{{ cdata.CBD}}</span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- PGSOFT Details -->
                            <template v-if="reportType=='PGSOFT' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.PGSOFTCHILD" class="bd-bg pgsoft-subitem">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Brand'">
                                            {{ cdata.PTI}}
                                        </template>
                                        <template v-else-if="header == 'BetID'">
                                            {{ cdata.TI}}
                                        </template>
                                        <template v-else-if="header == 'Result'">
                                        </template>
                                        <template v-else-if="header == 'Game'">
                                            <span v-html="getGameName(cdata.GD)"></span>
                                        </template>
                                        <template v-else-if="header == 'MemberWL'">
                                            <span :class="cdata.WLA == 0? '': cdata.WLA > 0 ? 'positive-number': 'negative-number'" class="tableCtnRight d-block">{{ formatNumber(cdata.WLA, 2, data.ISOC, false) }}</span>
                                        </template>
                                        <template v-else-if="header == 'ProviderWL' && getUserInfo.AT <= 1 && searchGameProviderId.length >= 1 && !searchGameProviderId.includes('55')">
                                            <span :class="cdata.JP == 0? '': cdata.JP > 0 ? 'positive-number': 'negative-number'" class="tableCtnRight d-block">{{ formatNumber(cdata.JP, 2, data.ISOC, false) }}</span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- PGSOFT_THB_SLOT Details -->
                            <template v-if="reportType=='PGSOFT_THB_SLOT' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.PGSOFT_THB_SLOTCHILD" class="bd-bg pgsoftthb-subitem">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Brand'">
                                            {{ cdata.PTI}}
                                        </template>
                                        <template v-else-if="header == 'BetID'">
                                            {{ cdata.TI}}
                                        </template>
                                        <template v-else-if="header == 'Result'">
                                            <span @click="PGSOFT_THB_SLOTgameResult(cdata)"></span>
                                        </template>
                                        <template v-else-if="header == 'Game'">
                                            <span v-html="getGameName(cdata.GD)"></span>
                                        </template>
                                        <template v-else-if="header == 'MemberWL'">
                                            <span :class="cdata.WLA == 0? '': cdata.WLA > 0 ? 'positive-number': 'negative-number'" class="tableCtnRight d-block">{{ formatNumber(cdata.WLA, 2, data.ISOC, false) }}</span>
                                        </template>
                                        <template v-else-if="header == 'ProviderWL' && getUserInfo.AT <= 1 && searchGameProviderId.length >= 1 && !searchGameProviderId.includes('55')">
                                            <span :class="cdata.JP == 0? '': cdata.JP > 0 ? 'positive-number': 'negative-number'" class="tableCtnRight d-block">{{ formatNumber(cdata.JP, 2, data.ISOC, false) }}</span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- PS Details -->
                            <!--<template v-if="reportType=='PS' && data.bool_showDetails">
                                <tr class="bd-bg ps-subitem">
                                    <td v-if="data.RURL!=''" colspan="100%" v-html="data.RURL">
                                    </td>
                                    <td v-else colspan="100%">
                                        {{ //this.getLanguage['BETRPT']['SPRD'] }}
                                    </td>
                                </tr>
                            </template>-->
                            <!-- GD88 Details -->
                            <template v-if="reportType=='DIAMONDCLUB' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg  diamondclub-subitem">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Game'">
                                            <span v-html="renderGameResult(cdata.D, cdata)"></span>
                                        </template>
                                        <template v-else-if="header == 'Result'">
                                            <span v-html="renderGameResult(cdata.BD, cdata)"></span>
                                        </template>
                                        <template v-else-if="header == 'BetAmount'">
                                            <span class="tableCtnRight d-block">{{ formatNumber(cdata.BA, 2, data.ISOC, false) }}</span>
                                        </template>
                                        <template v-else-if="header == 'CurrencyRate'">
                                            {{ data.ISOC }}
                                        </template>
                                        <template v-else-if="header == 'MemberWL'">
                                            {{ renderGD88WL(cdata.GD) }}
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- CQ9 Details -->
                            <template v-if="reportType=='CQ9_CASINO' && data.bool_showDetails && data.DT == 0">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Result'">
                                            {{ utilGetErrorLanguage('WLRPT_CQ9.' + cdata.BD) }}
                                        </template>
                                    </td>
                                </tr>
                                <tr class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Result'">
                                            <span @click="gameResultDetailOnClick(data)" v-html="renderGameResult(cdata.RURL, data, true)"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- EVOPLAY Details -->
                            <template v-if="reportType=='EVOPLAY_CASINO' && data.bool_showDetails && data.DT == 0">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Result'">
                                            <span v-if="data.GN == 967">{{ utilGetErrorLanguage('WLRPT_EVO.' + cdata.BD) }}</span>
                                            <span v-if="data.GN == 748">{{ cdata.BD }}</span>
                                            <span v-if="data.GN == 745">{{ cdata.BD }}</span>
                                            <span v-if="data.GN == 751">{{ cdata.BD }}</span>
                                            <span v-if="data.GN == 946">{{ cdata.BD }}</span>
                                            <span v-if="data.GN == 1006">{{ cdata.BD }}</span>
                                            <span v-if="data.GN == 1009">{{ cdata.BD }}</span>
                                            <span v-if="data.GN == 5553">{{ cdata.BD }}</span>
                                            <span v-if="data.GN == 5669">{{ cdata.BD }}</span>
                                            <span v-if="data.GN == 5679">{{ cdata.BD }}</span>
                                        </template>
                                        <template v-else-if="header == 'BetAmount'">
                                            <span class="tableCtnRight d-block">{{ formatNumber(cdata.BA, 2, data.ISOC, false) }}</span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- WM Details -->
                            <template v-if="reportType=='WM' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'BetID'">
                                            <span>{{ cdata.BID }}</span>
                                        </template>
                                        <template v-if="header == 'Result'">
                                            <span v-html="renderGameResult(cdata.BD, cdata)"></span>
                                        </template>
                                        <template v-else-if="header == 'BetAmount'">
                                            <span class="tableCtnRight d-block">{{ formatNumber(cdata.BA, 2, data.ISOC, false) }}</span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- 93Connect Details -->
                            <template v-if="reportType=='CONNECT93' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Result'">
                                            <span v-html="renderGameResult(cdata.BD, cdata)"></span>
                                        </template>
                                        <template v-else-if="header == 'BetAmount'">
                                            <span class="tableCtnRight d-block">{{ formatNumber(cdata.BA, 2, data.ISOC, false) }}</span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- AESEXY Details -->
                            <template v-if="reportType=='AESEXY' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Result'">
                                            <span v-html="renderGameResult(cdata.BD, cdata)"></span>
                                        </template>
                                        <template v-else-if="header == 'BetAmount'">
                                            <span class="tableCtnRight d-block">{{ formatNumber(cdata.BA, 2, data.ISOC, false) }}</span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- SV388 Details -->
                            <template v-if="reportType=='SV388' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Result'">
                                            <span v-html="renderGameResult(cdata.BD, cdata)"></span>
                                        </template>
                                        <template v-else-if="header == 'BetAmount'">
                                            <span class="tableCtnRight d-block">{{ formatNumber(cdata.BA, 2, data.ISOC, false) }}</span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- CF361 Details -->
                            <template v-if="reportType=='CF361' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Result'">
                                            <span v-html="renderGameResult(cdata.BD, cdata)"></span>
                                        </template>
                                        <template v-else-if="header == 'MemberWL'">
                                            <span :class="cdata.WLA >= 0? 'positive-number': 'negative-number'" class="tableCtnRight d-block">{{ formatNumber(cdata.WLA, 2, data.ISOC, false) }}</span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- SA Details -->
                            <template v-if="reportType=='SA' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Result'">
                                            <span v-html="renderGameResult(cdata.BD, cdata)"></span>
                                        </template>
                                        <template v-else-if="header == 'BetAmount'">
                                            <span class="tableCtnRight d-block">{{ formatNumber(cdata.BA, 2, data.ISOC, false) }}</span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- TGA Details -->
                            <template v-if="reportType=='AFBCASINO' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Result'">
                                            <span v-html="renderGameResult(cdata.BD, cdata)"></span>
                                        </template>
                                        <template v-else-if="header == 'BetAmount'">
                                            <span class="tableCtnRight d-block">{{ formatNumber(cdata.BA, 2, data.ISOC, false) }}</span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- LIGATOGEL Details -->
                            <template v-if="reportType=='LIGATOGEL' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Game'">
                                            <span v-html="getGameName(cdata.BD)"></span>
                                        </template>
                                        <template v-else-if="header == 'BetAmount'">
                                            <span class="tableCtnRight d-block">{{ formatNumber(cdata.BA, 2, data.ISOC, false) }}</span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- AFB288 Details -->
                            <template v-if="reportType=='AFB288_LOTTERY' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Result'">
                                            <span v-html="renderGameResult(cdata.BD, cdata)"></span>
                                        </template>
                                        <template v-else-if="header == 'BetAmount'">
                                            <span class="tableCtnRight d-block">{{ formatNumber(cdata.BA, 2, data.ISOC, false) }}</span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- DG Details -->
                            <template v-if="reportType=='DREAMGAME' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Game'">
                                            <span v-html="cdata.D"></span>
                                        </template>
                                        <template v-else-if="header == 'Result'">
                                            <span v-html="renderGameResult(cdata.BD, cdata)"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- AFB GAMING Details -->
                            <template v-if="(reportType=='AFBGAMING' || reportType=='AFBGAMING_FISHING' || reportType=='AFBGAMING_E_CASINO') && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Result'">
                                            <span @click="gameResultDetailOnClick(cdata.TI)"><a href="#"> {{getLanguage["WLRPT"]["VT"]}}</a></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- LUCKY361 Details -->
                            <template v-if="reportType=='LUCKY361_SLOT' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Result'">
                                            <span @click="gameResultDetailOnClick(cdata.TI)"><a href="#"> {{getLanguage["WLRPT"]["VT"]}}</a></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- EACASINO Details -->
                            <template v-if="reportType=='EACASINO' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg n2-subitem">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'BetID'">
                                            {{ cdata.BID}}
                                        </template>
                                        <template v-if="header == 'Game'">
                                            {{ cdata.GD}}
                                        </template>
                                        <template v-else-if="header == 'Result'">
                                            <span v-html="cdata.BD"></span>
                                        </template>
                                        <template v-else-if="header == 'BetAmount'">
                                            <span class="tableCtnRight d-block">{{ formatNumber(cdata.BA, 2, data.ISOC, false) }}</span>
                                        </template>
                                        <template v-else-if="header == 'MemberWL'">
                                            <span :class="cdata.WLA >= 0? 'positive-number': 'negative-number'" class="tableCtnRight d-block">{{ formatNumber(cdata.WLA, 2, data.ISOC, false) }}</span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- Spinomenal Slot Details -->
                            <template v-if="(reportType=='SPINOMENAL_SLOT' || reportType=='SPINOMENAL_LOTTERY') && data.bool_showDetails">
                                <tr v-if="cdata.TI != data.TI" v-for="(cdata, cindex) in data.SPINOMENALCHILD" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'BetID'">
                                            {{ cdata.TI}}
                                        </template>
                                        <template v-else-if="header == 'Result'">
                                            <span v-if="cdata.URL!='' && cdata.URL!=null " colspan="2"> <a :href="cdata.URL" target="_blank"> {{getLanguage["WLRPT"]["VT"]}}</a></span>
                                            <span v-else @click="openSpinomenalDetails(cdata)"> <a href="#"> {{getLanguage["WLRPT"]["VT"]}}</a></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- EVOLUTION Details -->
                            <template v-if="reportType=='EVOLUTION_CASINO' && data.bool_showDetails && data.DT == 0">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Game'">
                                            <span v-html="cdata.D"></span>
                                        </template>
                                        <template v-else-if="header == 'Result'">
                                            <span v-html="cdata.BD"></span>
                                        </template>
                                        <template v-else-if="header == 'BetAmount'">
                                            <span class="tableCtnRight d-block" v-if="data.GN == 'MegaBall00000001' && cindex == 0 || data.GN !== 'MegaBall00000001'">{{ formatNumber(cdata.BA, 2, data.ISOC, false) }}</span>
                                        </template>
                                        <template v-else-if="header == 'MemberWL'">
                                            <span :class="cdata.WLA == 0? '': cdata.WLA > 0 ? 'positive-number': 'negative-number'" class="tableCtnRight d-block" v-if="data.GN == 'MegaBall00000001' && cindex == 0 || data.GN !== 'MegaBall00000001'">{{ formatNumber(cdata.WLA, 2, data.ISOC, false) }}</span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- WE1POKER Details -->
                            <template v-if="reportType=='WE1POKER' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg n2-subitem">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'BetID'">
                                            {{ cdata.BID}}
                                        </template>
                                        <template v-if="header == 'Game'">
                                            {{ cdata.GD}}
                                        </template>
                                        <template v-else-if="header == 'Result'">
                                            <span v-html="cdata.BD"></span>
                                        </template>
                                        <template v-else-if="header == 'BetAmount'">
                                            <span class="tableCtnRight d-block">{{ formatNumber(cdata.BA, 2, data.ISOC, false) }}</span>
                                        </template>
                                        <template v-else-if="header == 'MemberWL'">
                                            <span :class="cdata.WLA >= 0? 'positive-number': 'negative-number'" class="tableCtnRight d-block">{{ formatNumber(cdata.WLA, 2, data.ISOC, false) }}</span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- AFBPOKER Details -->
                            <template v-if="reportType=='AFBPOKER' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg n2-subitem">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'BetID'">
                                            {{ cdata.BID}}
                                        </template>
                                        <template v-if="header == 'Game'">
                                            {{ cdata.GD}}
                                        </template>
                                        <template v-else-if="header == 'BetTime'">
                                            {{ formatDateTime(cdata.GTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss", true) }}
                                        </template>
                                        <template v-else-if="header == 'EndTime'">
                                            {{ formatDateTime(cdata.RTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss", true) }}
                                        </template>
                                        <template v-else-if="header == 'Result'">
                                            <span v-html="cdata.BD"></span>
                                        </template>
                                        <template v-else-if="header == 'BetAmount'">
                                            <span class="tableCtnRight d-block">{{ formatNumber(cdata.BA, 2, data.ISOC, false) }}</span>
                                        </template>
                                        <template v-else-if="header == 'MemberWL'">
                                            <span :class="cdata.WLA >= 0? 'positive-number': 'negative-number'" class="tableCtnRight d-block">{{ formatNumber(cdata.WLA, 2, data.ISOC, false) }}</span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- SIMPLE PLAY SLOT Details -->
                            <template v-if="reportType=='SIMPLEPLAY_SLOT' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'BetID'">
                                            {{ cdata.BID}}
                                        </template>
                                        <template v-else-if="header == 'Result'">
                                            <span @click="openSimplePlayDetails(cdata)"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- SIMPLE PLAY E CASINO Details -->
                            <template v-if="reportType=='SIMPLEPLAY_E_CASINO' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'BetID'">
                                            {{ cdata.BID}}
                                        </template>
                                        <template v-else-if="header == 'Result'">
                                            <span v-html="renderGameResult(cdata.BD, cdata)"></span>
                                        </template>
                                        <template v-else-if="header == 'BetAmount'">
                                            <span class="tableCtnRight d-block">{{ formatNumber(cdata.BA, 2, data.ISOC, false) }}</span>
                                        </template>
                                        <template v-else-if="header == 'MemberWL'">
                                            <span :class="cdata.WLA >= 0? 'positive-number': 'negative-number'" class="tableCtnRight d-block">{{ formatNumber(cdata.WLA, 2, data.ISOC, false) }}</span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- EBET Details -->
                            <template v-if="reportType=='EBET' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg n2-subitem">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'BetID'">
                                            {{ cdata.BID}}
                                        </template>
                                        <template v-if="header == 'Game'">
                                            {{ cdata.GD}}
                                        </template>
                                        <template v-else-if="header == 'Result'">
                                            <span v-html="cdata.BD"></span>
                                        </template>
                                        <template v-else-if="header == 'BetAmount'">
                                            <span class="tableCtnRight d-block">{{ formatNumber(cdata.BA, 2, data.ISOC, false) }}</span>
                                        </template>
                                        <template v-else-if="header == 'MemberWL'">
                                            <span :class="cdata.WLA >= 0? 'positive-number': 'negative-number'" class="tableCtnRight d-block">{{ formatNumber(cdata.WLA, 2, data.ISOC, false) }}</span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- SIMPLE PLAY FISHING Details -->
                            <template v-if="reportType=='SIMPLEPLAY_FISHING' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Result'">
                                            <span v-html="renderGameResult(cdata.BD, cdata)"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- CG Details -->
                            <template v-if="(reportType=='CG' || reportType=='CG_FISHING' || reportType=='CG_VIRTUAL_CASINO' || reportType=='CG_E_CASINO') && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg n2-subitem">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'BetID'">
                                            {{ cdata.BID}}
                                        </template>
                                        <template v-else-if="header == 'Result'">
                                            <span v-html="cdata.BD"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- POKERV Details -->
                            <template v-if="(reportType=='POKERV') && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg n2-subitem">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'BetID'">
                                            {{ cdata.BID}}
                                        </template>
                                        <template v-else-if="header == 'Result'">
                                            <span v-html="cdata.BD"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- LG88 Details -->
                            <template v-if="reportType=='LG88' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Result'">
                                            <span v-html="lg88RenderDetail(cdata.CBD)"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- YGGDRASIL Details -->
                            <template v-if="(reportType=='YGGDRASIL' || reportType=='YGGDRASIL_E_CASINO') && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Result'">
                                            <span v-html="cdata.BD"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- PNG_SLOT Details -->
                            <template v-if="reportType=='PNG_SLOT' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Result'">
                                            <span v-html="cdata.BD"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- AUX_SLOT Details -->
                            <template v-if="reportType=='AUX_SLOT' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Result'">
                                            <span v-html="cdata.BD"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- GHG_SLOT Details -->
                            <template v-if="reportType=='GHG_SLOT' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Result'">
                                            <span v-html="cdata.BD"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- NLC_SLOT Details -->
                            <template v-if="reportType=='NLC_SLOT' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Result'">
                                            <span v-html="cdata.BD"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- RELAX_SLOT && RELAX_E_CASINO Details -->
                            <template v-if="(reportType=='RELAX_SLOT' || reportType=='RELAX_E_CASINO') && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Result'">
                                            <span @click="gameResultDetailOnClick(data)" v-html="cdata.BD"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- RELAX_E_CASINO Details -->
                            <template v-if="reportType=='RELAX_E_CASINO' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Result'">
                                            <span v-html="cdata.BD"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- JILI Details -->
                            <template v-if="(reportType=='JILI_SLOT' || reportType=='JILI_FISHING' || reportType=='JILI_E_CASINO') && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Result'">
                                            <span @click="gameResultDetailOnClick(data)" v-html="cdata.BD"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- EVORacing Details -->
                            <template v-if="reportType=='EVO_RACING' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Result'">
                                            <span v-html="cdata.BD"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- EVORacingVR Details -->
                            <template v-if="reportType=='EVO_RACING_VR' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Result'">
                                            <span v-html="cdata.BD"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- ATA_EVOPLAY_SLOT Details -->
                            <template v-if="(reportType=='ATA_EVOPLAY_SLOT') && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Result'">
                                            <span @click="gameResultDetailOnClick(data)" v-html="cdata.BD"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- JOKER FISHING Details -->
                            <template v-if="(reportType=='JOKER_FISHING') && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Result'">
                                            <span @click="gameResultDetailOnClick(data)" v-html="cdata.BD"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- KINGMAKER Details -->
                            <template v-if="(reportType=='KINGMAKER_CASINO'|| reportType=='KINGMAKER_SLOTS') && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Result'">
                                            <span @click="gameResultDetailOnClick(data)" v-html="cdata.BD"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- YGR_SLOT Details -->
                            <template v-if="(reportType=='YGR_SLOT') && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Result'">
                                            <span @click="gameResultDetailOnClick(data)" v-html="cdata.BD"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- YGR FISHING Details -->
                            <template v-if="(reportType=='YGR_FISHING') && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Result'">
                                            <span @click="gameResultDetailOnClick(data)" v-html="cdata.BD"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- FACHAI SLOT Details -->
                            <template v-if="(reportType=='FACHAI_SLOT') && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Result'">
                                            <span @click="gameResultDetailOnClick(data)" v-html="cdata.BD"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- FACHAI FISHING Details -->
                            <template v-if="(reportType=='FACHAI_FISHING') && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Result'">
                                            <span @click="gameResultDetailOnClick(data)" v-html="cdata.BD"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- FACHAI E CASINO Details -->
                            <template v-if="(reportType=='FACHAI_E_CASINO') && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Result'">
                                            <span @click="gameResultDetailOnClick(data)" v-html="cdata.BD"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- ACE333 SLOT Details -->
                            <template v-if="(reportType=='ACE333_SLOT') && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'BetID'">
                                            <span @click="gameResultDetailOnClick(data)" v-html="cdata.BD"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- ACE333 E CASINO Details -->
                            <template v-if="(reportType=='ACE333_E_CASINO') && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'BetID'">
                                            <span @click="gameResultDetailOnClick(data)" v-html="cdata.BD"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- HABANERO Details -->
                            <template v-if="reportType=='HABANERO' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Game'">
                                            {{ cdata.D}}
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- JDB_SLOT & JDB_FISHING Details -->
                            <template v-if="reportType=='JDB_SLOT' || reportType=='JDB_FISHING' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Game'">
                                            {{ cdata.D}}
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- MIKIWORLD / AFB CARNIVAL LIVE CASINO Details -->
                            <template v-if="(reportType=='MIKIWORLD_CASINO' || reportType=='MIKIWORLD_E_CASINO') && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'BetID'">
                                            <span v-html="cdata.BD"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- Winfinity Details -->
                            <template v-if="(reportType=='WINFINITY_CASINO') && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'BetID'">
                                            <span>{{ cdata.BID }}</span>
                                        </template>
                                        <template v-if="header == 'Result'">
                                            <span @click="gameResultDetailOnClick(data)"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- 9Gaming Others Details -->
                            <template v-if="(reportType=='GAMING9_OTHERS') && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Result'">
                                            <span v-if="cdata.BD != null">{{cdata.BD}}</span>
                                        </template>
                                        <template v-else-if="header == 'BetAmount'">
                                            <span v-if="cdata.BA != null" class="tableCtnRight d-block">{{ formatNumber(cdata.BA, 2, data.ISOC, false)}}</span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- NEWKENO Details -->
                            <template v-if="reportType=='NEWKENO_LOTTERY' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Result'">
                                            <span v-html="renderGameResult(cdata.BD, cdata)"></span>
                                        </template>
                                        <template v-else-if="header == 'BetAmount'">
                                            <span class="tableCtnRight d-block">{{ formatNumber(cdata.BA, 2, data.ISOC, false) }}</span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- NEXTSPIN Details -->
                            <template v-if="(reportType=='NEXTSPIN_SLOT') && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'BetID'">
                                            <span v-html="cdata.BD"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- MG SLOT Details -->
                            <template v-if="(reportType=='MG_SLOT') && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'BetID'">
                                            <span v-html="cdata.BD"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- MG LIVE Details -->
                            <template v-if="(reportType=='MG_LIVE') && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'BetID'">
                                            <span v-html="cdata.BD"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- VPower Details -->
                            <template v-if="(reportType=='VPOWER') && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'BetID'">
                                            <span v-html="cdata.BD"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- Pretty Live Details -->
                            <template v-if="(reportType=='PRETTY_LIVE') && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'BetID'">
                                            <span @click="gameResultDetailOnClick(data)" v-html="cdata.BD"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- LIVE22 Details -->
                            <template v-if="(reportType=='LIVE22_SLOT'|| reportType=='LIVE22_E_CASINO') && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header" :class="[hideElement(header),['ProviderName','EventInfo','BalanceBefore','Bonus','Jackpot','BetAmount','CurrencyRate','Turnover','MemberWL','AWR','ProviderWL','CompanyWL','SMWL','MAWL','AGWL'].includes(header)?'tableCtnRight':'']">
                                        <template v-if="header == 'Result'">
                                            <span @click="gameResultDetailOnClick(data)" v-html="cdata.BD"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <!-- IBEX_SLOT Details -->
                            <!--<template v-if="(reportType=='IBEX_SLOT') && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td v-for="header in reportHeaders1" :key="header">
                                        <template v-if="header == 'Result'">
                                            <span @click="gameResultDetailOnClick(data)" v-html="cdata.BD"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>-->
                        </template>
                        </tbody>
                    </table>
                </div>

                <footer style=" padding: 0.57rem 0rem;" v-if="int_TP >= 2">
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </footer>
            </div>
        </div>
    </div>
</template>
<script>
    import { constWinLossType } from '@/modules/Constant.js'
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import Loading from 'vue-loading-overlay';
    import moment from "moment";
    import 'vue-loading-overlay/dist/vue-loading.css';
    import genericHelper from "@/modules/GenericHelper.js";
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import { mapGetters, mapActions } from 'vuex';
    import Vue from 'vue'
    import { constAccessType, constRejectReasonD } from '@/modules/Constant.js';
    //Vue.use(require('vue-shortkey'))
    import draggable from 'vuedraggable';
    import $ from 'jquery'

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
            draggable
        },
        data() {
            return {
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                bool_fullLoading: false,
                str_tableSortBy: "", //(sort the table col name)
                bool_isSort: false, // Table Ascending Descending
                bool_showSearchBar: true,
                // dropdown value
                ddAgentList: null,
                ddGameProviderList: null,
                ddWinLossTypeList: constWinLossType,
                ddMemberList: null,
                ddDefaultMemberList: null,
                // ddDefaultMemberTypeList: null,
                dd_userType: [],
                dd_subagentgroup: [],//subagent group option
                ddDefaultSubBrand: [],
                rtSubBrand: 0,
                // search fields
                searchAgi: "",
                searchAgent: null,
                searchUserId: null,
                searchUserType: null,
                searchUsername: null,
                searchGameProviderId: [],
                searchWinLossType: null,
                searchIsTester: null,
                searchBetId: null,
                searchVDP: null,
                searchFreeSpin: null,
                searchCashOut: null,
                searchCreatedTS: { startDate: this.getTodayDate(), endDate: this.getMonthEndDate() },
                searchSubAgent: null,
                arr_provider_reportList: {},
                arr_summary_reportList: [],
                reportType: "summary",
                skipPageUpdate: false,
                dd_memberKey: 0,
                memberName: "",
                DataLastUpdatedTS: "-",
                shareIndicator: "",
                constAccessType: constAccessType,
                str_summary_tableSortBy: "", //(sort summary table col name)
                bool_summary_isSort: true, // summary Table Ascending Descending
                defaultReportHeaders: ['Brand', 'UserID', 'BetCount', 'BetAmount', 'TurnoverAmount', 'MemberWL', 'AWR', 'AGWL', 'ProviderWL', 'CompanyWL', 'SMWL', 'MAWL', 'LTP', 'Share', 'Currency', 'No'],
                reportHeaders: [],
                needResetHeaders: false,
                defaultReportHeaders1: ['NO', 'Brand', 'UserID', 'BetID', 'ProviderName', 'Game', 'EventInfo', 'BetTime', 'Result', 'BalanceBefore', 'BetAmount', 'Turnover', 'MemberWL', 'AWR', 'EndTime', 'ProviderWL', 'CompanyWL', 'SMWL', 'MAWL', 'AGWL', 'Bonus', 'CurrencyRate', 'Currency', 'Jackpot', 'IP', 'Share'],
                reportHeaders1: [],
                needResetHeaders1: false,
                defaultReportHeaders2: ['NO', 'Brand', 'Currency', 'UserID', 'GameProvider', 'BetID', 'Game', 'BalanceBefore', 'BetAmount', 'BetTime', 'EndTime', 'Turnover', 'MemberWL', 'AWR', 'ProviderWL', 'CompanyWL', 'SMWL', 'MAWL', 'AGWL', 'Share', 'IP'],
                reportHeaders2: [],
                needResetHeaders2: false,
                ddCurrencyList: null,
                searchCurrency: null,
                bool_isFirstLoad: true,
                totalReport: null,
                allTotalReport: null,
                totalReport1: null,
                allTotalReport1: null,
                hideBrand: false,
                arry_vdp: [],
                arry_free_spin: [],
                arry_cash_out: [],
                disableSubDD: false,
                searchGameCategoryIds: null,
                providerCategories: {},
                backURL: null,
                searchRegisterSourceName: null,
                obj_Post: {
                    SelectedBrands1: null
                },
                bool_isDDMV: false,
                minStartDate: this.getMinStartDate()
            }
        },
        methods: {
            ...mapActions('UserInfo', ['setSearchCriteriaAGI']),
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchCreatedTS.startDate = dateObj;
                        if (dateObj < this.minStartDate) {
                            this.searchCreatedTS.startDate = this.minStartDate;
                        }
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.searchCreatedTS.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchCreatedTS.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.searchCreatedTS.endDate = "";
                    }
                }
            },
            getDropdownList() {
                this.arry_vdp = [{ id: "", label: this.getLanguage['GL']['ALL2'] }, { id: "1", label: this.getLanguage['GL']['YES'] }, { id: "0", label: this.getLanguage['GL']['NO'] }];
                this.arry_free_spin = [{ id: "0", label: this.getLanguage['GL']['ALL2'] }, { id: "1", label: this.getLanguage['GL']['YES'] }, { id: "2", label: this.getLanguage['GL']['NO'] }];
                this.arry_cash_out = [
                    {
                        id: 1,
                        value: '1',
                        label: this.getLanguage['GL']['YES'],  // Yes option
                    },
                    {
                        id: 0,
                        value: '0',
                        label: this.getLanguage['CNO']['NO'],  // No option
                    }
                ];
            },
            setSortSummaryTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_summary_tableSortBy = SV;
                this.bool_summary_isSort = !this.bool_summary_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getReportList();
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getReportList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            setSummarySortLogo(str_TF) {
                return `cil-${this.str_summary_tableSortBy == str_TF ? (this.bool_summary_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            loadAgentOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddAgentList = d.dropdownlist;
                        }
                        else {
                            that.ddAgentList = null;
                        }

                        callback();
                    });
            },
            selectAgentOptions(value, instanceId) {
                //if (value) {
                //    this.setSearchCriteriaAGI(value);
                //}
                //else {
                //    this.setSearchCriteriaAGI(null);
                //}

                //this.searchAgi = 0;
                //if (value) {
                //    var agentList = value.split("-");
                //    this.searchAgi = agentList[agentList.length - 1];
                //}
                this.searchUsername = null;
                this.searchUserId = null;
                this.ddMemberList = null;
                this.ddDefaultMemberList = null;
                this.dd_memberKey = 0;
                this.disableSubDD = false;
                var temp = "";
                for (var x = 0; x < value.length; x++) {
                    if (x != 0) {
                        temp += ",";
                    }
                    var split = value[x].split("-");

                    if (split.length == 2) {
                        temp += split[1];
                    }
                    else {
                        temp += split[0];
                    }
                }
                this.searchAgi = temp;

                if (value.length > 1) {
                    this.disableSubDD = true;
                }
                this.ddGameProviderList = null;
                this.selectGameProvider();
            },
            getWe1LastTotalPayment(data, getCSSClass = false) {
                var result = '';
                try {
                    //this.formatNumber(data.BCWLA, data.ISOC);
                    // var tempLTP = 0;
                    // tempLTP = data.WLA + data.AWL;
                    if (getCSSClass) {
                        if (data >= 0) {
                            result = "positive-number";
                        }
                        else {
                            result = "negative-number";
                        }
                    }
                    else {
                        result = this.formatNumber(data, 4, "");
                    }
                } catch (error) {
                    console.log(error);
                }
                return result;
            },
            selectGameProvider(value, instanceId) {                
                this.ddGameProviderList = null;
                var that = this;
                var agi = 0;
                if (this.searchAgent == null || this.searchAgi == "") {
                    agi = this.curAGI;
                }
                else {
                    agi = this.searchAgi;
                }

                this.getDataApi('/api/dd/game/prov/0/1/1/' + agi,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            // Initialize provider-to-category mapping
                            that.providerCategories = {};

                            for (var j = 0; j < d.dropdownlist.length; j++) {
                                var currentCategory = d.dropdownlist[j];
                                var categoryId = currentCategory.id.includes('-')
                                    ? currentCategory.id.split('-')[1]
                                    : currentCategory.id;

                                if (currentCategory.children != null && currentCategory.children.length > 0) {
                                    for (var l = 0; l < currentCategory.children.length; l++) {
                                        var provider = currentCategory.children[l];

                                        // Store category mapping (providerId -> categoryId)
                                        that.providerCategories[provider.id] = categoryId;

                                        // Original translation logic
                                        if (provider.label in that.getLanguage['GP']) {
                                            provider.RT = provider.label;
                                            provider.label = that.getLanguage['GP'][provider.label];
                                        }
                                    }
                                }
                            }

                            that.ddGameProviderList = that.appendSelectAllOption(d.dropdownlist);                            
                        }
                        else {
                            that.ddGameProviderList = null;
                        }
                    });                
            },

            setReportType() {
                this.arr_provider_reportList = {};
                var previousReportType = this.reportType;
                this.reportType = 'summary';
                this.showSummary = true;                

                if (this.searchUserId && this.searchGameProviderId && this.searchGameProviderId.length == 1) {
                                      
                    if (this.searchUserId && this.ddGameProviderList) {                        
                        for (var i = 0; i < this.ddGameProviderList.length; i++) {
                            for (var j = 0; j < this.ddGameProviderList[i].children.length; j++) {
                                for (var k = 0; k < this.ddGameProviderList[i].children[j].children.length; k++) {
                                    if (this.ddGameProviderList[i].children[j].children[k].id == this.searchGameProviderId[0]) {
                                        this.reportType = this.ddGameProviderList[i].children[j].children[k].RT;                                        
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                else if (this.searchUserId) {
                    this.reportType = 'MemberSummary';
                    this.getMemberName();
                    this.showSummary = false;
                }                                

                if (this.reportType != previousReportType) {
                    this.str_tableSortBy = "";
                }
            },
            loadGameProviderOptions({ action, callback, instanceId }) {
                var that = this;

                this.getDataApi('/api/dd/game/prov/0/1/1/' + this.curAGI,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            for (var j = 0; j < d.dropdownlist.length; j++) {
                                d.dropdownlist[j].label = that.renderCategory(d.dropdownlist[j].id.slice(d.dropdownlist[j].id.indexOf('-') + 1));
                                if (d.dropdownlist[j].children != null && d.dropdownlist[j].children.length > 0) {
                                    for (var l = 0; l < d.dropdownlist[j].children.length; l++) {
                                        if (d.dropdownlist[j].children[l].label in that.getLanguage['GP']) {
                                            d.dropdownlist[j].children[l].RT = d.dropdownlist[j].children[l].label;
                                            d.dropdownlist[j].children[l].label = that.getLanguage['GP'][d.dropdownlist[j].children[l].label];
                                        }
                                    }

                                }
                            }

                            that.ddGameProviderList = that.appendSelectAllOption(d.dropdownlist);
                        }
                        else {
                            that.ddGameProviderList = null;
                        }
                        callback();
                        //if (that.searchGameProviderId > 0) {
                        //    that.selectGameProvider(that.searchGameProviderId);
                        //}
                    });
            },
            renderCategory(id) {
                return this.getLanguage["GC"][id];
            },
            getCategory() {
                var that = this;
                this.getDataApi('/api/dd/game/prov/0/1/1',
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            for (var j = 0; j < d.dropdownlist.length; j++) {
                                d.dropdownlist[j].label = that.renderCategory(d.dropdownlist[j].id.slice(d.dropdownlist[j].id.indexOf('-') + 1));
                                if (d.dropdownlist[j].children != null && d.dropdownlist[j].children.length > 0) {
                                    for (var l = 0; l < d.dropdownlist[j].children.length; l++) {
                                        if (d.dropdownlist[j].children[l].label in that.getLanguage['GP'])
                                            d.dropdownlist[j].children[l].label = that.renderProviderName(d.dropdownlist[j].children[l].label);
                                    }

                                }
                            }

                            that.ddGameProviderList = that.appendSelectAllOption(d.dropdownlist);
                        }
                        else {
                            that.ddGameProviderList = null;
                        }
                        callback();
                    });
            },
            ctrPage(newPage, inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getReportList(false);
            },
            newSearch() {
                this.$refs.search.focus();
                this.int_Page = 1;
                this.int_IC = 1;
                if (this.searchCreatedTS) {
                    if (this.searchCreatedTS.startDate != "") {
                        var z = this.set90daysDateSearch(this.searchCreatedTS.startDate);
                        if (z == true) {
                            return;
                        }
                    }
                }
                this.setReportType();
                this.getReportList();
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            CheckingMember(agi, mi) {
                let routeData = this.$router.resolve({ path: '/M/ML/CheckingMember', query: { agi: agi, i: mi } });
                window.open(routeData.href, '_blank');
            },
            getbgtooltip(data) {
                var bgColor = '#FFF';
                var textColor = '#000';
                if (data) {
                    if (data.TBC) {
                        bgColor = data.TBC;
                    }

                    if (data.TC) {
                        textColor = data.TC;
                    }
                }
                return {
                    backgroundColor: bgColor, color: textColor, padding: '0px 5px', borderRadius: '5px'
                };
            },
            getReportList(loadGrandTotal = true) {
                if (this.reportType != null) {                    
                    this.bool_fullLoading = true;
                    var that = this;
                    //var agentGId = null;

                    //if (this.searchAgi > 0) {
                    //    agentGId = this.searchAgi;
                    //}
                    sessionStorage.setItem('WINLV2_FilterAGI', '');
                    sessionStorage.setItem('WINLV2_FilterAgent', '');
                    sessionStorage.setItem('WINLV2_FilterMI', '');
                    sessionStorage.setItem('WINLV2_FilterBI', '');
                    sessionStorage.setItem('WINLV2_FilterCO', '');
                    sessionStorage.setItem('WINLV2_FilterGPI', '');
                    sessionStorage.setItem('WINLV2_FilterWLT', '');
                    sessionStorage.setItem('WINLV2_FilterSTS_from', '');
                    sessionStorage.setItem('WINLV2_FilterSTS_to', '');
                    sessionStorage.setItem('WINLV2_FilterITU', '');
                    sessionStorage.setItem('WINLV2_FilterVDP', '');
                    sessionStorage.setItem('WINLV2_FilterFreeSpin', '');
                    sessionStorage.setItem('WINLV2_FilterCI', '');
                    sessionStorage.setItem('WINLV2_FilterSAGI', '');

                    if (that.reportType != "summary") {
                        var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                    }
                    else {
                        var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_summary_tableSortBy, this.bool_summary_isSort);

                    }
                    var hasDefaultPath = false;

                    if (path) {
                        hasDefaultPath = true;
                    }
                    path += "&f.FW=2";

                    path += "&f.LC=" + this.getLangCode;

                    //if (agentGId) {
                    //    path += "&f.AGI=" + agentGId;
                    //}
                    if (this.searchAgi) {
                        path += "&f.AGI_csv=" + this.searchAgi;
                        sessionStorage.setItem('WINLV2_FilterAGI', this.searchAgi);
                        sessionStorage.setItem('WINLV2_FilterAgent', this.searchAgent);
                    }
                    if (this.searchUserId) {
                        this.getMemberName();                    
                        path += "&f.MI=" + this.searchUserId;
                        sessionStorage.setItem('WINLV2_FilterMI', this.searchUserId);
                        sessionStorage.setItem('WINLV2_FilterMName', this.searchUsername);
                    }

                    if (this.searchBetId) {
                        path += "&f.BI=" + this.searchBetId.replaceAll('#', '<').replaceAll('_', '>');
                        sessionStorage.setItem('WINLV2_FilterBI', this.searchBetId);
                    }
                    if (this.searchCashOut != null) {
                        path += "&f.CO=" + this.searchCashOut;
                        sessionStorage.setItem('WINLV2_FilterCO', this.searchCashOut);
                    }

                    if (this.searchGameCategoryIds) {
                        path += "&f.GCI_csv=" + this.searchGameCategoryIds;
                    }

                    if (this.searchGameProviderId) {
                        //path += "&f.GPI=" + this.searchGameProviderId;
                        path += "&f.GPI_csv=" + this.searchGameProviderId;

                        if (this.searchGameProviderId != null && this.searchGameProviderId.length == 1) {
                            path += "&f.GPI=" + this.searchGameProviderId;
                        }
                        sessionStorage.setItem('WINLV2_FilterGPI', this.searchGameProviderId);
                    }

                    if (this.searchWinLossType) {
                        path += "&f.WLT=" + this.searchWinLossType;
                        sessionStorage.setItem('WINLV2_FilterWLT', this.searchWinLossType);
                    }

                    if (this.searchRegisterSourceName) {
                        path += "&f.RSN=" + this.searchRegisterSourceName;
                    }



                    if (this.searchCreatedTS) {
                        if (this.searchCreatedTS.startDate != "") {
                            path += "&f.STS_from=" + this.parseDateToJsonString(this.searchCreatedTS.startDate);
                            sessionStorage.setItem('WINLV2_FilterSTS_from', this.parseDateToJsonString(this.searchCreatedTS.startDate));
                        }

                        if (this.searchCreatedTS.endDate != "") {
                            path += "&f.STS_to=" + this.parseDateToJsonString(this.searchCreatedTS.endDate);
                            sessionStorage.setItem('WINLV2_FilterSTS_to', this.parseDateToJsonString(this.searchCreatedTS.endDate));
                        }
                    }

                    if (this.searchIsTester) {
                        path += "&f.ITU=" + this.searchIsTester;
                        sessionStorage.setItem('WINLV2_FilterITU', this.searchIsTester);
                    }
                    if (this.searchVDP) {
                        path += "&f.VDP=" + this.searchVDP;
                        sessionStorage.setItem('WINLV2_FilterVDP', this.searchVDP);
                    }
                    if (this.searchFreeSpin) {
                        path += "&f.FSB=" + this.searchFreeSpin;
                        sessionStorage.setItem('WINLV2_FilterFreeSpin', this.searchFreeSpin);
                    }
                    if (this.searchCurrency) {
                        path += "&f.CI=" + this.searchCurrency;
                        sessionStorage.setItem('WINLV2_FilterCI', this.searchCurrency);
                    }
                    path += "&f.RT=" + this.reportType;
                    if (this.searchSubAgent) {
                        path += "&f.SAGI=" + this.searchSubAgent;
                        sessionStorage.setItem('WINLV2_FilterSAGI', this.searchSubAgent);
                    }
                    if (!hasDefaultPath && path) {
                        path = path.substring(1);
                    }
                    if (that.reportType == "summary") {
                        this.getDataApi(this.getReportURL() + `v2?${path}`,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.DataLastUpdatedTS = that.getLUTS(d.Item1.D.Items);
                                    that.int_TP = Math.max(d.Item1.D.TotalPages, 1);
                                    that.int_Total = d.Item1.D.TotalItems;
                                    that.arr_summary_reportList = d.Item1.D.Items;
                                    that.totalReport = d.Item2;
                                }
                            });
                        if (loadGrandTotal) {
                            this.getDataApi(`/api/reports/winloss/summaryallv2?${path}`,
                                function (data) {
                                    that.allTotalReport = data;
                                });
                        }
                    }
                    else if (that.reportType == "MemberSummary") {
                        this.getDataApi(this.getReportURL() + `v2?${path}`,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.DataLastUpdatedTS = that.getLUTS(d.Item1.D.Items);
                                    that.int_TP = Math.max(d.Item1.D.TotalPages, 1);
                                    that.int_Total = d.Item1.D.TotalItems;

                                    if (d.Item1 && d.Item1.D && d.Item1.D.Items) {
                                        for (var i = 0; i < d.Item1.D.Items.length; i++) {
                                            d.Item1.D.Items[i].bool_showDetails = false;
                                        }
                                    }
                                    that.arr_provider_reportList = d.Item1.D.Items;
                                    that.totalReport1 = d.Item2;
                                }
                            });
                        if (loadGrandTotal) {
                            this.arr_summary_reportList = [];
                            this.getDataApi(this.getReportURL() + `allv2?${path}`,
                                function (data) {
                                    if (data)
                                        that.allTotalReport1 = data;
                                    //if (data.Item1)
                                    //    that.arr_summary_reportList = data.Item1;
                                });
                        }
                    }
                    else {
                        //var TotalWithdraw = 0;
                        //this.getDataApi("/api/reports/winloss/summaryv2" + `?${path}`,
                        //    function (d, s) {
                        //        if (s) {
                        //            that.DataLastUpdatedTS = that.getLUTS(d.Item1.D.Items);
                        //            // that.int_TP = Math.max(d.D.TotalPages, 1);
                        //            // that.int_Total = d.D.TotalItems;
                        //            that.arr_summary_reportList = d.Item1.D.Items;
                        //            that.totalReport = d.Item2;
                        //            that.resizeTableHead();
                        //            //if (d.Item1.D.Items.length > 0) {
                        //            //    TotalWithdraw = d.Item1.D.Items[0].TW;
                        //            //}
                        //        }
                        //    });
                        //if (loadGrandTotal) {
                        //    this.getDataApi(`/api/reports/winloss/summaryallv2?${path}`,
                        //        function (data) {
                        //            that.allTotalReport = data;
                        //        });
                        //}

                        this.getDataApi(this.getReportURL() + `v2?${path}`,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.DataLastUpdatedTS = that.getLUTS(d.Item1.D.Items);
                                    that.int_TP = Math.max(d.Item1.D.TotalPages, 1);
                                    that.int_Total = d.Item1.D.TotalItems;

                                    if (d.Item1 && d.Item1.D && d.Item1.D.Items) {
                                        for (var i = 0; i < d.Item1.D.Items.length; i++) {
                                            d.Item1.D.Items[i].bool_showDetails = false;
                                            //d.Item1.D.Items[i].TW = TotalWithdraw;
                                        }
                                    }

                                    that.arr_provider_reportList = d.Item1.D.Items;
                                    that.totalReport1 = d.Item2;
                                    that.resizeTableHead();

                                }
                            });
                        if (loadGrandTotal) {
                            this.arr_summary_reportList = [];
                            this.getDataApi(this.getReportURL() + `allv2?${path}`,
                                function (data) {
                                    if (data.Item2)
                                        that.allTotalReport1 = data.Item2;
                                    if (data.Item1)
                                        that.arr_summary_reportList = data.Item1;
                                    that.resizeTableHead();

                                });
                        }
                    }
                    that.resizeTableHead();

                    // this.getDataApi(this.getReportURL() + `?${path}`,
                    //     function (d, s) {
                    //         that.bool_fullLoading = false;
                    //         if (s) {
                    //             that.int_TP = Math.max(d.D.TotalPages, 1);
                    //             that.int_Total = d.D.TotalItems;

                    //             switch (that.reportType) {
                    //                 case "N2":
                    //                 case "DIAMONDCLUB":
                    //                 case "PS":
                    //                 case "PPLAY":
                    //                 case "PGSOFT":
                    //                 case "AFB1188":
                    //                 case "CQ9":
                    //                 case "CQ9_CASINO":
                    //                 case "EVOPLAY":
                    //                 case "EVOPLAY_CASINO":
                    //                 case "BETSOFT":
                    //                 case "BETSOFT_CASINO":
                    //                 case "BETSOFT_POKER":
                    //                 case "JOKER":
                    //                 case "JOKER_CASINO":
                    //                 case "WM":
                    //                 case "TFG_ESPORTS":
                    //                     if (d && d.D && d.D.Items) {
                    //                         for (var i = 0; i < d.D.Items.length; i++) {
                    //                             d.D.Items[i].bool_showDetails = false;
                    //                         }
                    //                     }
                    //                     that.arr_provider_reportList = d.D.Items;
                    //                     break;
                    //                 case "summary":
                    //                 default:
                    //                     that.arr_summary_reportList = d.D.Items;
                    //                     break;
                    //             }
                    //         }
                    //     });
                }
                else {
                    this.showErrorMessage(null, this.getLanguage['WLRPT']['PSP'], 1000);
                }
            },
            saveToExcel() {

                if (this.reportType != null) {
                    this.bool_fullLoading = false;
                    var that = this;
                    //var agentGId = null;

                    //if (this.searchAgi > 0) {
                    //    agentGId = this.searchAgi;
                    //}

                    var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                    var hasDefaultPath = false;

                    if (path) {
                        hasDefaultPath = true;
                    }

                    //if (agentGId) {
                    //    path += "&f.AGI=" + agentGId;
                    //}
                    if (this.searchAgi) {
                        path += "&f.AGI_csv=" + this.searchAgi;
                    }
                    if (this.searchUserId) {
                        path += "&f.MI=" + this.searchUserId;
                    }

                    if (this.searchBetId) {
                        path += "&f.BI=" + this.searchBetId;
                    }

                    if (this.searchCashOut != null) {
                        path += "&f.CO=" + this.searchCashOut;
                    }

                    if (this.searchGameCategoryIds) {
                        path += "&f.GCI_csv=" + this.searchGameCategoryIds;
                    }

                    if (this.searchGameProviderId) {
                        //path += "&f.GPI=" + this.searchGameProviderId;
                        path += "&f.GPI_csv=" + this.searchGameProviderId;

                        if (this.searchGameProviderId != null && this.searchGameProviderId.length == 1) {
                            path += "&f.GPI=" + this.searchGameProviderId;
                        }
                    }

                    if (this.searchWinLossType) {
                        path += "&f.WLT=" + this.searchWinLossType;
                    }

                    if (this.searchRegisterSourceName) {
                        path += "&f.RSN=" + this.searchRegisterSourceName;
                    }

                    if (this.searchIsTester) {
                        path += "&f.ITU=" + this.searchIsTester;
                    }
                    if (this.searchCurrency) {
                        path += "&f.CI=" + this.searchCurrency;
                    }
                    path += "&f.RT=" + this.reportType;
                    path += "&f.LC=" + this.getLangCode;

                    if (this.searchCreatedTS) {
                        if (this.searchCreatedTS.startDate != "") {
                            path += "&f.STS_from=" + this.parseDateToJsonString(this.searchCreatedTS.startDate);
                        }

                        if (this.searchCreatedTS.endDate != "") {
                            path += "&f.STS_to=" + this.parseDateToJsonString(this.searchCreatedTS.endDate);
                        }
                    }
                    if (this.searchVDP) {
                        path += "&f.VDP=" + this.searchVDP;
                    }
                    if (this.searchFreeSpin) {
                        path += "&f.FSB=" + this.searchFreeSpin;
                    }
                    if (this.searchSubAgent) {
                        path += "&f.SAGI=" + this.searchSubAgent;
                    }
                    if (!hasDefaultPath && path) {
                        path = path.substring(1);
                    }

                    window.open('/api/reports/newwinlossexcelv2?' + path, '_blank');
                }
                /*
                else {
                    this.showErrorMessage(null, this.getLanguage['WLRPT']['PSP'], 1000);
                }
                */
            },
            getLUTS(items) {
                if (items != null && items.length > 0) {
                    var result = moment(items[items.length - 1].UTS).format("MMM DD, YYYY hh:mm a");
                    try {
                        //new Date(Math.max.apply(null, items.map(function(e) {
                        //    var temp = new Date(e.UTS);
                        //    result = moment(temp).format("MMM DD, YYYY hh:mm a");
                        //})));
                        var temp = new Date(items[0].UTS);
                        for (var i = 0; i < items.length; i++) {
                            var curDT = new Date(items[i].UTS);
                            if (curDT > temp) {
                                temp = curDT;
                            }
                        }
                        result = moment(temp).format("MMM DD, YYYY hh:mm a");;
                    }
                    catch (ex) {
                        console.log(ex);
                    }
                    return result
                }
            },
            getStatus(data) {
                var status = '';
                if (data.RS == 1) {
                    status = this.getLanguage['BETRPT']['SIP'];
                }
                else if (data.RS == 2) {
                    if (data.IC == 1) {
                        status = this.getLanguage['BETRPT']['SC'];
                    }
                    else if (data.DPS == 0) {
                        status = this.getLanguage['BETRPT']['SPRD'];
                    }
                    else if (data.DPS == 3) {
                        status = this.getLanguage['BETRPT']['SE'];
                    }
                    else {
                        status = this.getLanguage['BETRPT']['SCP'];
                    }
                }

                return status;
            },
            CheckWinLoss(WLA, status, otherAmount) {
                if (WLA != 0) {
                    if (otherAmount >= 0 && status == 2) {
                        return "positive-number";
                    }
                    else if (otherAmount < 0 && status == 2) {
                        return "negative-number";
                    }
                }
            },
            getGameName(name) {
                var tailstr = "";

                if (this.reportType == "AFB1188" || this.reportType == "GGCORRECTSCORE") {
                    if (name == "PAR") {
                        name = "PARLAY";//this.reportType + "_" + name;
                    }
                    else {
                        return name;
                    }
                }
                else if (this.reportType == "TFG_ESPORTS" || this.reportType == "TFG_ESPORTS_SPORTS") {
                    if (name) {
                        name = name.replace('tfg_combo', this.getLanguage["TFG_ESPORTS_SPORTS"]["COMBO"]);
                    }

                    return name;
                }
                else if (this.reportType == "DIAMONDCLUB") {
                    name = this.reportType + "_" + name;
                }
                else if (this.reportType == "DREAMGAME") {
                    tailstr = name.split("_")[1];
                    name = name.split("_")[0];
                }

                var gamename = name;

                if (this.reportType in this.getLanguage && name in this.getLanguage[this.reportType]) {
                    gamename = this.getLanguage[this.reportType][name];
                }

                if (this.reportType == "DREAMGAME") {
                    switch (tailstr) {
                        case "10101": gamename = gamename + " " + "DG01"; break;
                        case "10102": gamename = gamename + " " + "DG02"; break;
                        case "10103": gamename = gamename + " " + "DG03"; break;
                        case "10104": gamename = gamename + " " + "DG05"; break;
                        case "10105": gamename = gamename + " " + "DG06"; break;
                        case "10106": gamename = gamename + " " + "DG07"; break;
                        case "10107": gamename = gamename + " " + "DG08"; break;
                        case "10108": gamename = gamename + " " + "DG09"; break;
                        case "10109": gamename = gamename + " " + "DG10"; break;
                        case "10802": gamename = gamename + " " + "DG11"; break;
                        case "10803": gamename = gamename + " " + "DG12"; break;
                        case "10201": gamename = gamename + " " + "DG13"; break;
                        case "10202": gamename = gamename + " " + "DG15"; break;
                        case "10301": gamename = gamename + " " + "DG16"; break;
                        case "10302": gamename = gamename + " " + "DG17"; break;
                        case "10701": gamename = gamename + " " + "DG18"; break;
                        case "11101": gamename = gamename + " " + "DG19"; break;
                        case "11601": gamename = gamename + " " + "DG20"; break;
                        case "10401": gamename = gamename + " " + "DG21"; break;
                        case "10501": gamename = gamename + " " + "DG22"; break;
                        case "30101": gamename = gamename + " " + "CT01"; break;
                        case "30102": gamename = gamename + " " + "CT02"; break;
                        case "30103": gamename = gamename + " " + "CT03"; break;
                        case "30105": gamename = gamename + " " + "CT05"; break;
                        case "30301": gamename = gamename + " " + "CT06"; break;
                        case "30401": gamename = gamename + " " + "CT08"; break;
                        case "30601": gamename = gamename + " " + "CT10"; break;
                        case "50101": gamename = gamename + " " + "E1"; break;
                        case "50102": gamename = gamename + " " + "E3"; break;
                        case "50103": gamename = gamename + " " + "E7"; break;
                        case "50401": gamename = gamename + " " + "R1"; break;
                        case "70101": gamename = gamename + " " + "GC01"; break;
                        case "70102": gamename = gamename + " " + "GC02"; break;
                        case "70103": gamename = gamename + " " + "GC03"; break;
                        case "70105": gamename = gamename + " " + "GC05"; break;
                        case "70106": gamename = gamename + " " + "GC06"; break;
                        case "70501": gamename = gamename + " " + "GC09"; break;
                        case "84101": gamename = gamename + " " + "Q1"; break;
                        case "84102": gamename = gamename + " " + "Q2"; break;
                        case "84103": gamename = gamename + " " + "Q3"; break;
                        case "84104": gamename = gamename + " " + "Q5"; break;
                        case "84105": gamename = gamename + " " + "Q6"; break;
                        case "84106": gamename = gamename + " " + "Q7"; break;
                        case "84201": gamename = gamename + " " + "Q8"; break;
                        case "84202": gamename = gamename + " " + "Q9"; break;
                        case "84301": gamename = gamename + " " + "Q10"; break;
                        case "84401": gamename = gamename + " " + "Q11"; break;
                        case "84501": gamename = gamename + " " + "Q12"; break;
                    }
                }
                return gamename;
            },
            getProviderName(provider, name) {
                var gamename = name;
                if (provider in this.getLanguage && name in this.getLanguage[provider]) {
                    gamename = this.getLanguage[provider][name];
                }

                return gamename;
            },
            //member all provider report use
            getMemberName() {
                //this.memberName = "Member";
                //for (var pt of this.ddMemberList) {
                //    if (pt.id == this.searchUserId) {
                //        this.memberName = pt.label;
                //    }
                //}
                if (this.ddMemberList && this.ddMemberList.length > 0) {
                    for (var i = 0; i < this.ddMemberList.length; i++) {
                        if (this.ddMemberList[i].id == this.searchUserId) {
                            this.memberName = this.ddMemberList[i].label;
                            break;
                        }
                    }
                } else if (this.memberName == "") {
                    this.memberName = "Member";
                }

                //return this.memberName;
            },
            getProviderReport(data) {
                //this.setReportType();
                var stringGPI = String(data.GPI); //get GPI in string
                this.searchGameProviderId = [stringGPI];
                this.openMemberWinLossDetail(data);
            },
            getProvName(name) {
                var pname = name;
                pname = this.getLanguage["GP"][name];

                return pname;
            },
            getGN(PN, GN) {
                var result = GN;
                try {
                    result = this.getLanguage[PN][GN];
                    if (result === "") {
                        return GN;
                    }
                    else {
                        return result;
                    }
                }
                catch (e) { }
                //if (this.reportType in this.getLanguage && name in this.getLanguage[this.reportType]) {

                //}
                return result;
            },
            //member all provider report use end
            renderGameResult(gameResult, dt, isUrl) {
                if (gameResult && gameResult.length > 0) {
                    if (this.reportType == "AFB1188" || this.reportType == "GGCORRECTSCORE") {
                        gameResult = gameResult.replace("afb_result", this.getLanguage["WLRPT"]["R"]);
                        gameResult = gameResult.replace("afb_score", this.getLanguage["WLRPT"]["FSC"]);
                        gameResult = gameResult.replace("afb_over", this.getLanguage["AFB1188"]["OV"]);
                        gameResult = gameResult.replace("afb_under", this.getLanguage["AFB1188"]["UN"]);
                        gameResult = gameResult.replace("afb_odd", this.getLanguage["AFB1188"]["ODD"]);
                        gameResult = gameResult.replace("afb_even", this.getLanguage["AFB1188"]["EVEN"]);
                        gameResult = gameResult.replace("afb_draw", this.getLanguage["AFB1188"]["DRAW"]);

                        gameResult = gameResult.replace("afb_win", this.getLanguage["AFB1188"]["WIN"]);

                        gameResult = gameResult.replace(/afb_lastgoal/gi, this.getLanguage["AFB1188"]["LG"]);
                        gameResult = gameResult.replace(/afb_firstgoal/gi, this.getLanguage["AFB1188"]["FG"]);
                        gameResult = gameResult.replace(/afb_nogoal/gi, this.getLanguage["AFB1188"]["NG"]);

                        gameResult = gameResult.replace("afb_dc", this.getLanguage["AFB1188"]["DC"]);
                        gameResult = gameResult.replace("afb_tg", this.getLanguage["AFB1188"]["TG"]);

                        gameResult = gameResult.replace("afb_bd", this.getLanguage["AFB1188"]["BD"]);

                    }
                    else if (this.reportType == "DIAMONDCLUB") {
                        gameResult = gameResult.replace("DRAGONEVEN", this.getLanguage["DIAMONDCLUB"]["DRAGONEVEN"]);
                        gameResult = gameResult.replace("DRAGONODD", this.getLanguage["DIAMONDCLUB"]["DRAGONODD"]);
                        gameResult = gameResult.replace("TIGEREVEN", this.getLanguage["DIAMONDCLUB"]["TIGEREVEN"]);
                        gameResult = gameResult.replace("TIGERODD", this.getLanguage["DIAMONDCLUB"]["TIGERODD"]);
                        gameResult = gameResult.replace("DRAGONBLACK", this.getLanguage["DIAMONDCLUB"]["DRAGONBLACK"]);
                        gameResult = gameResult.replace("DRAGONRED", this.getLanguage["DIAMONDCLUB"]["DRAGONRED"]);
                        gameResult = gameResult.replace("TIGERBLACK", this.getLanguage["DIAMONDCLUB"]["TIGERBLACK"]);
                        gameResult = gameResult.replace("TIGERRED", this.getLanguage["DIAMONDCLUB"]["TIGERRED"]);
                        gameResult = gameResult.replace("DRAGON", this.getLanguage["DIAMONDCLUB"]["DRAGON"]);
                        gameResult = gameResult.replace("TIGER", this.getLanguage["DIAMONDCLUB"]["TIGER"]);

                        gameResult = gameResult.replace("BIG", this.getLanguage["DIAMONDCLUB"]["BIG"]);
                        gameResult = gameResult.replace("SMALL", this.getLanguage["DIAMONDCLUB"]["SMALL"]);
                        gameResult = gameResult.replace("ODD", this.getLanguage["DIAMONDCLUB"]["ODD"]);
                        gameResult = gameResult.replace("EVEN", this.getLanguage["DIAMONDCLUB"]["EVEN"]);
                        gameResult = gameResult.replace("ANYTRIPLE", this.getLanguage["DIAMONDCLUB"]["ANYTRIPLE"]);
                        gameResult = gameResult.replace("EXACT", this.getLanguage["DIAMONDCLUB"]["EXACT"]);

                        gameResult = gameResult.replace("BANKER", this.getLanguage["DIAMONDCLUB"]["BANKER"]);
                        gameResult = gameResult.replace("PLAYER", this.getLanguage["DIAMONDCLUB"]["PLAYER"]);
                        gameResult = gameResult.replace("TIE", this.getLanguage["DIAMONDCLUB"]["TIE"]);
                        gameResult = gameResult.replace("BPAIR", this.getLanguage["DIAMONDCLUB"]["BPAIR"]);
                        gameResult = gameResult.replace("PPAIR", this.getLanguage["DIAMONDCLUB"]["PPAIR"]);

                        gameResult = gameResult.replace("RED", this.getLanguage["DIAMONDCLUB"]["RED"]);
                        gameResult = gameResult.replace("BLACK", this.getLanguage["DIAMONDCLUB"]["BLACK"]);
                    }
                    else if (this.reportType == "CQ9" || this.reportType == "CQ9_FISHING" || (this.reportType == "CQ9_CASINO" && dt && (dt.DT == 1 || isUrl)) || this.reportType == "CQ9_LOTTERY") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "CQ9_LIVE_CASINO") {
                        gameResult = '<span>Round Number : ' + dt.GR + '</span></br>'
                        gameResult += '<span>Detail Report : <a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a></span>';
                    }
                    else if (this.reportType == "EVOPLAY" || this.reportType == "EVOPLAY_CASINO") {
                        if (dt.DT == 0) {
                            //socket game
                            if (gameResult == "Win" || gameResult == "Lose") {
                                gameResult = gameResult.replace("Win", this.getLanguage["WLRPT"]["RWIN"]);
                                gameResult = gameResult.replace("Lose", this.getLanguage["WLRPT"]["RLOSE"]);
                            } else {
                                gameResult = gameResult;
                            }
                        } else {
                            gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VR"] + '</a>';
                        }

                    }
                    else if (this.reportType == "JOKER" || this.reportType == "JOKER_CASINO" || this.reportType == "JOKER_FISHING") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';

                        //if (dt.B == 0 && dt.J == 0) {
                        //    gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                        //} else {
                        //    //if (dt.B > 0) gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VBT"] + '</a>';
                        //    //if (dt.J > 0) gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VJT"] + '</a>';
                        //    if (dt.B > 0) gameResult = '<span>Grand Jackpot</span>';
                        //    if (dt.J > 0) gameResult = '<span>Powerbar</span>';
                        //}
                    }
                    else if (this.reportType == "YGR_SLOT" || this.reportType == "YGR_FISHING") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "FACHAI_SLOT" || this.reportType == "FACHAI_FISHING" || this.reportType == "FACHAI_E_CASINO") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "ACE333_SLOT" || this.reportType == "ACE333_E_CASINO") {
                        if (gameResult == "Jackpot") {
                            gameResult = 'Jackpot Win';
                        }
                        else {
                            gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                        }
                    }
                    else if (this.reportType == "PPLAY" || this.reportType == "PPLAY_CASINO" || this.reportType == "PPLAY_E_CASINO" || this.reportType == "FATPANDA_SLOT") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "PGSOFT") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "PGSOFT_THB_SLOT") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                        //gameResult = this.PGSOFT_THB_SLOTgameResult_WithoutDetail(dt.WLA);
                    }

                    else if (this.reportType.match(/betsoft/i)) {
                        if (gameResult == "Win" || gameResult == "Lose") {
                            gameResult = gameResult.replace("Win", this.getLanguage["WLRPT"]["RWIN"]);
                            gameResult = gameResult.replace("Lose", this.getLanguage["WLRPT"]["RLOSE"]);
                        } else {
                            gameResult = '<a href="' + dt.RURL + '" target="_blank">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                        }
                    }
                    else if (this.reportType == 'TFG_ESPORTS' || this.reportType == 'TFG_ESPORTS_SPORTS') {
                        gameResult = gameResult.replace("tfg_result", this.getLanguage["TFG_ESPORTS"]["RE"]);
                        gameResult = gameResult.replace("tfg_over", this.getLanguage["TFG_ESPORTS"]["OV"]);
                        gameResult = gameResult.replace("tfg_under", this.getLanguage["TFG_ESPORTS"]["UN"]);
                        gameResult = gameResult.replace("tfg_draw", this.getLanguage["TFG_ESPORTS"]["DRAW"]);
                    }
                    else if (this.reportType == 'CONNECT93') {
                        gameResult = gameResult.replace("GN", 'GameName');
                        gameResult = gameResult.replace("DN", 'Periods');
                        gameResult = gameResult.replace("BT", 'BetConent');
                        gameResult = gameResult.replace("BO", 'Odds');
                        gameResult = gameResult.replace("GRS", 'TotalSum');
                    }
                    //else if (this.reportType == "AFBGAMING" || this.reportType == "AFBGAMING_FISHING") {
                    else if (this.reportType == "AFBGAMING" || this.reportType == "AFBGAMING_E_CASINO") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "AFBGAMING_FISHING") {
                        //gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>'; //pending afbgaming develop
                        //gameResult = '<span>' + gameResult + '</span>';
                    }
                    else if (this.reportType == "LUCKY361_SLOT") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType.match(/habanero/i)) {
                        gameResult = '<a href="' + dt.RURL + '" target="_blank">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "SPINOMENAL_SLOT") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "SPINOMENAL_LOTTERY") {
                        // gameResult = '<a href="' + dt.RURL + '" target="_blank">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "NETENT" || this.reportType == "REDTIGER" || this.reportType == "NETENT_E_CASINO" || this.reportType == "REDTIGER_E_CASINO" || this.reportType == "BTG_SLOT" || this.reportType == "NLC_V2_SLOT") {
                        if (dt.GR == "DLS")
                            gameResult = "Daily Lucky Spin";
                        else
                            gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "SIMPLEPLAY_SLOT") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "SIMPLEPLAY_E_CASINO") {

                    }
                    else if (this.reportType == "JDB_FISHING") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "JDB_SLOT") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "BOOMING_GAMES") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "KA_FISHING") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "KA_SLOT") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "LG88") {

                    }
                    else if (this.reportType == "YGGDRASIL" ||
                        this.reportType == "YGGDRASIL_E_CASINO" ||
                        this.reportType == "NLC_SLOT" ||
                        this.reportType == "AUX_SLOT" ||
                        this.reportType == "RELAX_SLOT" ||
                        this.reportType == "RELAX_E_CASINO" ||
                        this.reportType == "HACKSAW_SLOT") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "PNG_SLOT") {

                    }
                    else if (this.reportType == "GHG_SLOT") {

                    }
                    else if (this.reportType == "ATA_EVOPLAY_SLOT") {

                    }
                    else if (this.reportType == "AIS_SLOTS") {
                        //gameResult = `<a href="${dt.GR}" target="_blank">${this.getLanguage["WLRPT"]["VT"]}</a>`;
                    }
                    else if (this.reportType == "JILI_SLOT" || this.reportType == "JILI_FISHING" || this.reportType == "JILI_E_CASINO") {
                        gameResult = `<a href="#">${this.getLanguage["WLRPT"]["VT"]}</a>`;
                    }
                    else if (this.reportType == "EBET_SLOT" || this.reportType == "EBET_E_CASINO") {
                        gameResult = `<a href="#">${this.getLanguage["WLRPT"]["VT"]}</a>`;
                    }
                    else if (this.reportType == "NEXTSPIN_SLOT") {
                        gameResult = `<a href="#">${this.getLanguage["WLRPT"]["VT"]}</a>`;
                    }
                    else if (this.reportType == "ADVANTPLAY_SLOT") {
                        gameResult = `<a href="#">${this.getLanguage["WLRPT"]["VT"]}</a>`;
                    }
                    else if (this.reportType == "ARCADIA_GAMING") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "NAGA_SLOT") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "GAMING9_POKER" || this.reportType == "GAMING9_OTHERS") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    } else if (this.reportType == "JILI_V2_SLOT" || this.reportType == "JILI_V2_FISHING" || this.reportType == "JILI_V2_E_CASINO") {
                        gameResult = `<a href="#">${this.getLanguage["WLRPT"]["VT"]}</a>`;
                    }
                    else if (this.reportType == "KINGMAKER_CASINO" || this.reportType == "KINGMAKER_SLOTS") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "SPRIBE_E_CASINO") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "SPADEGAMING_SLOT") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "UU_SLOT") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "WINFINITY_CASINO") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "MG_SLOT") {
                        gameResult = `<a href="#">${this.getLanguage["WLRPT"]["VT"]}</a>`;
                    }
                    else if (this.reportType == "MG_LIVE") {
                        gameResult = `<a href="#">${this.getLanguage["WLRPT"]["VT"]}</a>`;
                    }
                    else if (this.reportType == "DCACE_SLOT") {
                        gameResult = `<a href="#">${this.getLanguage["WLRPT"]["VT"]}</a>`;
                    }
                    else if (this.reportType == "VPOWER") {
                        if (gameResult == "Win" || gameResult == "Lose") {
                            gameResult = gameResult.replace('Win', `<span class="positive-number">${this.getLanguage["WLRPT"]["RWIN"]}</span>`);
                            gameResult = gameResult.replace('Lose', `<span class= "negative-number" >${this.getLanguage["WLRPT"]["RLOSE"]}</span>`);
                        } else {
                            gameResult = `<a href="#">${this.getLanguage["WLRPT"]["VT"]}</a>`;
                        }
                    }
                    else if (this.reportType == "PRETTY_LIVE") {
                        if (gameResult == "Win" || gameResult == "Lose") {
                            gameResult = gameResult.replace('Win', `<span class="positive-number">${this.getLanguage["WLRPT"]["RWIN"]}</span>`);
                            gameResult = gameResult.replace('Lose', `<span class= "negative-number" >${this.getLanguage["WLRPT"]["RLOSE"]}</span>`);
                        } else {
                            gameResult = `<a href="#">${this.getLanguage["WLRPT"]["VT"]}</a>`;
                        }
                    }
                    else if (this.reportType == "IBEX_SLOT") {
                        if (gameResult == "Win" || gameResult == "Lose") {
                            gameResult = gameResult.replace('Win', `<span class="positive-number">${this.getLanguage["WLRPT"]["RWIN"]}</span>`);
                            gameResult = gameResult.replace('Lose', `<span class= "negative-number" >${this.getLanguage["WLRPT"]["RLOSE"]}</span>`);
                        } else {

                        }
                    }
                    else if (this.reportType == "LIVE22_SLOT" || this.reportType == "LIVE22_E_CASINO") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                }
                else {
                    if (this.reportType == "CQ9" || this.reportType == "CQ9_FISHING" || this.reportType == "CQ9_CASINO" || this.reportType == "CQ9_LOTTERY" || this.reportType == "CQ9_LIVE_CASINO") {
                        try {
                            if (dt.GN == "promo_payoff") {
                                var realGn = this.getGameName(dt.GN);
                                gameResult = "<span>" + realGn + "</span>"
                            }
                        }
                        catch (e) {
                            console.log(e);
                        }
                    }
                }

                return gameResult;
            },
            gameResultOnClick(dt) {
                if ((this.reportType == "CQ9" || this.reportType == "CQ9_FISHING" || (this.reportType == "CQ9_CASINO" && dt.DT == 1) || this.reportType == "CQ9_LOTTERY" || this.reportType == "CQ9_LIVE_CASINO") && dt && dt.GR) {
                    this.openCQ9Details(dt);
                }
                else if ((this.reportType == "EVOPLAY" || this.reportType == "EVOPLAY_CASINO") && dt && dt.GR && dt.DT == 1) {
                    this.openEvoPlayDetails(dt);
                }
                else if ((this.reportType == "JOKER" || this.reportType == "JOKER_CASINO" || this.reportType == "JOKER_FISHING") && dt && dt.GR) {
                    this.openJokerDetails(dt);
                }
                else if ((this.reportType == "YGR_SLOT" || this.reportType == "YGR_FISHING") && dt && dt.GR) {
                    this.openYGRDetails(dt);
                }
                else if ((this.reportType == "FACHAI_SLOT" || this.reportType == "FACHAI_FISHING" || this.reportType == "FACHAI_E_CASINO") && dt && dt.GR) {
                    this.openFACHAIDetails(dt);
                }
                else if ((this.reportType == "ACE333_SLOT" || this.reportType == "ACE333_E_CASINO") && dt && dt.GR) {
                    this.openACE333Details(dt);
                }
                else if ((this.reportType == "PPLAY" || this.reportType == "PPLAY_CASINO" || this.reportType == "PPLAY_E_CASINO") && dt && dt.GR) {
                    this.openPPlayDetails(dt);
                }
                else if (this.reportType == "PGSOFT" && dt && dt.GR) {
                    this.openPGSOFTDetails(dt);
                }
                else if (this.reportType == "PGSOFT_THB_SLOT" && dt && dt.GR) {
                    this.PGSOFT_THB_SLOTgameResult(dt);
                }
                else if ((this.reportType == "AFBGAMING" || this.reportType == "AFBGAMING_E_CASINO") && dt && dt.GR) {
                    //else if (this.reportType == "AFBGAMING" && dt && dt.GR){
                    this.openAFBGamingDetails(dt);
                }
                else if (this.reportType == "LUCKY361_SLOT" && dt && dt.GR) {
                    this.openLUCKY361Details(dt);
                }
                else if (this.reportType == "SPINOMENAL_SLOT" && dt && dt.GR) {
                    this.openSpinomenalDetails(dt.SPINOMENALCHILD[0]);
                }
                else if (this.reportType == "SPINOMENAL_LOTTERY" && dt && dt.GR) {
                    this.openSpinomenalDetails(dt.SPINOMENALCHILD[0]);
                }
                else if (this.reportType == "SIMPLEPLAY_SLOT" && dt && dt.GR) {
                    this.openSimplePlayDetails(dt);
                }
                else if (this.reportType == "PGSOFT_THB_SLOT" && dt && dt.GR) {
                    this.PGSOFT_THB_SLOTgameResult(dt);
                }
                else if ((this.reportType == "REDTIGER" || this.reportType == "NETENT" || this.reportType == "REDTIGER_E_CASINO" || this.reportType == "NETENT_E_CASINO" || this.reportType == "BTG_SLOT" || this.reportType == "NLC_V2_SLOT") && dt && dt.GR) {
                    if (dt.GR != "DLS")
                        this.openBetPlayDetails(dt);
                }
                else if (this.reportType == "JDB_FISHING" && dt && dt.GR) {
                    this.openJDBFishingDetails(dt);
                }
                else if (this.reportType == "JDB_SLOT" && dt && dt.GR) {
                    this.openJDBSlotDetails(dt);
                }
                else if (this.reportType == "BOOMING_GAMES" && dt && dt.GR) {
                    this.openBOOMINGGAMESDetails(dt);
                }
                else if (this.reportType == "KA_FISHING" && dt && dt.GR) {
                    this.openKAFishingDetails(dt);
                }
                else if (this.reportType == "KA_SLOT" && dt && dt.GR) {
                    this.openKASlotDetails(dt);
                }
                else if ((this.reportType == "JILI_SLOT" || this.reportType == "JILI_FISHING" || this.reportType == "JILI_E_CASINO") && dt && dt.GR) {
                    this.openJILIDetails(dt);
                }
                else if ((this.reportType == "EBET_SLOT" || this.reportType == "EBET_E_CASINO") && dt && dt.GR) {
                    this.openEBETDetails(dt);
                }
                else if ((this.reportType == "YGGDRASIL" ||
                    this.reportType == "YGGDRASIL_E_CASINO" ||
                    this.reportType == "NLC_SLOT" ||
                    this.reportType == "AUX_SLOT" ||
                    this.reportType == "HACKSAW_SLOT") && dt && dt.GR) {
                    this.openATADetails(dt);
                }
                else if ((this.reportType == "RELAX_SLOT" ||
                    this.reportType == "RELAX_E_CASINO") && dt && dt.GR) {
                    this.openRELAXDetails(dt);
                }
                else if ((this.reportType == "NEXTSPIN_SLOT") && dt && dt.GR) {
                    this.openNextSpinDetails(dt);
                }
                else if ((this.reportType == "ADVANTPLAY_SLOT") && dt && dt.GR) {
                    this.openADVANTPLAYDetails(dt);
                }
                else if (this.reportType == "ARCADIA_GAMING" && dt && dt.GR) {
                    this.openAGDetails(dt);
                }
                else if (this.reportType == "NAGA_SLOT" && dt && dt.GR) {
                    this.openNAGADetails(dt);
                }
                else if (this.reportType == "GAMING9_POKER" || this.reportType == "GAMING9_OTHERS" && dt && dt.GR) {
                    this.openG9Details(dt);
                }
                else if ((this.reportType == "JILI_V2_SLOT" || this.reportType == "JILI_V2_FISHING" || this.reportType == "JILI_V2_E_CASINO") && dt && dt.GR) {
                    this.openJILI_V2Details(dt);
                }
                else if (this.reportType == "KINGMAKER_CASINO" || this.reportType == "KINGMAKER_SLOTS" && dt && dt.GR) {
                    this.openKINGMAKERDetails(dt);
                }
                else if (this.reportType == "SPRIBE_E_CASINO" && dt && dt.GR) {
                    this.openSpribeDetails(dt);
                }
                else if (this.reportType == "SPADEGAMING_SLOT" && dt && dt.GR) {
                    this.openSpadeGamingDetails(dt);
                }
                else if (this.reportType == "UU_SLOT" && dt && dt.GR) {
                    this.openUUDetails(dt);
                }
                else if (this.reportType == "WINFINITY_CASINO" && dt && dt.GR) {
                    this.openWINFINITYDetails(dt);
                }
                else if ((this.reportType == "MG_SLOT") && dt && dt.GR) {
                    this.openMG_SLOTDetails(dt);
                }
                else if ((this.reportType == "MG_LIVE") && dt && dt.GR) {
                    this.openMG_LIVEDetails(dt);
                }
                else if ((this.reportType == "DCACE_SLOT") && dt && dt.GR) {
                    this.openDCACEDetails(dt);
                }
                else if ((this.reportType == "VPOWER") && dt && dt.GR) {
                    this.openVPOWERDetails(dt);
                }
                else if ((this.reportType == "PRETTY_LIVE") && dt && dt.GR) {
                    this.openPRETTY_LIVEDetails(dt);
                }
                else if (this.reportType == "LIVE22_SLOT" || this.reportType == "LIVE22_E_CASINO" && dt && dt.GR) {
                    this.openLIVE22Details(dt);
                }
                else if ((this.reportType == "FATPANDA_SLOT") && dt && dt.GR) {
                    this.openFatPandaDetails(dt);
                }
                //else if ((this.reportType == "IBEX_SLOT") && dt && dt.GR) {
                //    this.openIBEX_SLOTDetails(dt);
                //}
                return false;
            },
            gameResultDetailOnClick(dt) {
                if (this.reportType == "CQ9_CASINO" && dt.DT == 0 && dt && dt.RURL) {
                    this.openCQ9Details(dt);
                }
                //else if ((this.reportType == "RELAX_SLOT" || this.reportType == "RELAX_E_CASINO")) {
                //    //debugger;
                //    this.openRELAXDetails(dt)
                //}

                return false;
            },
            renderAFBWL(res) {
                if (res != "") {
                    let color = "black";
                    switch (res) {
                        case "WA":
                        case "WH":
                            color = "green";
                            break;
                        case "LA":
                        case "LH":
                            color = "red";
                            break;
                    }
                    return `<div style="color: ${color}">${this.getLanguage["WLRPT"]["R" + res]}</div>`;
                }
                return res;
            },
            renderSBOWL(cbd) {
                if (cbd != "") {
                    let color = "black";
                    switch (cbd) {
                        case "won": case "won1":
                            color = "green";
                            cbd = cbd == "won" ? "Won" : "Half Won";
                            break;
                        case "lose": case "lose1":
                            color = "red";
                            cbd = cbd == "lose" ? "Lose" : "Half Lose";
                            break;
                        case "draw":
                            cbd = "Draw";
                    }

                    return `<div style="color: ${color}">${cbd}</div>`;
                }
                return cbd;
            },
            renderGD88WL(res) {
                if (res != "")
                    return this.getLanguage["WLRPT"]["R" + res];

                return res;
            },
            openCQ9Details(dt) {
                var that = this;
                var param = dt.RURL ? dt.RURL : dt.GR;

                if (that.getLangCode == 'cn') {
                    param += "&lang=zh-cn";
                }

                that.bool_fullLoading = true;
                this.getDataApi(`/api/reports/winloss/cq9/detail?${param}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d && d.D) {
                            window.open(d.D, 'cq9result');
                        }
                    });
            },
            //openRELAXDetails(dt) {
            //    var that = this;
            //    that.bool_fullLoading = true;
            //    let url = btoa(dt.N)
            //    this.getDataApi(`/api/reports/winloss/relax/detail?playback=${url}`,
            //        function (playback) {
            //            that.bool_fullLoading = false;
            //            if (playback) {
            //                window.open(playback);
            //            }
            //        });
            //},
            openEvoPlayDetails(dt) {
                var that = this;

                that.bool_fullLoading = true;
                this.getDataApi(`/api/reports/winloss/evoplay/detail?${dt.GR}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d && d.D) {
                            window.open(d.D, 'evoplayresult');
                        }
                    });
            },
            openJokerDetails(dt) {
                var that = this;

                that.bool_fullLoading = true;
                this.getDataApi(`/api/reports/winloss/joker/detail?${dt.GR}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d && d.D) {
                            window.open(d.D, 'jokerresult');
                        }
                    });
            },
            openYGRDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;
                var param = dt.GR;
                var lang = "";

                switch (that.getLangCode) {
                    case "cn": lang = "zh-CN"; break;
                    case "en": lang = "en-US"; break;
                    case "ja": lang = "ja-JP"; break;
                    case "th": lang = "th-TH"; break;
                    case "id": lang = "id-ID"; break;
                    case "vn": lang = "vi-VN"; break;
                    case "es": lang = "es-ES"; break;
                    case "pt": lang = "pt-PT"; break;
                    default: lang = "en-US"; break;
                }

                param += "&lang=" + lang;

                this.getDataApi(`/api/reports/winloss/ygr/detail?${param}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d && d.D) {
                            window.open(d.D, 'ygrresult');
                        }
                    });
            },
            openFACHAIDetails(dt) {
                var that = this;

                that.bool_fullLoading = true;
                var param = dt.GR;
                var lang = "";

                switch (that.getLangCode) {
                    case "en": lang = "1"; break;
                    case "cn": lang = "2"; break;
                    case "vn": lang = "3"; break;
                    case "th": lang = "4"; break;
                    case "id": lang = "5"; break;
                    case "my": lang = "6"; break;
                    case "ja": lang = "7"; break;
                    case "kr": lang = "8"; break;
                    case "pt": lang = "9"; break;
                    default: lang = "1"; break;
                }

                param += "&lang=" + lang;

                this.getDataApi(`/api/reports/winloss/fachai/detail?${param}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d && d.D) {
                            window.open(d.D, 'fachairesult');
                        }
                    });
            },
            openACE333Details(dt) {
                var that = this;

                that.bool_fullLoading = true;
                var param = dt.GR;

                this.getDataApi(`/api/reports/winloss/ace333/detail?${param}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d && d.D) {
                            // 無法開啟頁面
                            //that.openWindowWithPost("/api/gamereplay", {
                            //    ReplayUrl: d.D,
                            //    DomainTitle: "ACE333 - View Ticket"
                            //});
                            window.open(d.D, 'ACE333 - View Ticket');
                        }
                    });
            },
            openPPlayDetails(dt) {
                var that = this;

                that.bool_fullLoading = true;
                this.getDataApi(`/api/reports/winloss/pplay/detail?${dt.GR}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d && d.D) {
                            that.openWindowWithPost("/api/gamereplay", {
                                ReplayUrl: d.D,
                                DomainTitle: "PragmatiPlay - View Ticket"
                            });
                            //window.open(d.D, 'pplayresult');
                        }
                    });
            },
            openFatPandaDetails(dt) {
                var that = this;

                that.bool_fullLoading = true;
                this.getDataApi(`/api/reports/winloss/fatpanda/detail?${dt.GR}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d && d.D) {
                            that.openWindowWithPost("/api/gamereplay", {
                                ReplayUrl: d.D,
                                DomainTitle: "FatPanda - View Ticket"
                            });
                            //window.open(d.D, 'pplayresult');
                        }
                    });
            },
            openATADetails(dt) {
                var that = this;

                that.bool_fullLoading = true;
                this.getDataApi(`/api/reports/winloss/ata/detail?${dt.GR}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d && d.D) {
                            that.openWindowWithPost("/api/gamereplay", {
                                ReplayUrl: d.D,
                                DomainTitle: "ATA - View Ticket"
                            });
                            //window.open(d.D, 'ataresult');
                        }
                    });
            },
            openRELAXDetails(dt) {
                var that = this;

                that.bool_fullLoading = true;
                this.getDataApi(`/api/reports/winloss/ata/detail?${dt.GR}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d) { //&& d.D
                            //that.openWindowWithPost("/api/gamereplay", {
                            //    ReplayUrl: d.D,
                            //    DomainTitle: "ATA - View Ticket"
                            //});
                            window.open(d.D, 'ataresult');
                        }
                    });
            },
            openAFBGamingDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;
                var param = `gpi=${dt.GPI}&agi=${dt.AGI}&betId=${dt.TI}`;
                this.getDataApi(`/api/reports/winloss/afbgaming/detail?${param}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d) {
                            that.bool_fullLoading = false;
                            that.openWindowWithPost("/api/gamereplay", {
                                ReplayUrl: d.D,
                                DomainTitle: "AFBGaming - View Ticket"
                            });

                            //window.open(d.D, 'afbgamingresult');
                            //window.open(d, 'afbgaming');
                        }
                    });
            },
            openLUCKY361Details(dt) {
                var that = this;
                that.bool_fullLoading = true;
                var param = `gpi=${dt.GPI}&agi=${dt.AGI}&betId=${dt.TI}`;
                this.getDataApi(`/api/reports/winloss/lucky361/detail?${param}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d) {
                            that.bool_fullLoading = false;
                            window.open(d.D, 'lucky361result');
                            //window.open(d, 'afbgaming');
                        }
                    });
            },
            openNAGADetails(dt) {
                var that = this;
                that.bool_fullLoading = true;
                let params = dt.GR
                this.getDataApi(`/api/reports/winloss/naga/detail?${params}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d) {
                            that.openWindowWithPost("/api/gamereplay", {
                                ReplayUrl: d.D,
                                DomainTitle: "NAGA - View Ticket"
                            });
                            //window.open(d.D, 'nagaresult');
                        }
                    });
            },
            openSpinomenalDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;
                this.getDataApi(`/api/reports/winloss/spinomenal/detail?TI=${dt.TI}&MGBTI=${dt.MGBTI}&U=${dt.U}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d) {
                            that.openWindowWithPost("/api/gamereplay", {
                                ReplayUrl: d.D,
                                DomainTitle: "Spinomenal - View Ticket"
                            });
                            //window.open(d, 'spinomenalresult');
                        }
                    });
            },
            openSimplePlayDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;
                this.getDataApi(`/api/reports/winloss/simpleplay/detail?GI=${dt.GR}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d && d.D) {
                            that.openWindowWithPost("/api/gamereplay", {
                                ReplayUrl: d.D,
                                DomainTitle: "SimplePlay - View Ticket"
                            });
                            //window.open(d.D, 'simpleplayresult');
                        }
                    });
            },
            openBetPlayDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;
                this.getDataApi(`/api/reports/winloss/betplay/detail?${dt.GR}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d) {
                            //that.openWindowWithPost("/api/gamereplay", {
                            //    ReplayUrl: d.D,
                            //    DomainTitle: "BetPlay - View Ticket"
                            //});
                            window.open(d.D, 'betplayresult');
                        }
                    });
            },
            openJDBFishingDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;

                var param = dt.GR;
                param += "&lang=" + that.getLangCode;

                this.getDataApi(`/api/reports/winloss/jdbfishing/detail?${param}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d) {
                            that.openWindowWithPost("/api/gamereplay", {
                                ReplayUrl: d.D,
                                DomainTitle: "JDB - View Ticket"
                            });
                            //window.open(d.D, 'jdbresult');
                        }
                    });
            },
            openJDBSlotDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;

                var param = dt.GR;
                param += "&lang=" + that.getLangCode;

                this.getDataApi(`/api/reports/winloss/jdbslot/detail?${param}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d) {
                            that.openWindowWithPost("/api/gamereplay", {
                                ReplayUrl: d.D,
                                DomainTitle: "JDB - View Ticket"
                            });
                            //window.open(d.D, 'jdbresult');
                        }
                    });
            },
            openBOOMINGGAMESDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;

                var param = dt.GR;
                param += "&lang=" + that.getLangCode;

                this.getDataApi(`/api/reports/winloss/boominggames/detail?${param}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d) {
                            that.openWindowWithPost("/api/gamereplay", {
                                ReplayUrl: d.D,
                                DomainTitle: "BoomingGames - View Ticket"
                            });
                            //window.open(d.D, 'boominggamesresult');
                        }
                    });
            },
            openKAFishingDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;

                var param = dt.GR;
                param += "&lang=" + that.getLangCode;

                this.getDataApi(`/api/reports/winloss/kafishing/detail?${param}`,
                    function (d, s) {
                        if (s && d) {
                            that.bool_fullLoading = false;
                            that.openWindowWithPost("/api/gamereplay", {
                                ReplayUrl: d.D,
                                DomainTitle: "KA - View Ticket"
                            });
                            //window.open(d.D, 'karesult');
                        }
                    });
            },
            openKASlotDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;

                var param = dt.GR;
                param += "&lang=" + that.getLangCode;

                this.getDataApi(`/api/reports/winloss/kaslot/detail?${param}`,
                    function (d, s) {
                        if (s && d) {
                            that.bool_fullLoading = false;
                            that.openWindowWithPost("/api/gamereplay", {
                                ReplayUrl: d.D,
                                DomainTitle: "KA - View Ticket"
                            });
                            //window.open(d.D, 'karesult');
                        }
                    });
            },
            openLG88Details(dt) {
                var that = this;
                that.bool_fullLoading = true;

                var param = dt.GR;
                param += "&lang=" + that.getLangCode;

                this.getDataApi(`/api/reports/winloss/lg88/detail?${param}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d) {
                            window.open(d.D, 'lg88result');
                        }
                    });
            },
            openJILIDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;

                var param = `${dt.GR}&lang=${that.getLangCode}`;
                this.getDataApi(`/api/reports/winloss/jili/detail?${param}`,
                    function (d, s) {
                        if (s && d) {
                            that.bool_fullLoading = false;
                            that.openWindowWithPost("/api/gamereplay", {
                                ReplayUrl: d.D,
                                DomainTitle: "JILI - View Ticket"
                            });
                            //window.open(d.D, 'jiliresult');
                        }
                    });
            },
            openJILI_V2Details(dt) {
                var that = this;
                that.bool_fullLoading = true;

                var param = `${dt.GR}&lang=${that.getLangCode}`;
                this.getDataApi(`/api/reports/winloss/jili_v2/detail?${param}`,
                    function (d, s) {
                        if (s && d) {
                            that.bool_fullLoading = false;
                            that.openWindowWithPost("/api/gamereplay", {
                                ReplayUrl: d.D,
                                DomainTitle: "JILI - View Ticket"
                            });
                            //window.open(d.D, 'jiliresult');
                        }
                    });
            },
            openNextSpinDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;

                var param = `${dt.GR}&lang=${that.getLangCode}`;
                this.getDataApi(`/api/reports/winloss/nextspin/detail?${param}`,
                    function (d, s) {
                        if (s && d) {
                            that.bool_fullLoading = false;
                            that.openWindowWithPost("/api/gamereplay", {
                                ReplayUrl: d.D,
                                DomainTitle: "NextSpin - View Ticket"
                            });
                            //window.open(d.D, 'nextspinresult');
                        }
                    });
            },
            openMG_SLOTDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;

                var param = `${dt.GR}&lang=${that.getLangCode}`;
                this.getDataApi(`/api/reports/winloss/mg_slot/detail?${param}`,
                    function (d, s) {
                        if (s && d) {
                            that.bool_fullLoading = false;
                            window.open(d.D, 'mg_slotresult');
                        }
                    });
            },
            openMG_LIVEDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;

                var param = `${dt.GR}&lang=${that.getLangCode}`;
                this.getDataApi(`/api/reports/winloss/mg_live/detail?${param}`,
                    function (d, s) {
                        if (s && d) {
                            that.bool_fullLoading = false;
                            window.open(d.D, 'mg_liveresult');
                        }
                    });
            },
            openDCACEDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;

                var param = `${dt.GR}&lang=${that.getLangCode}`;
                this.getDataApi(`/api/reports/winloss/dcace/detail?${param}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d) {
                            try {
                                // Attempt to create a URL object to check if d.D is a valid URL
                                new URL(d.D);
                                // If it's a valid URL, open it
                                window.open(d.D, 'dcaceresult');
                            } catch (e) {
                                // If an error occurs, assume it's HTML and write it to a new window
                                var win = window.open("", "dcaceresult");
                                win.document.write(d.D);
                            }
                        }
                    });
            },
            openVPOWERDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;

                var param = `${dt.GR}&lang=${that.getLangCode}`;
                this.getDataApi(`/api/reports/winloss/vpower/detail?${param}`,
                    function (d, s) {
                        if (s && d) {
                            that.bool_fullLoading = false;
                            window.open(d.D, 'vpowerresult');
                        }
                    });
            },
            openPRETTY_LIVEDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;

                var param = `${dt.GR}&lang=${that.getLangCode}`;
                this.getDataApi(`/api/reports/winloss/prettylive/detail?${param}`,
                    function (d, s) {
                        if (s && d) {
                            that.bool_fullLoading = false;
                            window.open(d.D, 'prettyliveresult');
                        }
                    });
            },
            openIBEX_SLOTDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;

                var param = `${dt.GR}&lang=${that.getLangCode}`;
                this.getDataApi(`/api/reports/winloss/ibex_slot/detail?${param}`,
                    function (d, s) {
                        if (s && d) {
                            that.bool_fullLoading = false;
                            window.open(d.D, 'ibex_slotresult');
                        }
                    });
            },
            openADVANTPLAYDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;
                var param = `${dt.GR}&lang=${that.getLangCode}`;
                this.getDataApi(`/api/reports/winloss/advantplay/detail?${param}`,
                    function (d, s) {
                        if (s && d) {
                            that.bool_fullLoading = false;

                            that.openWindowWithPost("/api/gamereplay", {
                                ReplayUrl: d.D,
                                DomainTitle: "AdvantPlay - View Ticket"
                            });

                            //window.open(d.D, 'advantplayresult');
                        }
                    });
            },
            openWindowWithPost(url, data) {
                var form = document.createElement("form");
                form.target = "_blank";
                form.method = "POST";
                form.action = url;
                form.style.display = "none";



                for (var key in data) {
                    var input = document.createElement("input");
                    input.type = "hidden";
                    input.name = key;
                    input.value = data[key];
                    form.appendChild(input);
                }

                document.body.appendChild(form);

                form.submit();
                document.body.removeChild(form);
            },
            openEBETDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;
                //debugger;
                var param = `${dt.GR}&lang=${that.getLangCode}`;
                this.getDataApi(`/api/reports/winloss/ebet/detail?${param}`,
                    function (d, s) {
                        if (s && d) {
                            that.bool_fullLoading = false;
                            window.open(d.D, 'ebetresult');
                        }
                    });
            },
            openAGDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;

                var param = dt.GR;
                param += "&lang=" + that.getLangCode;

                this.getDataApi(`/api/reports/winloss/ag/detail?${param}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d) {
                            that.openWindowWithPost("/api/gamereplay", {
                                ReplayUrl: d.D,
                                DomainTitle: "ArcadiaGaming - View Ticket"
                            });
                            //window.open(d.D, 'arcadiagamingsresult');
                        }
                    });
            },
            openG9Details(dt) {
                var that = this;
                that.bool_fullLoading = true;

                var param = dt.GR;
                param += "&lang=" + that.getLangCode;

                this.getDataApi(`/api/reports/winloss/9gaming/detail?${param}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d) {
                            that.openWindowWithPost("/api/gamereplay", {
                                ReplayUrl: d.D,
                                DomainTitle: "9Gaming - View Ticket"
                            });
                            //window.open(d.D, '9gamingsresult');
                        }
                    });
            },
            openKINGMAKERDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;

                var param = dt.GR;
                param += "&lang=" + that.getLangCode;

                this.getDataApi(`/api/reports/winloss/kingmaker/detail?${param}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d) {
                            that.openWindowWithPost("/api/gamereplay", {
                                ReplayUrl: d.D,
                                DomainTitle: "KingMaker - View Ticket"
                            });
                            //window.open(d.D, 'kingmakerresult');
                        }
                    });
            },
            openSpribeDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;

                var param = dt.GR;
                param += "&lang=" + that.getLangCode;

                this.getDataApi(`/api/reports/winloss/spribe/detail?${param}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d) {
                            that.openWindowWithPost("/api/gamereplay", {
                                ReplayUrl: d.D,
                                DomainTitle: "Spribe - View Ticket"
                            });
                            //window.open(d.D, 'spribeResult');
                        }
                    });
            },
            openSpadeGamingDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;

                var param = dt.GR;
                param += "&lang=" + that.getLangCode;

                this.getDataApi(`/api/reports/winloss/spadegaming/detail?${param}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d) {
                            that.openWindowWithPost("/api/gamereplay", {
                                ReplayUrl: d.D,
                                DomainTitle: "SpadeGaming - View Ticket"
                            });
                            //window.open(d.D, 'spadeGamingResult');
                        }
                    });
            },
            openUUDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;

                var param = dt.GR;
                param += "&lang=" + that.getLangCode;

                this.getDataApi(`/api/reports/winloss/uu/detail?${param}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d) {
                            that.openWindowWithPost("/api/gamereplay", {
                                ReplayUrl: d.D,
                                DomainTitle: "UUSlot - View Ticket"
                            });
                            //window.open(d.D, 'uuResult');
                        }
                    });
            },
            openWINFINITYDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;

                var param = dt.GR;
                param += "&lang=" + that.getLangCode;

                this.getDataApi(`/api/reports/winloss/winfinity/detail?${param}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d) {
                            try {
                                // Attempt to create a URL object to check if d.D is a valid URL
                                new URL(d.D);
                                // If it's a valid URL, open it
                                window.open(d.D, 'winfinityresult');
                            } catch (e) {
                                // If an error occurs, assume it's HTML and write it to a new window
                                var win = window.open("", "winfinityresult");
                                win.document.write(d.D);
                            }
                        }
                    });
            },
            openLIVE22Details(dt) {
                var that = this;
                that.bool_fullLoading = true;

                var param = dt.GR;
                param += "&lang=" + that.getLangCode;

                this.getDataApi(`/api/reports/winloss/live22/detail?${param}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d) {
                            that.openWindowWithPost("/api/gamereplay", {
                                ReplayUrl: d.D,
                                DomainTitle: "Live22 - View Ticket"
                            });
                            //window.open(d.D, 'kingmakerresult');
                        }
                    });
            },
            //openMIKIWORLDDetails(dt) {
            //    var that = this;
            //    that.bool_fullLoading = true;

            //    var param = dt.GR;
            //    param += "&lang=" + that.getLangCode;

            //    this.getDataApi(`/api/reports/winloss/mikiworld/detail?${param}`,
            //        function (d, s) {
            //            that.bool_fullLoading = false;
            //            if (s && d) {
            //                window.open(d.D, 'mikiworldresult');
            //            }
            //        });
            //},
            getReportURL() {
                var url = '/api/reports/winloss';

                switch (this.reportType) {
                    case "MemberSummary":
                        url += '/all'; //added IsTestUser
                        break;
                    case "N2":
                        url += '/n2'; //added IsTestUser
                        break;
                    case "PS":
                    case "PS_FISHING":
                        url += "/ps"; //added IsTestUser
                        break;
                    case "PGSOFT":
                        url += "/pgsoft"; //added IsTestUser
                        break;
                    case "SA":
                        url += "/sa"; //added IsTestUser
                        break;
                    case "AFBCASINO":
                        url += "/tga"; //added IsTestUser
                        break;
                    case "LIGATOGEL":
                        url += "/ligatogel";    //added IsTestUser
                        break;
                    case "AFB288_LOTTERY":
                        url += "/afb288";    //added IsTestUser
                        break;
                    case "DIAMONDCLUB":
                        url += '/gd88';  //added IsTestUser
                        break;
                    case "AFB1188":
                        url += '/afb1188'; //added IsTestUser
                        break;
                    case "GGCORRECTSCORE":
                    case "MINI_SPORTS":
                        url += '/ggcs'; //added IsTestUser
                        break;
                    case "summary":
                        url += "/summary"; //added IsTestUser
                        break;
                    case "CQ9":
                    case "CQ9_CASINO":
                    case "CQ9_FISHING":
                    case "CQ9_LOTTERY":
                    case "CQ9_LIVE_CASINO":
                        url += "/cq9"; //added IsTestUser
                        break;
                    case "EVOPLAY":
                    case "EVOPLAY_CASINO":
                        url += "/evoplay";  //added IsTestUser
                        break;
                    case "JOKER":
                    case "JOKER_CASINO":
                    case "JOKER_FISHING":
                        url += "/joker";     //added IsTestUser
                        break;
                    case "BETSOFT":
                    case "BETSOFT_CASINO":
                    case "BETSOFT_POKER":
                        url += "/betsoft"; //added IsTestUser
                        break;
                    case "PPLAY":
                    case "PPLAY_CASINO":
                    case "PPLAY_E_CASINO":
                        url += "/pplay"; //added IsTestUser
                        break;
                    case "WM":
                        url += "/wm"    //added IsTestUser
                        break;
                    case "TFG_ESPORTS":
                    case "TFG_ESPORTS_SPORTS":
                        url += '/tfg'; //added IsTestUser
                        break;
                    case "TTG":
                        url += '/ttg';  //added IsTestUser
                        break;
                    case "CONNECT93":
                        url += '/93connect';    //added IsTestUser
                        break;
                    case "AESEXY":
                        url += '/aesexy';    //added IsTestUser
                        break;
                    case "SV388":
                        url += '/sv388';    //added IsTestUser
                        break;
                    case "CF361":
                        url += '/cf361';    //added IsTestUser
                        break;
                    case "DREAMGAME":
                        url += '/dg';    //added IsTestUser
                        break;
                    case "AFBGAMING":
                    case "AFBGAMING_FISHING":
                    case "AFBGAMING_E_CASINO":
                        url += '/afbgaming';    //added IsTestUser
                        break;
                    case "LUCKY361_SLOT":
                        url += '/lucky361';    //added IsTestUser
                        break;
                    case "HABANERO":
                        url += '/habanero';     //added IsTestUser
                        break;
                    case "EACASINO":
                        url += '/eacasino';     //added IsTestUser
                        break;
                    case "SPINOMENAL_SLOT":
                    case "SPINOMENAL_LOTTERY":
                        url += "/spinomenal";    //added IsTestUser
                        break;
                    case "WE1POKER":
                        url += '/we1poker';      //added IsTestUser
                        break;
                    case "NETENT":
                    case "REDTIGER":
                    case "NETENT_E_CASINO":
                    case "REDTIGER_E_CASINO":
                    case "BTG_SLOT":
                    case "EVOLUTION_CASINO":
                    case "NLC_V2_SLOT":
                        url += '/betplay';   //added IsTestUser
                        break;
                    case "SIMPLEPLAY_SLOT":
                    case "SIMPLEPLAY_FISHING":
                    case "SIMPLEPLAY_E_CASINO":
                        url += '/simpleplay';   //added IsTestUser
                        break;
                    case "EBET":
                    case "EBET_SLOT":
                    case "EBET_E_CASINO":
                        url += '/ebet';     //added IsTestUser
                        break;
                    case "CG":
                    case "CG_FISHING":
                    case "CG_VIRTUAL_CASINO":
                    case "CG_E_CASINO":
                        url += '/cg';        //added IsTestUser
                        break;
                    case "JDB_FISHING":
                        url += '/jdb_fishing';  //added IsTestUser
                        break;
                    case "JDB_SLOT":
                        url += '/jdb_slot';   //added IsTestUser
                        break;
                    case "BOOMING_GAMES":
                        url += '/boominggames';   //added IsTestUser
                        break;
                    case "KA_FISHING":
                        url += '/ka_fishing';   //added IsTestUser
                        break;
                    case "KA_SLOT":
                        url += '/ka_slot';   //added IsTestUser
                        break;
                    case "POKERV":
                        url += '/pkv';  //added IsTestUser
                        break;
                    case "LG88":
                        url += '/lg88';      //added IsTestUser
                        break;
                    case "YGGDRASIL":
                    case "YGGDRASIL_E_CASINO":
                        url += '/yggdrasil';    //added IsTestUser
                        break;
                    case "PNG_SLOT":
                        url += '/png_slot';      //added IsTestUser
                        break;
                    case "AUX_SLOT":
                        url += '/aux_slot';      //added IsTestUser
                        break;
                    case "GHG_SLOT":
                        url += '/ghg_slot';     //added IsTestUser
                        break;
                    case "NLC_SLOT":
                        url += '/nlc_slot';     //added IsTestUser
                        break;
                    case "RELAX_SLOT":
                    case "RELAX_E_CASINO":
                        url += '/relax';    //added IsTestUser
                        break;
                    case "AIS_SLOTS":
                        url += '/ais';    //added IsTestUser
                        break;
                    case "JILI_SLOT":
                    case "JILI_FISHING":
                    case "JILI_E_CASINO":
                        url += '/jili';    //added IsTestUser
                        break;
                    case "JILI_V2_SLOT":
                    case "JILI_V2_FISHING":
                    case "JILI_V2_E_CASINO":
                        url += '/jili_v2';    //added IsTestUser
                        break;
                    case "EVO_RACING":
                        url += '/evoracing';    //added IsTestUser
                        break;
                    case "EVO_RACING_VR":
                        url += '/evoracingvr';    //added IsTestUser
                        break;
                    case "ATA_EVOPLAY_SLOT":
                        url += '/ata_evoplay_slot';
                        break;
                    case "SBO_SPORTSBOOK":
                        url += '/sbo_sportsbook';
                        break;
                    case "PGSOFT_THB_SLOT":
                        url += '/pgsoft_thb_slot';
                        break;
                    case "ARCADIA_GAMING":
                        url += '/ag';
                        break;
                    case "NEXTSPIN_SLOT":
                        url += '/nextspin';
                        break;
                    case "LIVE22_SLOT":
                    case "LIVE22_E_CASINO":
                        url += '/live22';
                        break;
                    case "HACKSAW_SLOT":
                        url += '/hacksaw';    //added IsTestUser
                        break;
                    case "ADVANTPLAY_SLOT":
                        url += '/advantplay';
                        break;
                    case "NAGA_SLOT":
                        url += '/naga';
                        break;

                    case "GAMING9_POKER":
                    case "GAMING9_OTHERS":
                        url += '/9gaming';
                        break;
                    case "FIVEMEN_SLOT":
                        url += '/fivemen';
                        break;
                    //case "PUSSY888":
                    //case "PUSSY888_E_CASINO":
                    //case "PUSSY888_FISHING":
                    //case "PUSSY888_UNCATEGORIZED":
                    //    url += '/pussy888';
                    //    break;
                    //case "MEGAV3_SLOT":
                    //case "MEGAV3_E_CASINO":
                    //case "MEGAV3_FISHING":
                    //case "MEGAV3_UNCATEGORIZED":
                    //    url += '/megav3';
                    //    break;
                    case "KISS918_SLOT":
                    case "KISS918_FISHING":
                    case "KISS918_E_CASINO":
                    case "KISS918_UNCATEGORIZED":
                        url += '/kiss918';
                        break;
                    //case "MEGAGAMING_SLOT":
                    //case "MEGAGAMING_E_CASINO":
                    //case "MEGAGAMING_FISHING":
                    //case "MEGAGAMING_UNCATEGORIZED":
                    //    url += '/megagaming';
                    //    break;
                    case "KINGMAKER_CASINO":
                    case "KINGMAKER_SLOTS":
                        url += '/kingmaker';
                        break;
                    case "YGR_SLOT":
                    case "YGR_FISHING":
                        url += '/ygr';
                        break;
                    case "FACHAI_SLOT":
                    case "FACHAI_FISHING":
                    case "FACHAI_E_CASINO":
                        url += '/fachai';
                        break;
                    case "ACE333_SLOT":
                    case "ACE333_E_CASINO":
                        url += '/ace333';
                        break;
                    case "SPRIBE_E_CASINO":
                        url += '/spribe';
                        break;
                    case "SPADEGAMING_SLOT":
                        url += '/spadegaming';
                        break;
                    case "UU_SLOT":
                        url += '/uu';
                        break;
                    case "MIKIWORLD_CASINO":
                    case "MIKIWORLD_E_CASINO":
                        url += '/mikiworld';
                        break;
                    case "WINFINITY_CASINO":
                        url += '/winfinity';
                        break;
                    case "IG_GFC":
                        url += '/ig_gfc';
                        break;
                    case "IG_LOTTERY":
                        url += '/ig_lottery';
                        break;
                    case "IG_LOTTO":
                        url += '/ig_lotto';
                        break;
                    case "DG3D_FISHING":
                        url += '/dg3d_fishing';
                        break;
                    case "NEWKENO_LOTTERY":
                        url += '/newkeno';
                        break;
                    case "SABA_SPORTSBOOK":
                        url += '/saba_sportsbook';
                        break;
                    case "PLAYTECH_SLOT":
                    case "PLAYTECH_E_CASINO":
                    case "PLAYTECH_LIVE_CASINO":
                        url += "/playtech";
                        break;
                    case "W_CASINO":
                        url += '/wcasino';
                        break;
                    case "MG_SLOT":
                        url += '/mg_slot';
                        break;
                    case "MG_LIVE":
                        url += '/mg_live';
                        break;
                    case "DCACE_SLOT":
                        url += '/dcace';
                        break;
                    case "VPOWER":
                        url += '/vpower';
                        break;
                    case "PRETTY_LIVE":
                        url += '/prettylive';
                        break;
                    case "YORIGINAL_E_CASINO":
                        url += '/yoriginal';
                        break;
                    case "IBEX_SLOT":
                        url += '/ibex_slot';
                        break;
                    case "OFA_CASINO":
                        url += '/ofa_casino';
                        break;
                    case "FATPANDA_SLOT":
                        url += '/fatpanda';
                        break;
                    case "AFB1234_LOTTERY":
                        url += '/afb1234';
                        break;
                    case "AFBPOKER":
                        url += '/afbpoker';
                        break;
                }

                return url;
            },
            loadMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddMemberList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    //this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${this.searchAgi}`,
                    this.obj_Post.SelectedBrands1 = this.searchAgi;

                    this.postDataApi(`/api/dd/mreferralbypost/${searchQuery}`, this.obj_Post,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMemberList = d.dropdownlist;
                            }
                            else {
                                that.ddMemberList = [];
                            }

                            callback(null, that.ddMemberList);
                        });
                }
            },
            openMemberWinLossDetail(data) {
                this.ddDefaultMemberList = [
                    { id: data.MI, label: data.U }
                ];

                this.dd_memberKey++;
                this.searchUserId = data.MI;
                this.searchUsername = data.U;
                this.memberName = data.U;
                this.searchCurrency = data.CI;
                this.searchAgi = data.AGI;
                this.searchAgent = data.AGN;
                this.setReportType();
                this.getReportList();
            },
            clickList(data, index, GameResult) {
                if (this.reportType == "AFB1188" || this.reportType == "GGCORRECTSCORE" || this.reportType == "MINI_SPORTS") {
                    if (data.EI == "PAR" || data.EI == "PAM")
                        data.bool_showDetails = !data.bool_showDetails;
                }
                else if (this.reportType == "EVOPLAY_CASINO") {
                    if (data.DT == 0)
                        var path = "p=" + data.GPI + "&agi=" + data.AGI + "&tradeid=" + data.TI;
                    this.getDataApi(`/api/reports/winloss/evoplay/betdetail?${path}`,
                        function (d, s) {
                            if (s && d && d) {
                                data.BTDESCR = d;
                                data.bool_showDetails = !data.bool_showDetails;
                            }
                        });
                }
                else if (this.reportType == "PGSOFT") {
                    if (data.PGSOFTCHILD.length > 1) {
                        data.bool_showDetails = !data.bool_showDetails;
                    }
                }
                else if (this.reportType == "PGSOFT_THB_SLOT") {
                    if (data.PGSOFT_THB_SLOTCHILD.length > 1) {
                        data.bool_showDetails = !data.bool_showDetails;
                    }
                }
                else {
                    data.bool_showDetails = !data.bool_showDetails;
                }
                this.resizeTableHead();
            },
            getProviderName() {
                if (this.reportType in this.getLanguage["GP"]) {
                    return this.getLanguage["GP"][this.reportType];
                }

                return this.reportType;
            },
            gameNameColspan() {
                if (this.reportType == "PS" || this.reportType == "PS_FISHING")
                    return 1;

                return 2;
            },
            gameResultColspan() {
                if (this.reportType == "PS" || this.reportType == "PS_FISHING" || this.reportType == "PGSOFT" || this.reportType == "PGSOFT_THB_SLOT")
                    return 1;

                return 2;
            },

            withBonus() {
                if (
                    //this.reportType == "PS" ||
                    this.reportType == "JOKER" ||
                    this.reportType == "JOKER_CASINO" ||
                    this.reportType == "LIVE22_SLOT" ||
                    this.reportType == "ADVANTPLAY_SLOT" ||
                    this.reportType == "PLAYTECH_SLOT" ||
                    this.reportType == "PLAYTECH_E_CASINO" ||
                    this.reportType == "PLAYTECH_LIVE_CASINO"
                )
                    return true;

                return false;
            },
            withJackpot() {
                if (
                    //this.reportType == "PS" ||
                    this.reportType == "CQ9" ||
                    this.reportType == "PPLAY" ||
                    this.reportType == "PPLAY_CASINO" ||
                    this.reportType == "PPLAY_E_CASINO" ||
                    this.reportType == "PGSOFT" ||
                    this.reportType == "PGSOFT_THB_SLOT" ||
                    this.reportType == "JOKER" ||
                    this.reportType == "JOKER_CASINO" ||
                    this.reportType == "LIVE22_SLOT" ||
                    this.reportType == "ADVANTPLAY_SLOT" ||
                    this.reportType == "GAMING9_OTHERS" ||
                    this.reportType == "PLAYTECH_SLOT" ||
                    this.reportType == "PLAYTECH_E_CASINO" ||
                    this.reportType == "PLAYTECH_LIVE_CASINO" ||
                    this.reportType == "FATPANDA_SLOT"

                )
                    return true;

                return false;
            },
            withSportsBook() {
                if (this.reportType == "AFB1188" || this.reportType == "GGCORRECTSCORE" || this.reportType == "MINI_SPORTS") {
                    return true;
                }
                return false;
            },
            onlyWE1POKER() {
                if (this.searchGameProviderId.includes('43') || this.searchGameProviderId.includes('55') || this.searchGameProviderId.includes('113'))
                    return true;
                return false;
            },
            withWE1POKER() {
                if (this.searchGameProviderId == 43 || this.searchGameProviderId == 55 || this.searchGameProviderId == 113 || this.searchGameProviderId == 117)
                    return true;
                return false;
            },
            formatPT2(data) {
                var result = '';
                switch (this.getUserInfo.AT) {
                    case 0:
                        var PLA = 100 - this.formatNumber(data.WLS) - this.formatNumber(data.SAWLS) - this.formatNumber(data.MAWLS) - this.formatNumber(data.AWLS);

                        if (data.PTPS == 0) {
                            result = this.getLanguage['WLRPT']['PPTP'];
                        }
                        else {
                            result = this.formatNumber(PLA) +
                                "/" + this.formatNumber(data.WLS) +
                                "/" + this.formatNumber(data.SAWLS) +
                                "/" + this.formatNumber(data.MAWLS) +
                                "/" + this.formatNumber(data.AWLS);
                        }

                        this.shareIndicator = this.getLanguage['WLRPT']['PRV'] +
                            "/" + this.getLanguage['WLRPT']['CO'] +
                            "/" + this.getLanguage['WLRPT']['SAG'] +
                            "/" + this.getLanguage['WLRPT']['MAG'] +
                            "/" + this.getLanguage['WLRPT']['AG'];

                        break;
                    case 1:
                        if (data.PTPS == 0) {
                            result = this.getLanguage['WLRPT']['PPTP'];
                        }
                        else {
                            result = this.formatNumber(data.SAWLS) +
                                "/" + this.formatNumber(data.MAWLS) +
                                "/" + this.formatNumber(data.AWLS);
                        }


                        this.shareIndicator = this.getLanguage['WLRPT']['SAG'] +
                            "/" + this.getLanguage['WLRPT']['MAG'] +
                            "/" + this.getLanguage['WLRPT']['AG'];

                        break;
                    case 2:
                        if (data.PTPS == 0) {
                            result = this.getLanguage['WLRPT']['PPTP'];
                        }
                        else {
                            result = this.formatNumber(data.MAWLS) +
                                "/" + this.formatNumber(data.AWLS);
                        }


                        this.shareIndicator = this.getLanguage['WLRPT']['MAG'] +
                            "/" + this.getLanguage['WLRPT']['AG'];

                        break;
                    case 3:
                        if (data.PTPS == 0) {
                            result = this.getLanguage['WLRPT']['PPTP'];
                        }
                        else {
                            result = this.formatNumber(data.AWLS);

                        }
                        this.shareIndicator = this.getLanguage['WLRPT']['AG'];
                        break;
                }

                return result;
            },
            formatPT(data) {
                if (data.ADPT == 0)
                    return this.formatPT2(data);
                var result = '';
                if (data.SSADPT < 2) {
                    data.PPT = data.PPT + data.SSADPT - 2;
                    data.SSADPT = 2;
                }
                switch (this.getUserInfo.AT) {
                    case 0:
                        //var PLA = 100 - this.formatNumber(data.WLS) - this.formatNumber(data.SAWLS) - this.formatNumber(data.MAWLS) - this.formatNumber(data.AWLS);

                        if (data.PTPS == 0) {
                            result = this.getLanguage['WLRPT']['PPTP'];
                        }
                        else {
                            result = this.formatNumber(data.PPT) +
                                "/" + this.formatNumber(data.SSADPT) +
                                "/" + this.formatNumber(data.SADPT) +
                                "/" + this.formatNumber(data.MADPT) +
                                "/" + this.formatNumber(data.ADPT);
                        }

                        this.shareIndicator = this.getLanguage['WLRPT']['PRV'] +
                            "/" + this.getLanguage['WLRPT']['CO'] +
                            "/" + this.getLanguage['WLRPT']['SAG'] +
                            "/" + this.getLanguage['WLRPT']['MAG'] +
                            "/" + this.getLanguage['WLRPT']['AG'];

                        break;
                    case 1:
                        if (data.PTPS == 0) {
                            result = this.getLanguage['WLRPT']['PPTP'];
                        }
                        else {
                            result = this.formatNumber(data.SADPT) +
                                "/" + this.formatNumber(data.MADPT) +
                                "/" + this.formatNumber(data.ADPT);
                        }


                        this.shareIndicator = this.getLanguage['WLRPT']['SAG'] +
                            "/" + this.getLanguage['WLRPT']['MAG'] +
                            "/" + this.getLanguage['WLRPT']['AG'];

                        break;
                    case 2:
                        if (data.PTPS == 0) {
                            result = this.getLanguage['WLRPT']['PPTP'];
                        }
                        else {
                            result = this.formatNumber(data.MADPT) +
                                "/" + this.formatNumber(data.ADPT);
                        }


                        this.shareIndicator = this.getLanguage['WLRPT']['MAG'] +
                            "/" + this.getLanguage['WLRPT']['AG'];

                        break;
                    case 3:
                        if (data.PTPS == 0) {
                            result = this.getLanguage['WLRPT']['PPTP'];
                        }
                        else {
                            result = this.formatNumber(data.ADPT);

                        }
                        this.shareIndicator = this.getLanguage['WLRPT']['AG'];
                        break;
                }

                return result;
            },
            openPGSOFTDetails(dt) {
                var param = dt.GR;
                this.getDataApi(`/api/reports/winloss/pgsoft/r?${param}`, function (d, s) {
                    if (s) {
                        window.open(d, '_blank');
                    }
                });
            },
            SIMPLEPLAY_E_CASINOgameResult(ti, agi, mi) {


            },
            PGSOFT_THB_SLOTgameResult(dt) {
                this.bool_fullLoading = true;
                var param = dt.GR;
                param += "&lang=" + this.getLangCode;
                var that = this;
                this.getDataApi(`/api/reports/winloss/pgsoft_thb_slot/detail?${param}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d) {
                            window.open(d.D, 'pgSoftThbResult');
                        }
                    });
            },
            PGSOFT_THB_SLOTgameResult_WithoutDetail(winLossAmount) {
                var cbd = "";
                if (winLossAmount >= 0) cbd = "won";
                else cbd = "lose";

                let color = "black";
                switch (cbd) {
                    case "won":
                        color = "green";
                        break;
                    case "lose":
                        color = "red";
                        break;
                }

                return `<div style="color: ${color}">${cbd}</div>`;
            },
            displayGameResult(value, recStatus) {
                if (recStatus != 1) return value;
                else return "NA";
            },
            displayExchangeRate(value) {
                return (value / 10000).toFixed(4);
            },
            clearDateRangeFilter() {
                this.searchCreatedTS.startDate = this.getTodayDate();
                this.searchCreatedTS.endDate = this.getMonthEndDate();
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('EPE', 'R', type);
            },
            lg88RenderDetail(gameResult) {
                try {
                    var gameResultObject = JSON.parse(gameResult);

                    var result = "";
                    var betContentResult = "Bet Content:";
                    if (gameResultObject["GR"]["round_details"]["banker"] != undefined) {
                        result += this.getLanguage["BETRPT"]["G"] + ":" + this.getLanguage["LG88"]["BACCARAT"] + "<br />";
                        result += this.getLanguage["LG88"]["BANKER"] + ":" + this.lg88RenderPorker(gameResultObject["GR"]["round_details"]["banker"]) + "<br />";
                        result += this.getLanguage["LG88"]["PLAYER"] + ":" + this.lg88RenderPorker(gameResultObject["GR"]["round_details"]["player"]);
                        betContentResult += this.lg88RenderBetContent(0, gameResultObject["BT"]);
                    }
                    else if (gameResultObject["GR"]["round_details"]["dragon"] != undefined) {
                        result += this.getLanguage["BETRPT"]["G"] + ":" + this.getLanguage["LG88"]["DRAGONTIGER"] + "<br />";
                        result += this.getLanguage["LG88"]["DRAGON"] + ":" + this.lg88RenderPorker(gameResultObject["GR"]["round_details"]["dragon"]) + "<br />";
                        result += this.getLanguage["LG88"]["TIGER"] + ":" + this.lg88RenderPorker(gameResultObject["GR"]["round_details"]["tiger"]);
                        betContentResult += this.lg88RenderBetContent(1, gameResultObject["BT"]);
                    }
                    else if (gameResultObject["GR"]["round_details"]["n"] != undefined) {
                        result += this.getLanguage["BETRPT"]["G"] + ":" + this.getLanguage["LG88"]["ROULETTE"] + "<br />";
                        result += gameResultObject["GR"]["round_details"]["n"];
                        betContentResult += this.lg88RenderBetContent(2, gameResultObject["BT"]);
                    }
                    else {
                        result += this.getLanguage["BETRPT"]["G"] + ":" + this.getLanguage["LG88"]["SICBO"] + "<br />";
                        result += this.lg88RenderSicbo(gameResultObject["GR"]["round_details"]);
                        betContentResult += this.lg88RenderBetContent(3, gameResultObject["BT"]);
                    }

                    return result + "<br />" + betContentResult;
                }
                catch (e) { return ""; }
            },
            lg88RenderPorker(numstring) {
                var numstringArray = numstring.split('*');
                var result = "";
                for (var i = 0; i < numstringArray.length; i++) {
                    var num = parseInt(numstringArray[i])
                    switch ((num / 13) && + (num / 13) | 0 || 0) {
                        case 0:
                            result += "<img src=\"/Content/img/spade.png\" class=\"gr-icon\">";
                            break;
                        case 1:
                            result += "<img src=\"/Content/img/heart.png\" class=\"gr-icon\">";
                            break;
                        case 2:
                            result += "<img src=\"/Content/img/club.png\" class=\"gr-icon\">";
                            break;
                        case 3:
                            result += "<img src=\"/Content/img/diamond.png\" class=\"gr-icon\">";
                            break;
                    }
                    switch ((num % 13) && + (num % 13) | 0 || 0) {
                        case 0:
                            result += "A";
                            break;
                        case 10:
                            result += "J";
                            break;
                        case 11:
                            result += "Q";
                            break;
                        case 12:
                            result += "K";
                            break;
                        default:
                            result += ((num % 13) && + (num % 13) | 0 || 0) + 1;
                    }
                }
                return result;
            },
            lg88RenderSicbo(numArray) {
                var result = "";
                for (var i = 0; i < numArray.length; i++) {
                    result += "<img src=\"/Content/img/dice-" + numArray[i] + ".png\" class=\"gr-fishing\">";
                }
                return result;
            },
            lg88RenderBetContent(type, contentArray) {
                var contentFormat;
                var result = "";
                switch (type) {
                    case 0:
                        contentFormat = ["Banker", "Tie", "Player", "Small", "Big", "Banker Pair", "Player Pair", "Banker Pair of no commission"];
                        break;
                    case 1:
                        contentFormat = ["Dragon", "Tie", "Tiger", "Dragon Odd", "Dragon Even", "Dragon Red", "Dragon Black", "Tiger Odd", "Tiger Even", "Tiger Red", "Tiger Black"];
                        break;
                    case 2:
                        contentFormat = ["Red", "Black", "Odd", "Event", "Small", "Big", "Dozen[1-12]", "Dozen[13-24]", "Dozen[25-36]", "Column[1,4,7,10,13,16,19,22,25,28,31,34]", "Column[2,5,8,11,14,17,20,23,26,29,32,35]", "Column[3,6,9,12,15,18,21,24,27,30,33,36]", "Line[1-6]", "Line[4-9]", "Line[7-12]", "Line[10-15]", "Line[13-18]", "Line[16-21]", "Line[19-24]", "Line[22-27]", "Line[25-30]", "Line[28-33]", "Line[31-36]", "Corner[1,2,4,5]", "Corner[2,3,5,6]", "Corner[4,5,7,8]", "Corner[5,6,8,9]", "Corner[7,8,10,11]", "Corner[8,9,11,12]", "Corner[10,11,13,14]", "Corner[11,12,14,15]", "Corner[13,14,16,17]", "Corner[14,15,17,18]", "Corner[16,17,19,20]", "Corner[17,18,20,21]", "Corner[19,20,22,23]", "Corner[20,21,23,24]", "Corner[22,23,25,26]", "Corner[23,24,26,27]", "Corner[25,26,28,29]", "Corner[26,27,29,30]", "Corner[28,29,31,32]", "Corner[29,30,32,33]", "Corner[31,32,34,35]", "Corner[32,33,35,36]", "Number[0,1,2,3]", "Street[1,2,3]", "Street[4,5,6]", "Street[7,8,9]", "Street[10,11,12]", "Street[13,14,15]", "Street[16,17,18]", "Street[19,20,21]", "Street[22,23,24]", "Street[25,26,27]", "Street[28,29,30]", "Street[31,32,33]", "Street[34,35,36]", "Street[0,1,2]", "Street[0,2,3]", "Split 2 Number[0,1]", "Split 2 Number[0,2]", "Split 2 Number[0,3]", "Split 2 Number[1,2]", "Split 2 Number[2,3]", "Split 2 Number[1,4]", "Split 2 Number[2,5]", "Split 2 Number[3,6]", "Split 2 Number[4,5]", "Split 2 Number[5,6]", "Split 2 Number[4,7]", "Split 2 Number[5,8]", "Split 2 Number[6,9]", "Split 2 Number[7,8]", "Split 2 Number[8,9]", "Split 2 Number[7,10]", "Split 2 Number[8,11]", "Split 2 Number[9,12]", "Split 2 Number[10,11]", "Split 2 Number[11,12]", "Split 2 Number[10,13]", "Split 2 Number[11,14]", "Split 2 Number[12,15]", "Split 2 Number[13,14]", "Split 2 Number[14,15]", "Split 2 Number[13,16]", "Split 2 Number[14,17]", "Split 2 Number[15,18]", "Split 2 Number[16,17]", "Split 2 Number[17,18]", "Split 2 Number[16,19]", "Split 2 Number[17,20]", "Split 2 Number[18,21]", "Split 2 Number[19,20]", "Split 2 Number[20,21]", "Split 2 Number[19,22]", "Split 2 Number[20,23]", "Split 2 Number[21,24]", "Split 2 Number[22,23]", "Split 2 Number[23,24]", "Split 2 Number[22,25]", "Split 2 Number[23,26]", "Split 2 Number[24,27]", "Split 2 Number[25,26]", "Split 2 Number[26,27]", "Split 2 Number[25,28]", "Split 2 Number[26,29]", "Split 2 Number[27,30]", "Split 2 Number[28,29]", "Split 2 Number[29,30]", "Split 2 Number[28,31]", "Split 2 Number[29,32]", "Split 2 Number[30,33]", "Split 2 Number[31,32]", "Split 2 Number[32,33]", "Split 2 Number[31,34]", "Split 2 Number[32,35]", "Split 2 Number[33,36]", "Split 2 Number[34,35]", "Split 2 Number[35,36]", "Number 0", "Number 1", "Number 2", "Number 3", "Number 4", "Number 5", "Number 6", "Number 7", "Number 8", "Number 9", "Number 10", "Number 11", "Number 12", "Number 13", "Number 14", "Number 15", "Number 16", "Number 17", "Number 18", "Number 19", "Number 20", "Number 21", "Number 22", "Number 23", "Number 24", "Number 25", "Number 26", "Number 27", "Number 28", "Number 29", "Number 30", "Number 31", "Number 32", "Number 33 ", "Number 34 ", "Number 35", "Number 36"];
                        break;
                    case 3:
                        contentFormat = ["Big", "Small", "Odd", "Even", "Any Triple", "Triple 1", "Triple 2", "Triple 3", "Triple 4", "Triple 5", "Triple 6", "Dice 1", "Dice 2", "Dice 3", "Dice 4", "Dice 5", "Dice 6", "Pair 1", "Pair 2", "Pair 3", "Pair 4", "Pair 5", "Pair 6", "1 and 2", "1 and 3", "1 and 4", "1 and 5", "1 and 6", "2 and 3", "2 and 4", "2 and 5", "2 and 6", "3 and 4", "3 and 5", "3 and 6", "4 and 5", "4 and 6", "5 and 6", "Total Point 4", "Total Point 17", "Total Point 5", "Total Point 16", "Total Point 6", "Total Point 15", "Total Point 7", "Total Point 14", "Total Point 8", "Total Point 13", "Total Point 9", "Total Point 10", "Total Point 11", "Total Point > 12"];
                        break;
                }

                for (var i = 0; i < contentArray.length; i++) {
                    result += "<br />" + contentFormat[contentArray[i]["type"] - 1] + " (Amount:" + contentArray[i]["value"] + ")";
                }

                return result;
            },
            generateEndTime(RS, CTS, RTS) {
                var result = "";
                try {
                    if (RS == 2) {
                        if (CTS > RTS) {
                            result = this.formatDateTime(CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss", true) + "*";
                        }
                        else {
                            result = this.formatDateTime(RTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss", true);
                        }

                    }
                    else {
                        result = "N/A";
                    }
                }
                catch (e) {
                    console.log(e);
                }
                return result;
            },
            getMemberTypeList() {
                this.dd_userType = [{ id: '1', label: this.getLanguage['MEM']['NMEM'] }, { id: '2', label: this.getLanguage['MEM']['TMEM'] }];
            },
            resetColumn(headerName) {
                var that = this;
                if (that.getUserInfo.AT >= 1) {
                    that.removeDefaultColumn('SAWL')
                    that.removeDefaultColumn('PSMC')
                }
                if (that.getUserInfo.AT >= 2) {
                    that.removeDefaultColumn('MAWL')
                    that.removeDefaultColumn('PMAC')
                }
                if (that.getUserInfo.AT >= 3) {
                    that.removeDefaultColumn('AWL')
                    that.removeDefaultColumn('PAC')
                }

                for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                    that.$set(that.reportHeaders, i, that.defaultReportHeaders[i])
                }
                this.resizeTableHead();
            },
            removeColumn(headerName) {
                var that = this;
                const index = that.reportHeaders.indexOf(headerName);
                if (index > -1)
                    that.reportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            removeDefaultColumn(headerName) {
                var that = this;
                const index = that.defaultReportHeaders.indexOf(headerName);
                if (index > -1)
                    that.defaultReportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            resetColumn1(headerName) {
                var that = this;
                if (that.hideBrand) {
                    that.removeDefaultColumn2('Brand')
                }
                if (that.getUserInfo.AT >= 1) {
                    that.removeDefaultColumn2('SAWL')
                    that.removeDefaultColumn2('PSMC')
                }
                if (that.getUserInfo.AT >= 2) {
                    that.removeDefaultColumn2('MAWL')
                    that.removeDefaultColumn2('PMAC')
                }
                if (that.getUserInfo.AT >= 3) {
                    that.removeDefaultColumn2('AWL')
                    that.removeDefaultColumn2('PAC')
                }

                for (var i = 0; i < that.defaultReportHeaders1.length; i++) {
                    if (that.reportHeaders1.indexOf(that.defaultReportHeaders1[i]) == -1)
                        that.reportHeaders1.splice(i, 0, that.defaultReportHeaders1[i]);
                }
                for (var i = 0; i < that.reportHeaders1.length; i++) {
                    if (that.defaultReportHeaders1.indexOf(that.reportHeaders1[i]) == -1)
                        that.removeColumn1(that.reportHeaders1[i]);
                }
                this.resizeTableHead();
            },
            removeColumn1(headerName) {
                var that = this;
                const index = that.reportHeaders1.indexOf(headerName);
                if (index > -1)
                    that.reportHeaders1.splice(index, 1);
                this.resizeTableHead();
            },
            removeDefaultColumn1(headerName) {
                var that = this;
                const index = that.defaultReportHeaders1.indexOf(headerName);
                if (index > -1)
                    that.defaultReportHeaders1.splice(index, 1);
                this.resizeTableHead();
            },
            resetColumn2(headerName) {
                var that = this;
                if (that.hideBrand) {
                    that.removeDefaultColumn2('Brand')
                }
                if (that.getUserInfo.AT >= 1) {
                    that.removeDefaultColumn2('SAWL')
                    that.removeDefaultColumn2('PSMC')
                }
                if (that.getUserInfo.AT >= 2) {
                    that.removeDefaultColumn2('MAWL')
                    that.removeDefaultColumn2('PMAC')
                }
                if (that.getUserInfo.AT >= 3) {
                    that.removeDefaultColumn2('AWL')
                    that.removeDefaultColumn2('PAC')
                }

                for (var i = 0; i < that.defaultReportHeaders2.length; i++) {
                    if (that.reportHeaders2.indexOf(that.defaultReportHeaders2[i]) == -1)
                        that.reportHeaders2.splice(i, 0, that.defaultReportHeaders2[i]);
                }
                for (var i = 0; i < that.reportHeaders2.length; i++) {
                    if (that.defaultReportHeaders2.indexOf(that.reportHeaders2[i]) == -1)
                        that.removeColumn2(that.reportHeaders2[i]);
                }
                this.resizeTableHead();
            },
            removeColumn2(headerName) {
                var that = this;
                const index = that.reportHeaders2.indexOf(headerName);
                if (index > -1)
                    that.reportHeaders2.splice(index, 1);
                this.resizeTableHead();
            },
            removeDefaultColumn2(headerName) {
                var that = this;
                const index = that.defaultReportHeaders2.indexOf(headerName);
                if (index > -1)
                    that.defaultReportHeaders2.splice(index, 1);
                this.resizeTableHead();
            },
            loadCurrencyOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/cur/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddCurrencyList = d.dropdownlist;

                            if (that.ddCurrencyList.length > 0) {
                                if (localStorage.getItem('CCUSD') != "") {
                                    for (var i = 0; i < that.ddCurrencyList.length; i++) {
                                        if (that.ddCurrencyList[i].id == localStorage.getItem('CCUSD')) {
                                            that.searchCurrency = that.ddCurrencyList[i].id;
                                            break;
                                        }
                                    }
                                }
                                //========= set default convert currency to USD====
                                else {
                                    if (that.bool_isFirstLoad && !that.searchCurrency) {
                                        for (var i = 0; i < that.ddCurrencyList.length; i++) {
                                            if (that.ddCurrencyList[i].label == 'USD') {
                                                that.searchCurrency = that.ddCurrencyList[i].id;
                                                break;
                                            }
                                        }

                                    }
                                }
                                that.bool_isFirstLoad = false;
                            }
                        }
                        else {
                            that.ddCurrencyList = null;
                            that.searchCurrency = null;
                        }

                        callback();
                    });
            },
            updateCC() {
                if (this.searchCurrency == null) {
                    localStorage.setItem('CCUSD', "");
                }
                else {
                    localStorage.setItem('CCUSD', this.searchCurrency);

                }
            },
            hideElement(header) {
                if ((header == 'CurrencyRate' && (!this.onlyWE1POKER() || (this.searchGameProviderId.length == 0 && this.searchUserId == null) || this.searchGameProviderId == 55)) ||
                    (header == 'Turnover' && ((this.searchGameProviderId.length == 0 && this.searchUserId == null) || this.searchGameProviderId == 55)) ||
                    (header == 'Bonus' && !this.withBonus()) ||
                    (header == 'Jackpot' && !this.withJackpot()) ||
                    (header == 'ProviderName' && !this.withSportsBook()) ||
                    (header == 'EventInfo' && !this.withSportsBook()) ||
                    (header == 'MemberWL' && ((this.searchGameProviderId.length == 0 && this.searchUserId == null) || this.searchGameProviderId == 55)) ||
                    (header == 'AWR' && ((this.searchGameProviderId.length == 0 && this.searchUserId == null) || this.searchGameProviderId == 55)) ||
                    (header == 'ProviderWL' && ((this.searchGameProviderId.length == 0 && this.searchUserId == null) || this.searchGameProviderId == 55)) ||
                    (header == 'CompanyWL' && ((this.searchGameProviderId.length == 0 && this.searchUserId == null) || this.searchGameProviderId == 55)) ||
                    (header == 'SMWL' && (this.getUserInfo.AT > 0 || (this.searchGameProviderId.length == 0 && this.searchUserId == null) || this.searchGameProviderId == 55)) ||
                    (header == 'MAWL' && (this.getUserInfo.AT > 1 || (this.searchGameProviderId.length == 0 && this.searchUserId == null) || this.searchGameProviderId == 55)) ||
                    (header == 'AGWL' && (this.getUserInfo.AT > 2 || (this.searchGameProviderId.length == 0 && this.searchUserId == null) || this.searchGameProviderId == 55)) ||
                    (header == 'Share' && ((this.searchGameProviderId.length == 0 && this.searchUserId == null) || this.searchGameProviderId == 55)) ||
                    (header == 'LTP' && ((this.searchGameProviderId.length == 0 && this.searchUserId == null) || !this.onlyWE1POKER())) //!this.searchGameProviderId.includes('43')
                ) {
                    return 'd-none hidden';
                } else if (header == 'UserID') {
                    return "kema-eft";
                }
                return '';
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                if (this.$el.querySelectorAll('#tBody').length === 1) {
                    const header = this.$el.querySelector("#tHead");
                    const body = this.$el.querySelector("#tBody");

                    header.addEventListener("scroll", () => {
                        body.scrollLeft = header.scrollLeft;
                    });

                    body.addEventListener("scroll", () => {
                        header.scrollLeft = body.scrollLeft;
                    });
                }
                if (this.$el.querySelectorAll('#tBody1').length === 1) {
                    const header1 = this.$el.querySelector("#tHead1");
                    const body1 = this.$el.querySelector("#tBody1");

                    header1.addEventListener("scroll", () => {
                        body1.scrollLeft = header1.scrollLeft;
                    });

                    body1.addEventListener("scroll", () => {
                        header1.scrollLeft = body1.scrollLeft;
                    });
                }
                if (this.$el.querySelectorAll('#tBody2').length === 1) {
                    const header2 = this.$el.querySelector("#tHead2");
                    const body2 = this.$el.querySelector("#tBody2");

                    header2.addEventListener("scroll", () => {
                        body2.scrollLeft = header2.scrollLeft;
                    });

                    body2.addEventListener("scroll", () => {
                        header2.scrollLeft = body2.scrollLeft;
                    });
                }
            },
            calculateWidths() {
                // Reset scroll positions for all headers and bodies
                ['#tHead', '#tBody', '#tHead1', '#tBody1', '#tHead2', '#tBody2'].forEach((selector) => {
                    $(selector).scrollLeft(0);
                });

                if (this.$el.querySelectorAll('#tBody').length === 1) {
                    const tables = this.$el.querySelectorAll('#tBody .custom-table');
                    const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(5) th');

                    if (!headerCells.length) return;

                    tables.forEach((table) => {
                        const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                        if (!bodyCells.length) return;

                        // Reset all widths
                        [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                        // Apply new widths
                        bodyCells.forEach((cell, index) => {
                            const width = `${cell.getBoundingClientRect().width}px`;
                            if (headerCells[index]) headerCells[index].style.width = width;
                            table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                        });
                    });
                }
                if (this.$el.querySelectorAll('#tBody1').length === 1) {
                    const tables1 = this.$el.querySelectorAll('#tBody1 .custom-table');
                    let headerCells1 = this.$el.querySelectorAll('#tHead1 .custom-table thead tr:nth-child(5) th');
                    if (!headerCells1.length) {
                        headerCells1 = this.$el.querySelectorAll('#tHead1 .custom-table thead tr:nth-child(1) th');
                        if (!headerCells1.length) {
                            return;
                        }
                    }

                    tables1.forEach((table) => {
                        const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                        if (!bodyCells.length) return;

                        // Reset all widths
                        [...headerCells1, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                        // Apply new widths
                        bodyCells.forEach((cell, index) => {
                            const width = `${cell.getBoundingClientRect().width}px`;
                            if (headerCells1[index]) headerCells1[index].style.width = width;
                            table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                        });
                    });
                }
                if (this.$el.querySelectorAll('#tBody2').length === 1) {
                    const tables2 = this.$el.querySelectorAll('#tBody2 .custom-table');
                    const headerCells2 = this.$el.querySelectorAll('#tHead2 .custom-table thead tr:nth-child(5) th');

                    if (!headerCells2.length) return;

                    tables2.forEach((table) => {
                        const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                        if (!bodyCells.length) return;

                        // Reset all widths
                        [...headerCells2, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                        // Apply new widths
                        bodyCells.forEach((cell, index) => {
                            const width = `${cell.getBoundingClientRect().width}px`;
                            if (headerCells2[index]) headerCells2[index].style.width = width;
                            table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                        });
                    });
                }
            },
            initTableObserver() {
                const bodyTables = [
                    this.$el.querySelector('#tBody'),
                    this.$el.querySelector('#tBody1'),
                    this.$el.querySelector('#tBody2'),
                ];

                // Create a single MutationObserver instance
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                // Observe each table
                bodyTables.forEach((table) => {
                    if (table) {
                        observer.observe(table, { childList: true, subtree: true });
                    }
                });

                this.calculateWidths();
            },

            SubAgentGroupChangefs(value) {
                if (value != undefined) {
                    var that = this;
                    var agi = 0;

                    if (value != "") {
                        agi = value;
                    }

                    this.getDataApi(`/api/dd/dadn/` + agi,
                        function (d, s) {
                            if (s) {
                                that.searchSubAgent = agi;
                            }
                        });
                }
                else {
                    this.searchSubAgent = null;
                }
            },
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;
                if (this.searchAgent) {
                    var agiSelectedValue = this.searchAgent[0];

                    var agentList = agiSelectedValue.split("-");
                    if (agentList.length > 0) {
                        parentAGI = agentList[1];
                    }
                }
                else if (this.getUserInfo.AT === 4) {
                    parentAGI = 0;
                }
                else if (this.getUserInfo.AT != 3) {
                    this.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PSAA']);
                    return;
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.dd_subagentgroup = d.dropdownlist;
                                //that.bool_cacheOptionValue = true;
                            }
                            else {
                                that.dd_subagentgroup = [];
                            }
                            callback(null, that.dd_subagentgroup);
                        });
                }
            },
            loadDefaultSubBrand(agi) {
                var that = this;
                var searchQuery = "0";

                this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${agi}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddDefaultSubBrand = d.dropdownlist;
                            that.searchSubAgent = that.ddDefaultSubBrand[0].id;
                            that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                        }
                        else {
                            that.ddDefaultSubBrand = [];
                        }
                        //that.getReportList();
                        if (that.$route.query.as == 't') {
                            window.setTimeout(function () {
                                that.setReportType();
                                that.getReportList();
                            }, 1000);
                        }
                    });
            },
            withTransferWallet() {
                if (this.reportType == "MEGAGAMING_SLOT" || this.reportType == "MEGAGAMING_E_CASINO" || this.reportType == "MEGAGAMING_FISHING" ||
                    this.reportType == "MEGAV3_SLOT" || this.reportType == "MEGAV3_FISHING" || this.reportType == "MEGAV3_E_CASINO" ||
                    this.reportType == "PUSSY888" || this.reportType == "PUSSY888_E_CASINO" || this.reportType == "PUSSY888_FISHING" ||
                    this.reportType == "KISS918_SLOT" || this.reportType == "KISS918_FISHING" || this.reportType == "KISS918_E_CASINO" ||
                    this.reportType == "IG_GFC" || this.reportType == "IG_LOTTERY" || this.reportType == "IG_LOTTO" ||
                    this.reportType == "DG3D_FISHING" || this.reportType == "WICKET9_SPORTSBOOK") {
                    return true;
                }
                return false;
            },
            MarginCal(winloss, turnover, ISOC) {
                var formatWinloss = this.formatNumber(winloss, 2, ISOC, false);
                var formatTurnover = this.formatNumber(turnover, 2, ISOC, false);
                formatWinloss = Number(formatWinloss.toString().replaceAll(',', ''));
                formatTurnover = Number(formatTurnover.toString().replaceAll(',', ''));
                var result = (formatWinloss / formatTurnover) * -100;
                return result;
            },
            selectMemberOptions(node, instanceId) {
                if (this.ddMemberList && this.ddMemberList.length > 0) {
                    var index = -1;
                    for (var i = 0; i < this.ddMemberList.length; i++) {
                        if (this.ddMemberList[i].id == node) {
                            this.searchUsername = this.ddMemberList[i].label;
                            break;
                        }
                    }                    
                }
                else {
                    this.searchUsername = null;
                }                
            },
            deSelectMemberOptions(node, instanceId) {                
                this.searchUserId = null;
                this.searchUsername = null;
                this.setReportType();
            },
        },
        computed: {
            ...mapGetters('Language', ['getLanguage', 'getLangCode']),
            ...mapGetters('UserInfo', ['getUserMemberSC', 'getUserInfo', 'checkModuleAccess', 'checkModuleIndex']),

            shouldShowFreeSpin() {
                // Check if searchUserId is truthy and searchGameProviderId exists and has length
                if (!this.searchUserId || !this.searchGameProviderId || !this.searchGameProviderId.length) {
                    return false;
                }

                return this.searchGameProviderId.some(providerId => {
                    const categoryId = this.providerCategories[providerId];
                    return categoryId === '5'; // Your slot category ID
                });
            }
        },
        created() {

            this.$parent.showSubMenu = 'R';
            this.$parent.showSubSubMenu = 'RS3';
            this.$parent.showActiveMenu = 'R.WINLV2';

            this.hideBrand = this.getUserInfo.IHAGIF;
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;

            //if (this.$route.query.agi && this.$route.query.agi > 0) {
            //    this.searchAgi = this.$route.query.agi;
            //    this.searchAgent = '3-' + this.searchAgi;
            //    sessionStorage.setItem('FilterAGI', this.$route.query.ut);
            //} else {
            //    var FilterAGI = sessionStorage.getItem('FilterAGI');
            //    if (FilterAGI) {
            //        this.searchAgi = FilterAGI;
            //        this.searchAgent = '3-' + this.searchAgi;
            //        sessionStorage.removeItem('FilterAGI');
            //    }
            //}
            if (this.$route.query.back && this.$route.query.back == 1) {
                var FilterAGI = sessionStorage.getItem('WINLV2_FilterAGI');
                var FilterAgent = sessionStorage.getItem('WINLV2_FilterAgent');
                if (FilterAGI && FilterAgent) {
                    //var that = this;
                    this.searchAgi = FilterAGI;
                    this.searchAgent = FilterAgent.split(',');
                    //this.getDataApi(`/api/dd/ag/1/0/1`,
                    //    function (d, s) {
                    //        if (s && d && d.dropdownlist) {
                    //            that.ddAgentList = d.dropdownlist;
                    //        }
                    //    });
                }

                var FilterSAGI = sessionStorage.getItem('WINLV2_FilterSAGI');
                if (FilterSAGI) {
                    this.searchSubAgent = FilterSAGI;
                }

                var FilterGPI = sessionStorage.getItem('WINLV2_FilterGPI');
                if (FilterGPI) {
                    this.searchGameProviderId = FilterGPI.split(',');
                    this.arr_displayGPI = this.searchGameProviderId.map(Number);
                }

                var FilterMI = sessionStorage.getItem('WINLV2_FilterMI');
                var FilterMName = sessionStorage.getItem('WINLV2_FilterMName');
                if (FilterMI && FilterMName) {
                    this.searchUserId = FilterMI;
                    this.searchUsername = FilterMName;
                    this.ddDefaultMemberList = [
                        { id: this.searchUserId, label: this.searchUsername }
                    ];
                }

                var FilterITU = sessionStorage.getItem('WINLV2_FilterITU');
                if (FilterITU) {
                    this.searchIsTester = FilterITU;
                }

                var FilterCI = sessionStorage.getItem('WINLV2_FilterCI');
                if (FilterCI) {
                    this.searchCurrency = FilterCI;
                }

                var FilterCIF = sessionStorage.getItem('WINLV2_FilterCIF');
                if (FilterCIF) {
                    this.searchCurrencyFilter = FilterCIF;
                }

                var FilterSTS_from = sessionStorage.getItem('WINLV2_FilterSTS_from');
                if (FilterSTS_from) {
                    this.searchCreatedTS.startDate = FilterSTS_from;
                    var dateObj = new Date(FilterSTS_from);
                    if (dateObj != "Invalid Date" && FilterSTS_from != "" && dateObj < this.minStartDate) {
                        this.searchCreatedTS.startDate = this.minStartDate;
                    }
                }

                var FilterSTS_to = sessionStorage.getItem('WINLV2_FilterSTS_to');
                if (FilterSTS_to) {
                    this.searchCreatedTS.endDate = FilterSTS_to;
                }

                var FilterVDP = sessionStorage.getItem('WINLV2_FilterVDP');
                if (FilterVDP) {
                    this.searchVDP = FilterVDP;
                }

                var FilterFreeSpin = sessionStorage.getItem('WINLV2_FilterFreeSpin');
                if (FilterFreeSpin) {
                    this.searchFreeSpin = FilterFreeSpin;
                }

                var FilterWLT = sessionStorage.getItem('WINLV2_FilterWLT');
                if (FilterWLT) {
                    this.searchWinLossType = FilterWLT;
                }
            } else {
                if (this.$route.query.sagi && this.$route.query.sagi != 0) {
                    this.searchAgent = Array.isArray(this.$route.query.sagi) ? this.$route.query.sagi : [this.$route.query.sagi];
                    //if (this.$route.query.agi && this.$route.query.agi != 0) {
                    //    this.searchAgi = this.$route.query.agi;
                    //    var tempAgent = this.searchAgent[0].split('-');
                    //    if (parseInt(tempAgent[0]) < 3) {
                    //        var that = this;
                    //        this.getDataApi(`/api/dd/agilist/${tempAgent[1]}`,
                    //            function (d, s) {
                    //                if (s && d) {
                    //                    that.searchAgi = d;
                    //                    that.searchAgent = [];
                    //                    var agentList = that.searchAgi.split(',');
                    //                    for (var i = 0; i < agentList.length; i++) {
                    //                        that.searchAgent.push("3-" + agentList[i]);
                    //                    }
                    //                }
                    //            });
                    //    }
                    //}

                    if (this.$route.query.agi) {
                        var AGIList = ($.isArray(this.$route.query.agi) ? this.$route.query.agi : [this.$route.query.agi]);
                        var temp = "";
                        for (var x = 0; x < AGIList.length; x++) {
                            if (x != 0) {
                                temp += ",";
                            }
                            var split = AGIList[x].split("-");

                            if (split.length == 2) {
                                temp += split[1];
                            }
                            else {
                                temp += split[0];
                            }
                        }
                        this.searchAgi = temp;                        
                    }

                    if (this.$route.query.subagi && this.$route.query.subagi != 0) {
                        this.searchSubAgent = Array.isArray(this.$route.query.subagi) ? this.$route.query.subagi : [this.$route.query.subagi];
                        this.loadDefaultSubBrand(this.searchSubAgent);
                    }
                }

                if (this.$route.query.gpi) {                    
                    this.searchGameProviderId = ($.isArray(this.$route.query.gpi) ? this.$route.query.gpi : [this.$route.query.gpi]);                                      
                }

                if (this.$route.query.ut) {
                    this.searchIsTester = this.$route.query.ut;
                }

                if (this.$route.query.wlt) {
                    this.searchWinLossType = this.$route.query.wlt;
                }

                // if (this.$route.query.cur) {
                //     this.searchCurrency = this.$route.query.cur;
                // }



                if (this.$route.query.df) {
                    var date = this.$route.query.df;
                    this.searchCreatedTS.startDate = date;
                    var dateObj = new Date(date);
                    if (dateObj != "Invalid Date" && date != "" && dateObj < this.minStartDate) {
                        this.searchCreatedTS.startDate = this.minStartDate;
                    }
                }

                if (this.$route.query.dt) {
                    this.searchCreatedTS.endDate = this.$route.query.dt;
                }

                if (this.$route.query.i && this.$route.query.u) {
                    this.searchUserId = this.$route.query.i;
                    this.searchUsername = this.$route.query.u;
                    this.memberName = this.searchUsername;
                    this.ddDefaultMemberList = [
                        { id: this.searchUserId, label: this.searchUsername }
                    ];
                }
            }
            if (this.getUserInfo.AT == 4)
                this.loadDefaultSubBrand(0);
            else if (this.$route.query.as == 't') {
                var that = this;
                window.setTimeout(function () {                   
                    that.setReportType();
                    that.getReportList();
                }, 1000);
                this.backURL = sessionStorage.getItem(this.$route.path);
            }
            else {
                sessionStorage.setItem(this.$route.path, '');
            }
            this.getMemberTypeList();
            this.getDropdownList();
            this.reportHeaders = null;
            this.reportHeaders1 = null;
            this.reportHeaders2 = null;
        },
        watch: {
            reportHeaders() {
                var that = this;
                if (this.reportHeaders == null) {
                    this.getDataApi(`/api/reports/gc/WinLossTicketV2`,
                        function (d, s) {
                            if (s) {
                                if (d == null) {
                                    that.reportHeaders = [];
                                    for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                                        if (that.reportHeaders.indexOf(that.defaultReportHeaders[i]) == -1)
                                            that.reportHeaders.push(that.defaultReportHeaders[i]);
                                    }
                                }
                                else {
                                    try {
                                        that.reportHeaders = JSON.parse(d);
                                    } catch (e) {
                                        d += "]";
                                        that.reportHeaders = JSON.parse(d);
                                    }
                                }
                                that.removeDefaultColumn('No')
                                that.removeColumn('No')

                                if (that.getUserInfo.AT >= 1) {
                                    that.removeDefaultColumn('SAWL')
                                    that.removeDefaultColumn('PSMC')
                                    that.removeColumn('SAWL')
                                    that.removeColumn('PSMC')
                                }
                                if (that.getUserInfo.AT >= 2) {
                                    that.removeDefaultColumn('MAWL')
                                    that.removeDefaultColumn('PMAC')
                                    that.removeColumn('MAWL')
                                    that.removeColumn('PMAC')
                                }
                                if (that.getUserInfo.AT >= 3) {
                                    that.removeDefaultColumn('AWL')
                                    that.removeDefaultColumn('PAC')
                                    that.removeColumn('AWL')
                                    that.removeColumn('PAC')
                                }
                            }
                        });
                }
                else {
                    this.getDataApi(`/api/reports/sc/WinLossTicketV2/` + JSON.stringify(that.reportHeaders),
                        function (d, s) {
                            if (s) {

                            }
                        });
                }

                if (this.reportHeaders != null) {
                    if (that.defaultReportHeaders.length != that.reportHeaders.length)
                        that.needResetHeaders = true;
                    else
                        that.needResetHeaders = false;
                }
            },
            reportHeaders1() {
                var that = this;
                if (this.reportHeaders1 == null) {
                    this.getDataApi(`/api/reports/gc/WinLossTicketDetailV2`,
                        function (d, s) {
                            if (s) {
                                if (d == null) {
                                    that.reportHeaders1 = [];
                                    for (var i = 0; i < that.defaultReportHeaders1.length; i++) {
                                        if (that.reportHeaders1.indexOf(that.defaultReportHeaders1[i]) == -1)
                                            that.reportHeaders1.push(that.defaultReportHeaders1[i]);
                                    }
                                }
                                else {
                                    try {
                                        that.reportHeaders1 = JSON.parse(d);
                                    } catch (e) {
                                        d += "]";
                                        that.reportHeaders1 = JSON.parse(d);
                                    }
                                }

                                if (that.hideBrand) {
                                    that.removeDefaultColumn1('Brand')
                                    that.removeColumn1('Brand')
                                }
                                if (that.getUserInfo.AT >= 1) {
                                    that.removeDefaultColumn1('SAWL')
                                    that.removeDefaultColumn1('PSMC')
                                    that.removeColumn1('SAWL')
                                    that.removeColumn1('PSMC')
                                }
                                if (that.getUserInfo.AT >= 2) {
                                    that.removeDefaultColumn1('MAWL')
                                    that.removeDefaultColumn1('PMAC')
                                    that.removeColumn1('MAWL')
                                    that.removeColumn1('PMAC')
                                }
                                if (that.getUserInfo.AT >= 3) {
                                    that.removeDefaultColumn1('AWL')
                                    that.removeDefaultColumn1('PAC')
                                    that.removeColumn1('AWL')
                                    that.removeColumn1('PAC')
                                }
                            }
                        });
                }
                else {
                    this.postDataApi(`/api/reports/psc`, { rn: 'WinLossTicketDetailV2', cl: JSON.stringify(that.reportHeaders1) },
                        function (d, s) {
                            if (s) {

                            }
                        });
                }

                //if (!this.withSportsBook()) {
                //    that.removeDefaultColumn1('ProviderName');
                //    that.removeDefaultColumn1('EventInfo');
                //    for (let i = this.reportHeaders1.length - 1; i >= 0; i--) {
                //        if (this.reportHeaders1[i] === 'ProviderName' || this.reportHeaders1[i] === 'EventInfo') {
                //            this.reportHeaders1.splice(i, 1);
                //        }
                //    }
                //} else
                //{
                //    if (!this.defaultReportHeaders1.includes('ProviderName')) {
                //        this.defaultReportHeaders1.splice(4, 0, 'ProviderName');
                //    }
                //    if (!this.defaultReportHeaders1.includes('EventInfo')) {
                //        this.defaultReportHeaders1.splice(6, 0, 'EventInfo');
                //    }
                //}

                if (this.reportHeaders1 != null) {
                    if (that.defaultReportHeaders1.length != that.reportHeaders1.length)
                        that.needResetHeaders1 = true;
                    else
                        that.needResetHeaders1 = false;

                }
            },
            reportHeaders2() {
                var that = this;
                if (this.reportHeaders2 == null) {
                    this.getDataApi(`/api/reports/gc/WinLossTicketMemberV2`,
                        function (d, s) {
                            if (s) {
                                if (d == null) {
                                    that.reportHeaders2 = [];
                                    for (var i = 0; i < that.defaultReportHeaders2.length; i++) {
                                        if (that.reportHeaders2.indexOf(that.defaultReportHeaders2[i]) == -1)
                                            that.reportHeaders2.push(that.defaultReportHeaders2[i]);
                                    }
                                }
                                else {
                                    try {
                                        that.reportHeaders2 = JSON.parse(d);
                                    } catch (e) {
                                        d += "]";
                                        that.reportHeaders2 = JSON.parse(d);
                                    }
                                }

                                if (that.hideBrand) {
                                    that.removeDefaultColumn2('Brand')
                                    that.removeColumn2('Brand')
                                }
                                if (that.getUserInfo.AT >= 1) {
                                    that.removeDefaultColumn2('SAWL')
                                    that.removeDefaultColumn2('PSMC')
                                    that.removeColumn2('SAWL')
                                    that.removeColumn2('PSMC')
                                }
                                if (that.getUserInfo.AT >= 2) {
                                    that.removeDefaultColumn2('MAWL')
                                    that.removeDefaultColumn2('PMAC')
                                    that.removeColumn2('MAWL')
                                    that.removeColumn2('PMAC')
                                }
                                if (that.getUserInfo.AT >= 3) {
                                    that.removeDefaultColumn2('AWL')
                                    that.removeDefaultColumn2('PAC')
                                    that.removeColumn2('AWL')
                                    that.removeColumn2('PAC')
                                }
                            }
                        });
                }
                else {
                    this.getDataApi(`/api/reports/sc/WinLossTicketMemberV2/` + JSON.stringify(that.reportHeaders2),
                        function (d, s) {
                            if (s) {

                            }
                        });
                }

                if (this.reportHeaders2 != null) {
                    if (that.defaultReportHeaders2.length != that.reportHeaders2.length)
                        that.needResetHeaders2 = true;
                    else
                        that.needResetHeaders2 = false;
                }
            },
            getLanguage() {
                this.getMemberTypeList();
                this.getDropdownList();
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/SideMenu/Reports/WinLossV2.vue